/* eslint-disable react-hooks/rules-of-hooks */
import { React, useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  RightLayoutContainer,
  PageTitleComp,
  TableLayoutData,
} from "../../styledElements";
import {
  Button,
  PageHeader,
  Table,
  Tooltip,
  Progress,
  Tabs,
  Row,
  Col,
  Skeleton,
  Empty,
  Dropdown,
  Menu,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import OrderFilter from "../../../Components/OrderFilter/Filter";
import { DisabledButtonStyle, Styled, StyledTab } from "../../pageStyled";
import EditNewOrderDrawer from "../OrderDetailDrawer/editOrderDetails";
// import ResendApprovalData from "../OrderDetailDrawer/resendApproval";
import ResendApprovalData from "../OrderDetailDrawer/resendApprovalNewDrawer";
import ProductionDetailsDrawer from "../OrderDetailDrawer/productionDetailsDrawer";
import ViewProcessedQuantityDrawer from "../OrderDetailDrawer/viewProcessedQuantityDrawer";
import ViewPendingQuantityDrawer from "../OrderDetailDrawer/PendingQuantityDrawer";
import {
  getAllOrdersList,
  getFilteredOrders,
  searchOrderRecords,
  getSplitGroupOrders,
  deleteOrder,
  getERPOrders,
} from "../../../Services/orderServices";
import moment from "moment";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import SplitOrderDrawer from "../OrderDetailDrawer/splitOrderDrawer";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import ActionDrawer from "../OrderDetailDrawer/ActionDrawer";
import MergeDrawer from "../OrderDetailDrawer/MergeOrderDrawer";
import EmptyState from "../../../Components/EmptyState/emptyState";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import warning from "../../../Assets/Icons/warning.png";
import {
  changeOrderPriority,
  bulkChangeOrderState,
} from "../../../Services/orderServices";
import styled from "styled-components";
import {
  currency_List,
  lengthUnit,
  weightUnit,
} from "../../../Utils/Constant/MeasurementUnitList";
import { getUnitData } from "../../../Services/measurementService";
import CancelQuantityDrawer from "../OrderDetailDrawer/cancelQuantityDrawer";
import MultiDiaEditOrderDrawer from "../OrderDetailDrawer/multiDiaEditOrderDrawer";
import { ModalPopup } from "../../../Components/Modal/modal";
import axios from "axios";
import { toHandlePOName } from "../../../Utils/helper/helper";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices";

const Panes = Tabs.TabPane;
const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);
const CustomButtons = styled.div`
  .ant-ant-space ant-space-horizontal ant-space-align-center {
    align-items: start;
  }
`;

const ScrollbarStyle = styled.div`
  min-height: 100vh;
  height: 100px;
  overflow: scroll;
`;

// const StyledModal = styled(Modal)`
//   min-height: 100vh;
//   height: 100px;
//   overflow: scroll;
// }`

const OrderRecordsData = (props) => {
  const location = useLocation();
  const refetch=useRef(location?.state?.refetch||false);
  const titleRef = useRef(null);
  const tabRef = useRef(null);
  const searchRef = useRef(null);
  const [stickyOffsets, setStickyOffsets] = useState({ title: 58, tabs: 95, search: 140, table: 226 });

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      const baseTop = refetch.current ? 0 : 58;
      const titleHeight = titleRef.current?.offsetHeight || 0;
      const tabsHeight = tabRef.current?.offsetHeight || 0;
      const searchHeight = searchRef.current?.offsetHeight || 0;

      setStickyOffsets({
        title: baseTop,
        tabs: baseTop + titleHeight,
        search: baseTop + titleHeight + tabsHeight,
        table: baseTop + titleHeight + tabsHeight
      });
    });

    if (titleRef.current) observer.observe(titleRef.current);
    if (tabRef.current) observer.observe(tabRef.current);
    if (searchRef.current) observer.observe(searchRef.current);

    return () => observer.disconnect();
  }, [refetch.current]);

  const now = new Date();
  const [NewGradeSideDrawer, setNewGradeSideDrawer] = useState(false);
  const [resendApprovalData, setResendApprovalData] = useState(false);
  const [splitOrderSideDrawer, setSplitOrderSideDrawer] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState();
  const [allOrdersList, setAllOrdersList] = useState([]);
  const [orderRecords, setOrderRecords] = useState();
  const [rendering, setRendering] = useState(true);
  const [totalRecords, setTotalRecords] = useState();
  const [orderCount, setOrderCount] = useState();
  const [poCount, setPOCount] = useState();
  const [soCount, setSOCount] = useState();

  const [currentPage, setCurrentPage] = useState(1);
  const [orderState, setOrderState] = useState(
    location?.state?.defaultOrderState ? location?.state?.defaultOrderState : ""
  );
  const [clearSearch, setClearSearch] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [filterTags, setFilterTags] = useState([]);
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [settingsData, setSettingsData] = useState(
    JSON.parse(localStorage.getItem("setting-data"))
  );
  const [loading, setLoading] = useState(true);
  const [nestedLoading, setNestedLoading] = useState(true);
  // Toasters
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [isRestore, setIsRestore] = useState(false);
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [paginationParams, setPaginationParams] = useState({
    page: 1,
    size: settingsData?.settings?.default_page_size || 10,
  });
  const [sortParams, setSortParams] = useState({
    sort_by: "updated_at",
    sort_type: "descending",
  });
  const [searchValue, setSearchValue] = useState("");
  const [holdOrders, setHoldOrders] = useState(false);
  const [holdOrderDrawer, setHoldOrderDrawer] = useState(false);
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const [orderAction, setOrderAction] = useState("");
  const [allInnerRecords, setAllInnerRecords] = useState({});
  const [mergeSideDrawer, setMergeSideDrawer] = useState(false);
  const [rerenderInnerTable, setRerenderInnerTable] = useState(false);
  const [isStateData, setStateData] = useState(false);
  const [isVisiblePriorityModal, setIsVisiblePriorityModal] = useState(false);
  const [defaultActiveKey, setDefaultActiveKey] = useState(
    location?.state?.defaultActiveKey ? location?.state?.defaultActiveKey : "0"
  );
  const [orderWeightCount, setOrderWeightCount] = useState();
  const [productionDetailsSideDrawer, setProductionDetailsSideDrawer] =
    useState(false);
  const [processedQtyDetailsSideDrawer, setProcessedQtyDetailsSideDrawer] =
    useState(false);
  const [pendingQtyDetailsSideDrawer, setPendingQtyDetailsSideDrawer] =
    useState(false);
  const currentState = useRef(
    location?.state?.defaultOrderState ? location?.state?.defaultOrderState : ""
  );
  const paginationRef = useRef({ page: 1, size: settingsData?.settings?.default_page_size || 10 });
  const [measurementData, setMeasurementData] = useState();
  const [cancelQuantitySideDrawer, setCancelQuantitySideDrawer] =
    useState(false);
  const [poBackKey, setPoBackKey] = useState(
    location?.state?.poBackKey ? location?.state?.poBackKey : ""
  );
  const [isVisibleDeleteModal, setIsVisibleDeleteModal] = useState(false);
  const [isVisibleReleaseModal, setIsVisibleReleaseModal] = useState(false);
  const [orderManagementSettings,setOrderManagementSettings]=useState(JSON.parse(localStorage.getItem("order-management-settings")))
  const [deckleManagementSettings,setDeckleManagementSettings]=useState()
  const [cancelToaster, setCancelToaster] = useState(null);
  const [cancelTosterMsg, setCancelTosterMsg] = useState(null);
  const source = axios.CancelToken.source();
  const [switchFetchOrdersfromERP,setSwitchFetchOrdersfromERP] = useState(false);
    
  
  // const columnsHead = useRef([
  //   {
  //     title: "Po/So.No",
  //     dataIndex: "pono",
  //     width: "11.5%",
  //     fixed: "left",
  //     key: "pono",
  //     align: "left",
  //     sorter: () => {},
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
  //     render: (text, record) => (
  //       <div className="">
  //         <Button
  //           style={{ background: "transparent" }}
  //           className="textTypeBtn textBtnIcon"
  //           onClick={() => handlePo(record)}
  //         >
  //           <div
  //                 style={{
  //                   whiteSpace: "normal",
  //                   lineHeight: "1.2",
  //                   textAlign: "left",
  //                 }}
  //               >
  //                 {`#${record.category === "PO" ? record.pono : record.sono}`
  //                   .match(/.{1,15}/g)
  //                   ?.map((chunk, index) => (
  //                     <span key={index}>
  //                       {chunk}
  //                       <br />
  //                     </span>
  //                   ))}
  //               </div>
  //         </Button>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Group No",
  //   //   dataIndex: "groupno",
  //   //   width: "6.5%",
  //   //   fixed: "left",
  //   //   sorter: () => {},
  //   //   // sortOrder: "null",
  //   // },
  //   {
  //     title: "Order No",
  //     dataIndex: "orderno",
  //     key: "orderno",
  //     width: "8%",
  //     fixed: "left",
  //     sorter: () => {},
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         {record?.previous_state?.old &&
  //         record?.previous_state?.new &&
  //         (record?.previous_state?.old === "review" ||
  //           record?.previous_state?.old === "approved" ||
  //           record?.previous_state?.old === "cancel") &&
  //         record.status === "Pending" ? (
  //           // <Styled >
  //           <TooltipSelector>
  //             <Tooltip
  //               overlayInnerStyle={{
  //                 borderRadius: "8px",
  //                 background: "rgba(32, 31, 30, 0.85)",
  //                 padding: "7px",
  //                 background: "rgba(32, 31, 30, 0.85)",
  //                 fontFamily: "var(--sf-pro-display-m)",
  //                 fontStyle: "normal",
  //                 fontSize: "12px",
  //                 lineHeight: "16px",
  //               }}
  //               placement="bottomRight"
  //               title={
  //                 record?.previous_state?.old === "review"
  //                   ? "This order has been sent for approval again. Changes were requested in this order previously."
  //                   : record?.previous_state?.old === "cancel"
  //                   ? "This order has been sent for approval again. This order was cancelled previously."
  //                   : "This order has been sent for approval again. This order was approved previously."
  //               }
  //               // getPopupContainer={(triggerNode) => triggerNode}
  //               overlayClassName="edit-tooltip"
  //             >
  //               <Button
  //                 style={{ background: "transparent" }}
  //                 className="textTypeBtn textBtnIcon"
  //                 onClick={() => handleViewAction(record)}
  //               >
  //                 {`${text}`}
  //               </Button>
  //             </Tooltip>
  //           </TooltipSelector>
  //         ) : text != "-" ? (
  //           // </Styled>
  //           <Button
  //             style={{ background: "transparent" }}
  //             className="textTypeBtn textBtnIcon"
  //             onClick={() => handleViewAction(record)}
  //           >
  //             {`${text}`}
  //           </Button>
  //         ) : (
  //           <span style={{ textAlign: "center" }}>{text}</span>
  //         )}
  //         {record?.previous_state?.old &&
  //           record?.previous_state?.new &&
  //           (record?.previous_state?.old === "review" ||
  //             record?.previous_state?.old === "approved" ||
  //             record?.previous_state?.old === "cancel") &&
  //           record.status === "Pending" && (
  //             <div>
  //               <span
  //                 style={{
  //                   color: "rgb(234, 101, 91)",
  //                   fontStyle: "italic",
  //                   fontSize: "10px",
  //                 }}
  //               >
  //                 Resent for approval
  //               </span>
  //             </div>
  //           )}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "PO/SO Date",
  //     dataIndex: "poDate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => {
  //         const dateA = new Date(a.category === "SO" ? a.soDate : a.poDate);
  //         const dateB = new Date(b.category === "SO" ? b.soDate : b.poDate);
  //         return dateA - dateB;
  //       },
  //     },
  //     render: (text, record) =>
  //       record.category === "SO" ? record.soDate : record.poDate,
  //   },
  //   { title: "Category", dataIndex: "category",width: "7%",
  //     align: "left", },
  //   {
  //     title: "Customer",
  //     dataIndex: "customer_alias",
  //     width: "7%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.customercode}-${record.customerName}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.customer_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Consignee",
  //     dataIndex: "consignee_alias",
  //     width: "7%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.consignee}-${record.consignee_name}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.consignee_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Prod. Code",
  //   //   dataIndex: "productcode",
  //   //   width: "5.8%",
  //   // },
  //   {
  //     title: (
  //       <div>
  //         Product
  //         <Styled style={{ display: "inline-flex" }}>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <span className="infoIcon"></span>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         <span style={{ fontSize: "10px" }}>{record.productspec} </span>
  //         <br />
  //         <span style={{ textAlign: "center" }}>{record.productcode}</span>
  //       </Styled>
  //     ),
  //     //dataIndex: "productspec",
  //     width: "10.8%",
  //   },
  //   // {
  //   //   title: "Type",
  //   //   dataIndex: "type",
  //   //   width: "5.8%",
  //   // },
  //   {
  //     title: "Size(WxL)",
  //     dataIndex: "size",
  //     width: "8.4%",
  //   },
  //   {
  //     title: "PLY",
  //     dataIndex: "ply",
  //     width: "8.4%",
  //   },
  //   {
  //     title: "Order Quantity",
  //     dataIndex: "quantity",
  //     width: "7.4%",
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         {record.type.toLowerCase() == "sheet" &&
  //         record.quantity_type.toLowerCase() == "reel_sheet" ? (
  //           <>
  //             <span style={{ textAlign: "center" }}>{text}</span>
  //             <br /> <span> {record.no_of_sheets + " Sheets"} </span>
  //           </>
  //         ) : (
  //           `${text} `
  //         )}
  //       </Styled>
  //     ),
  //   },
  //   {
  //     title: "Processed Quantity",
  //     dataIndex: "processQuantity",
  //     width: "10%",
  //     render: (text, record) => {
  //       return (
  //         <div
  //           className="actionBtn"
  //           style={{ marginTop: "14px", justifyContent: "left" }}
  //         >
  //           <Col span={12}>
  //             {parseFloat(text) && record.type ? (
  //               <span dangerouslySetInnerHTML={{ __html: text }} />
  //             ) : parseFloat(text) ? (
  //               `${text} `
  //             ) : (
  //               "-"
  //             )}
  //           </Col>
  //           {parseFloat(text) ? (
  //             <Col span={12}>
  //               <Styled style={{ marginTop: "-8px" }}>
  //                 <Tooltip
  //                   placement="bottomRight"
  //                   title={"View Processed Quantity Details"}
  //                   className="edit-tooltip"
  //                   getPopupContainer={(triggerNode) => triggerNode}
  //                 >
  //                   <Button
  //                     onClick={() => {
  //                       handleViewProcessedQtyAction(record);
  //                     }}
  //                   >
  //                     <Iconmoon
  //                       icon="viewPODetails"
  //                       size={16}
  //                       color="rgb(96, 94, 92)"
  //                     />
  //                   </Button>
  //                 </Tooltip>
  //               </Styled>
  //             </Col>
  //           ) : (
  //             ""
  //           )}
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     title: "Pending Quantity",
  //     dataIndex: "pendingQuantity",
  //     width: "10%",
  //     render: (text, record) => {
  //       return (
  //         <div
  //           className="actionBtn"
  //           style={{ marginTop: "14px", justifyContent: "left" }}
  //         >
  //           <Col span={12}>
  //             {parseFloat(text) && record.type
  //               ? `${text}`
  //               : parseFloat(text)
  //               ? `${text} `
  //               : "-"}
  //           </Col>
  //           {parseFloat(text) ? (
  //             <Col span={12}>
  //               <Styled style={{ marginTop: "-8px" }}>
  //                 <Tooltip
  //                   placement="bottomRight"
  //                   title={"View Pending Quantity Details"}
  //                   className="edit-tooltip"
  //                   getPopupContainer={(triggerNode) => triggerNode}
  //                 >
  //                   <Button
  //                     onClick={() => {
  //                       handleViewPendingQtyAction(record);
  //                     }}
  //                   >
  //                     <Iconmoon
  //                       icon="viewPODetails"
  //                       size={16}
  //                       color="rgb(96, 94, 92)"
  //                     />
  //                   </Button>
  //                 </Tooltip>
  //               </Styled>
  //             </Col>
  //           ) : (
  //             ""
  //           )}
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     title: "Cancelled Quantity",
  //     dataIndex: "cancelledQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text}`
  //         : "-",
  //   },
  //   // {
  //   //   title: "Order Weight",
  //   //   dataIndex: "weight",
  //   //   width: "9%",
  //   //   render: (text, record) =>
  //   //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
  //   // },
  //   // {
  //   //   title: "Planned Weight",
  //   //   dataIndex: "plannedweight",
  //   //   width: "9%",
  //   //   render: (text, record) =>
  //   //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
  //   // },
  //   // {
  //   //   title: "Core ID",
  //   //   dataIndex: "coreid",
  //   //   width: "6%",
  //   //   render: (text, record) =>
  //   //     parseFloat(text.split(" ")[0]) ? record.coreid : "-",
  //   // },
  //   // {
  //   //   title: "Reel OD",
  //   //   dataIndex: "reelod",
  //   //   width: "6%",
  //   //   render: (text, record, index) => (
  //   //     <Styled>
  //   //       <div style={{ display: "flex" }}>
  //   //         {record.id_od_type == "range" && (
  //   //           <div
  //   //             style={{
  //   //               color: "var(--para-text)",
  //   //               display: "flex",
  //   //               width: "100%",
  //   //               alignSelf: "center",
  //   //             }}
  //   //           >
  //   //             {record.minimum_reel_od +
  //   //               "-" +
  //   //               record.maximum_reel_od +
  //   //               " " +
  //   //               lengthUnit[record.units.maximum_reel_od].displayName}
  //   //           </div>
  //   //         )}
  //   //         {record.id_od_type == "constant" && (
  //   //           <div
  //   //             style={{
  //   //               display: "flex",
  //   //               width: "70%",
  //   //               flexDirection: "column",
  //   //               alignSelf: "center",
  //   //             }}
  //   //           >
  //   //             {record.reelod &&
  //   //               record.reelod?.map((item, index) => {
  //   //                 return (
  //   //                   index < 2 && (
  //   //                     <div>
  //   //                       {item}{" "}
  //   //                       {index == 1
  //   //                         ? "...,"
  //   //                         : record.reelod.length > 1
  //   //                         ? ","
  //   //                         : ""}
  //   //                     </div>
  //   //                   )
  //   //                 );
  //   //               })}

  //   //             {record.reelod &&
  //   //               record.reelod?.length >= 2 &&
  //   //               record.reelod?.map((item, index) => {
  //   //                 let tooltipData = "";
  //   //                 for (
  //   //                   let index = 2;
  //   //                   index < record.reelod?.length;
  //   //                   index++
  //   //                 ) {
  //   //                   const data = record.reelod[index];
  //   //                   tooltipData = tooltipData + data + ", ";
  //   //                 }
  //   //                 tooltipData = tooltipData.substring(
  //   //                   0,
  //   //                   tooltipData.length - 1
  //   //                 );
  //   //                 return (
  //   //                   index == 2 && (
  //   //                     <Tooltip title={tooltipData}>
  //   //                       {" "}
  //   //                       <span
  //   //                         style={{
  //   //                           display: "flex",
  //   //                           fontSize: "10px",
  //   //                           fontWeight: "bold",
  //   //                         }}
  //   //                       >
  //   //                         & {record.reelod.length - 2} More
  //   //                       </span>
  //   //                     </Tooltip>
  //   //                   )
  //   //                 );
  //   //               })}
  //   //           </div>
  //   //         )}
  //   //       </div>
  //   //     </Styled>
  //   //   ),
  //   // },
  //   // {
  //   //   title: "Rewinder Reels",
  //   //   dataIndex: "rewinder_reels",
  //   //   width: "9%",
  //   //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
  //   // },
  //   // {
  //   //   title: "QUO.PRICE",
  //   //   dataIndex: "price",
  //   //   width: "8%",
  //   //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
  //   // },
  //   {
  //     title: "Price",
  //     width: "8%",
  //     dataIndex: "netprice",
  //     render: (text, record) => (
  //       <Styled>
  //         {record.category === "SO" ? (
  //           "-"
  //         ) : (
  //           <>
  //             {record.type !== "reel" &&
  //               record.quantity_type !== "reel_sheet" && (
  //                 <span style={{ fontSize: "10px" }}>{record.netprice}</span>
  //               )}
  //             <br />
  //             <span style={{ textAlign: "center" }}>
  //               Rate: {record.dealerPrice}
  //             </span>
  //           </>
  //         )}
  //       </Styled>
  //     ),
  //     // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
  //   },
  //   {
  //     title: "Delivery Date",
  //     dataIndex: "deliverydate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
  //     },
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
  //   },
  //   {
  //     title: "Created Date",
  //     dataIndex: "createddate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
  //     },
  //     // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
  //   },

  //   {
  //     title: "Approver By",
  //     dataIndex: "approvedby",
  //     width: "6.4%",
  //     align: "center",
  //     render: (text, record) =>
  //       record.status === "Open" || record.status === "Pending" ? "-" : text,
  //   },
  //   {
  //     title: "Priority",
  //     dataIndex: "priority",
  //     width: "5%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Button style={{ cursor: "default" }}>
  //           <Iconmoon
  //             icon={record.priority ? "correct" : "wrong"}
  //             size={16}
  //             color={record.priority ? "#3FBD61" : "#a19f9d"}
  //           />
  //         </Button>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "remarks",
  //     width: "6%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={record.remarks}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button style={{ cursor: "default" }}>
  //               <Iconmoon icon="message" size={16} color="#EA655B" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },

  //   {
  //     title: "Status",
  //     dataIndex: "status",
  //     width: "7.6%",
  //     render: (text, record) => (
  //       <div className="statusVal" dataval={record.status}>
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               record.status === "Changes Req"
  //                 ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
  //                 : record.status === "Approved"
  //                 ? "The order has been approved"
  //                 : record.status === "Pending"
  //                 ? "The order is pending for approval"
  //                 : record.status === "Open"
  //                 ? "The order is not sent for approval yet. Go to PO to send orders for approval"
  //                 : record.status === "Rejected"
  //                 ? "The order is rejected by the approver. Click on View Order to see approver remarks"
  //                 : record.status === "On Hold"
  //                 ? "The order has been put on hold by the approver"
  //                 : record.status === "Cancelled"
  //                 ? "The order has been cancelled"
  //                 : record.status === "Merged"
  //                 ? "The quantity in this order is merged with other orders"
  //                 : record.status === "Complete"
  //                 ? "The order has been produced"
  //                 : null
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {" "}
  //             {record.status === "In_production" ? "Approved" : record.status}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Progress",
  //     dataIndex: "progress",
  //     width: "6.8%",
  //     render: (text, record) => {
  //       // if(record.item_type && record.item_type === "order"){
  //       if (
  //         record?.order_type === "sheet" ||
  //         (record?.order_type === "reel" && record?.quantity_type === "weight")
  //       ) {
  //         const totalProd =
  //           ((record?.progressbar_info?.completed?.weight +
  //             record?.progressbar_info?.in_production?.weight) /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         const totalCompleted =
  //           (record?.progressbar_info?.completed?.weight /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? (record?.progressbar_info?.completed?.weight).toFixed(3)
  //                     : 0.0
  //                 } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.completed?.units?.weight
  //                   ].displayName
  //                 )} Weight produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? (record?.progressbar_info?.in_production?.weight).toFixed(
  //                                 3
  //                               )
  //                             : 0.0
  //                         } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.in_production?.units?.weight
  //                   ].displayName
  //                 )} Weight in production
  //                       ${
  //                         record?.progressbar_info?.pending
  //                           ? (record?.progressbar_info?.pending?.weight).toFixed(
  //                               3
  //                             )
  //                           : 0.0
  //                       } ${capitalize(
  //                   weightUnit[record?.progressbar_info?.pending?.units?.weight]
  //                     .displayName
  //                 )} Weight pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={totalProd}
  //                   success={{
  //                     percent: totalCompleted,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       } else {
  //         const production =
  //           ((record?.progressbar_info?.completed?.quantity +
  //             record?.progressbar_info?.in_production?.quantity) /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;
  //         const completed =
  //           (record?.progressbar_info?.completed?.quantity /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;

  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? record?.progressbar_info?.completed?.quantity
  //                     : 0
  //                 } Reels produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? record?.progressbar_info?.in_production
  //                                 ?.quantity
  //                             : 0
  //                         } Reels in production
  //                         ${
  //                           record?.progressbar_info?.pending
  //                             ? record?.progressbar_info?.pending?.quantity
  //                             : 0
  //                         } Reels pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={production}
  //                   success={{
  //                     percent: completed,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       }
  //     },
  //     align: "center",
  //   },
  //   {
  //     title: "Actions",
  //     dataIndex: "action",
  //     width: "11%",
  //     render: (text, record) =>
  //       record.item_type === "order" ? (
  //         <div className="actionBtn">
  //           {![
  //             "Rejected",
  //             "On Hold",
  //             "Complete",
  //             "Cancelled",
  //             "Merged",
  //           ].includes(record?.status) &&
  //           (userDetails?.roles?.order_records.edit_all ||
  //             (userDetails?.roles?.order_records.edit_own &&
  //               userDetails.id == record.user)) &&
  //           ((record?.status == "Approved" &&
  //             record?.completed == 0 &&
  //             record?.in_production == 0) ||
  //             record?.status !== "Approved") ? (
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={"Edit this order"}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Button
  //                   onClick={() => {
  //                     handleEditAction(record);
  //                   }}
  //                 >
  //                   <Iconmoon
  //                     icon="edit"
  //                     size={16}
  //                     //  color="#A19F9D"
  //                     color="#605E5C"
  //                   />
  //                 </Button>
  //               </Tooltip>
  //             </Styled>
  //           ) : (
  //             <div style={{ display: "flex" }}>
  //               <div style={{ width: "38px" }}></div>
  //             </div>
  //           )}
  //           {/* {(userDetails?.roles?.order_records.edit_all || userDetails?.roles?.order_records.edit_own) ? ( */}
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={"View details of this order"}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button
  //                 onClick={() => {
  //                   handleViewAction(record);
  //                 }}
  //               >
  //                 <Iconmoon icon="file-view" size={16} color="#605E5C" />
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //           {/* ) : (
  //         <div style={{ display:"flex", width: "38px" }}></div>
  //         )} */}
  //           {/* {(userDetails?.roles?.order_records.edit_all ||
  //             userDetails?.roles?.order_records.edit_own) &&
  //           record?.status == "Approved" ? (
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={
  //                   record.priority
  //                     ? "Remove Priority"
  //                     : "Prioritize this order"
  //                 }
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Button
  //                   onClick={() => {
  //                     handlePriorityAction(record);
  //                   }}
  //                 >
  //                   <Iconmoon
  //                     // icon={"low-priority"} size={17} color="#A19F9D"
  //                     icon={record.priority ? "low-priority" : "high-priority"}
  //                     size={17}
  //                     color={record.priority ? "#ea4e2c" : "#3fbd61"}
  //                   />
  //                 </Button>
  //               </Tooltip>
  //             </Styled>
  //           ) : (
  //             <div style={{ display: "flex" }}>
  //               <div style={{ width: "38px" }}></div>
  //             </div>
  //           )}
  //           {(userDetails?.roles?.order_records.edit_all ||
  //             (userDetails?.roles?.order_records.edit_own &&
  //               userDetails.id == record.user)) &&
  //           record?.status == "Approved" &&
  //           !record?.priority &&
  //           record?.pending != 0 ? (
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={"Split this order"}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Button
  //                   onClick={() => {
  //                     handleSplitAction(record);
  //                   }}
  //                 >
  //                   <Iconmoon icon={"Mapping"} size={17} color="#605E5C" />
  //                 </Button>
  //               </Tooltip>
  //             </Styled>
  //           ) : (
  //             <div style={{ display: "flex" }}>
  //               <div style={{ width: "38px" }}></div>
  //             </div>
  //           )}
  //           {["On Hold", "Complete", "Approved"].includes(record?.status) ? (
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={"View Production Details"}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Button
  //                   onClick={() => {
  //                     handleViewProdDetailsAction(record);
  //                   }}
  //                 >
  //                   <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
  //                 </Button>
  //               </Tooltip>
  //             </Styled>
  //           ) : (
  //             <div style={{ display: "flex" }}>
  //               <div style={{ width: "38px" }}></div>
  //             </div>
  //           )} */}

  //           {
  //             //   [
  //             //   "Approved",
  //             //   "On Hold",
  //             //   "Complete",
  //             // ].includes(record?.status) ?
  //             <Dropdown
  //               overlay={
  //                 <Menu>
  //                   {(userDetails?.roles?.order_records.edit_all ||
  //                     userDetails?.roles?.order_records.edit_own) &&
  //                     record?.status == "Approved" && (
  //                       <Menu.Item key="1" style={{ padding: "0px 12px" }}>
  //                         <Button
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                           onClick={() => {
  //                             handlePriorityAction(record);
  //                           }}
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "8px" }}>
  //                               <Iconmoon
  //                                 icon={
  //                                   record.priority
  //                                     ? "low-priority"
  //                                     : "high-priority"
  //                                 }
  //                                 size={17}
  //                                 color={
  //                                   record.priority ? "#ea4e2c" : "#3fbd61"
  //                                 }
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "5px", marginLeft: "6px" }}
  //                             >
  //                               {record.priority
  //                                 ? "Remove Priority"
  //                                 : "Prioritize this order"}
  //                             </div>
  //                           </div>
  //                         </Button>
  //                       </Menu.Item>
  //                     )}
  //                   {(userDetails?.roles?.order_records.edit_all ||
  //                     (userDetails?.roles?.order_records.edit_own &&
  //                       userDetails.id == record.user)) &&
  //                     record?.status == "Approved" &&
  //                     !record?.priority &&
  //                     record?.pendingQuantityValue != 0 && (
  //                       <Menu.Item key="2" style={{ padding: "0px 12px" }}>
  //                         <Button
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                           onClick={() => {
  //                             handleSplitAction(record);
  //                           }}
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "8px" }}>
  //                               <Iconmoon
  //                                 icon={"Mapping"}
  //                                 size={17}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "5px", marginLeft: "6px" }}
  //                             >
  //                               Split this order
  //                             </div>
  //                           </div>
  //                         </Button>
  //                       </Menu.Item>
  //                     )}
  //                   {record.status !== "Cancelled" &&
  //                     record?.split_type != "auto" &&
  //                     record.split_group &&
  //                     record.status == "Approved" &&
  //                     !record?.priority &&
  //                     record.completed == 0 &&
  //                     record.in_production == 0 &&
  //                     record.in_process == 0 &&
  //                     record.parent && (
  //                       <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
  //                         <DisabledButtonStyle>
  //                           <Button
  //                             style={{
  //                               border: "none",
  //                               background: "none",
  //                               padding: "0",
  //                               font: "inherit",
  //                               textAlign: "left",
  //                               width: "100%",
  //                               color: "black",
  //                             }}
  //                             className="themeBtn noBg"
  //                             onClick={() =>
  //                               onMergeOrderHandler(record, "menuEle")
  //                             }
  //                           >
  //                             <div
  //                               style={{
  //                                 display: "flex",
  //                                 flexDirection: "row",
  //                               }}
  //                             >
  //                               <div style={{ marginTop: "-1px" }}>
  //                                 <Iconmoon
  //                                   icon={"export"}
  //                                   size={14}
  //                                   color="#605E5C"
  //                                 />{" "}
  //                               </div>
  //                               <div
  //                                 style={{
  //                                   marginTop: "-3px",
  //                                   marginLeft: "11px",
  //                                 }}
  //                               >
  //                                 Merge order
  //                               </div>
  //                             </div>
  //                           </Button>
  //                         </DisabledButtonStyle>
  //                       </Menu.Item>
  //                     )}
  //                   {record.status == "Approved" &&
  //                     record.pendingQuantityValue > 0 && (
  //                       <Menu.Item key="4" style={{ marginBottom: "-10px" }}>
  //                         <Button
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                           onClick={() =>
  //                             handleCancelledQuantityAction(record)
  //                           }
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "0px" }}>
  //                               <Iconmoon
  //                                 icon={"wrong"}
  //                                 size={15}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                             >
  //                               Cancel Quantity
  //                             </div>
  //                           </div>
  //                         </Button>
  //                       </Menu.Item>
  //                     )}
  //                   {["On Hold", "Approved"].includes(record?.status) && (
  //                     <Menu.Item key="5" style={{ padding: "0px 12px" }}>
  //                       <Button
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                         onClick={() => {
  //                           handleViewProdDetailsAction(record);
  //                         }}
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "8px" }}>
  //                             <Iconmoon
  //                               icon={"production"}
  //                               size={17}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "5px", marginLeft: "6px" }}
  //                           >
  //                             View Production Details
  //                           </div>
  //                         </div>
  //                       </Button>
  //                     </Menu.Item>
  //                   )}
  //                   {["On Hold", "Approved"].includes(record?.status) && (
  //                     <Menu.Item key="6" style={{ padding: "0px 12px" }}>
  //                       <Button
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                         onClick={() => {
  //                           handleViewProcessedQtyDetails(record);
  //                         }}
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "8px" }}>
  //                             <Iconmoon
  //                               icon={"viewPODetails"}
  //                               size={17}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "5px", marginLeft: "6px" }}
  //                           >
  //                             View Processed Quantity Details
  //                           </div>
  //                         </div>
  //                       </Button>
  //                     </Menu.Item>
  //                   )}

  //                   {[
  //                     "On Hold",
  //                     "Approved",
  //                     "Open",
  //                     "Changes Req",
  //                     "Pending",
  //                   ].includes(record?.status) && (
  //                     <Menu.Item key="7" style={{ padding: "0px 12px" }}>
  //                       <Button
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                         onClick={() => {
  //                           handleViewPendingQtyDetails(record);
  //                         }}
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "8px" }}>
  //                             <Iconmoon
  //                               icon={"viewPODetails"}
  //                               size={17}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "5px", marginLeft: "6px" }}
  //                           >
  //                             View Pending Quantity Details
  //                           </div>
  //                         </div>
  //                       </Button>
  //                     </Menu.Item>
  //                   )}

  //                   <Menu.Item key="8" style={{ marginBottom: "-10px" }}>
  //                     <DisabledButtonStyle>
  //                       <Button
  //                         onClick={() => {
  //                           onViewPODetailsHandler(record);
  //                         }}
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "0px" }}>
  //                             <Iconmoon
  //                               icon={"viewPODetails"}
  //                               size={17}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                           >
  //                             {record.category === "PO"
  //                               ? "View PO Details"
  //                               : "View SO Details"}
  //                           </div>
  //                         </div>
  //                       </Button>{" "}
  //                     </DisabledButtonStyle>
  //                   </Menu.Item>
  //                   <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
  //                     <DisabledButtonStyle>
  //                       <Button
  //                         onClick={() => {
  //                           onViewChangeHandler(record);
  //                         }}
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "0px" }}>
  //                             <Iconmoon
  //                               icon={"changeHistory"}
  //                               size={19}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "-2px", marginLeft: "5px" }}
  //                           >
  //                             View Change History
  //                           </div>
  //                         </div>
  //                       </Button>{" "}
  //                     </DisabledButtonStyle>
  //                   </Menu.Item>
  //                   {record.status == "Open" ? (
  //                     <Menu.Item key="10" style={{ marginBottom: "-10px" }}>
  //                       <DisabledButtonStyle>
  //                         <Button
  //                           onClick={() => handleDelete(record)}
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "0px" }}>
  //                               <Iconmoon
  //                                 icon={"delete"}
  //                                 size={15}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                             >
  //                               Delete Order
  //                             </div>
  //                           </div>
  //                         </Button>{" "}
  //                       </DisabledButtonStyle>
  //                     </Menu.Item>
  //                   ) : (
  //                     ""
  //                   )}
  //                   {(record.status == "Approved" &&
  //                     record.processQuantity?.split(" ")[0] == 0) ||
  //                   record.status == "On Hold" ||
  //                   record.status == "Pending" ||
  //                   record.status == "Changes Req" ||
  //                   record.status == "Rejected" ? (
  //                     <Menu.Item key="11" style={{ marginBottom: "-10px" }}>
  //                       <DisabledButtonStyle>
  //                         <Button
  //                           onClick={() => handleCancel(record)}
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "0px" }}>
  //                               <Iconmoon
  //                                 icon={"wrong"}
  //                                 size={15}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                             >
  //                               Cancel Order
  //                             </div>
  //                           </div>
  //                         </Button>{" "}
  //                       </DisabledButtonStyle>
  //                     </Menu.Item>
  //                   ) : (
  //                     ""
  //                   )}
  //                   {record.status == "Approved" &&
  //                   record.pendingQuantityValue ? (
  //                     <Menu.Item key="12" style={{ marginBottom: "-10px" }}>
  //                       <DisabledButtonStyle>
  //                         <Button
  //                           onClick={() => handleHold(record)}
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div
  //                               style={{ marginTop: "0px", marginLeft: "2px" }}
  //                             >
  //                               <Iconmoon
  //                                 icon={"hold"}
  //                                 size={14}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "-2px", marginLeft: "9px" }}
  //                             >
  //                               Hold Order
  //                             </div>
  //                           </div>
  //                         </Button>{" "}
  //                       </DisabledButtonStyle>
  //                     </Menu.Item>
  //                   ) : (
  //                     ""
  //                   )}
  //                   {record.status == "On Hold" ? (
  //                     <Menu.Item key="13" style={{ marginBottom: "-10px" }}>
  //                       <DisabledButtonStyle>
  //                         <Button
  //                           onClick={() => handleRelease(record)}
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "0px" }}>
  //                               <Iconmoon
  //                                 icon={"production"}
  //                                 size={17}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                             >
  //                               Release Order
  //                             </div>
  //                           </div>
  //                         </Button>{" "}
  //                       </DisabledButtonStyle>
  //                     </Menu.Item>
  //                   ) : (
  //                     ""
  //                   )}
  //                   <></>
  //                 </Menu>
  //               }
  //               placement="bottom"
  //               arrow
  //             >
  //               <DisabledButtonStyle>
  //                 <Button>
  //                   <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
  //                 </Button>
  //               </DisabledButtonStyle>
  //             </Dropdown>
  //             //   : (
  //             //   <div style={{ display: "flex" }}>
  //             //     <div style={{ width: "38px" }}></div>
  //             //   </div>
  //             // )
  //           }
  //         </div>
  //       ) : (
  //         "-"
  //       ),
  //     align: "center",
  //   },
  // ]);
  // const columnsNonApproverHead = useRef([
  //   {
  //     title: "Po/So.No",
  //     dataIndex: "pono",
  //     width: "8.6%",
  //     fixed: "left",
  //     align: "left",
  //     sorter: () => {},
  //     // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
  //     render: (text, record) => (
  //       <div className="">
  //         <Button
  //           style={{ background: "transparent" }}
  //           className="textTypeBtn textBtnIcon"
  //           onClick={() => handlePo(record)}
  //         >
  //           <div
  //                 style={{
  //                   whiteSpace: "normal",
  //                   lineHeight: "1.2",
  //                   textAlign: "left",
  //                 }}
  //               >
  //                 {`#${record.category === "PO" ? record.pono : record.sono}`
  //                   .match(/.{1,15}/g)
  //                   ?.map((chunk, index) => (
  //                     <span key={index}>
  //                       {chunk}
  //                       <br />
  //                     </span>
  //                   ))}
  //               </div>
  //         </Button>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Group No",
  //   //   dataIndex: "groupno",
  //   //   width: "5.6%",
  //   //   fixed: "left",
  //   //   sorter: () => { },
  //   // },
  //   {
  //     title: "Order No",
  //     dataIndex: "orderno",
  //     key: "orderno",
  //     width: "8%",
  //     fixed: "left",
  //     sorter: () => {},
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         {record?.previous_state?.old &&
  //         record?.previous_state?.new &&
  //         (record?.previous_state?.old === "review" ||
  //           record?.previous_state?.old === "approved" ||
  //           record?.previous_state?.old === "cancel") &&
  //         record.status === "Pending" ? (
  //           // <Styled >
  //           <TooltipSelector>
  //             <Tooltip
  //               overlayInnerStyle={{
  //                 borderRadius: "8px",
  //                 background: "rgba(32, 31, 30, 0.85)",
  //                 padding: "7px",
  //                 background: "rgba(32, 31, 30, 0.85)",
  //                 fontFamily: "var(--sf-pro-display-m)",
  //                 fontStyle: "normal",
  //                 fontSize: "12px",
  //                 lineHeight: "16px",
  //               }}
  //               placement="bottomRight"
  //               title={
  //                 record?.previous_state?.old === "review"
  //                   ? "This order has been sent for approval again. Changes were requested in this order previously."
  //                   : record?.previous_state?.old === "cancel"
  //                   ? "This order has been sent for approval again. This order was cancelled previously."
  //                   : "This order has been sent for approval again. This order was approved previously."
  //               }
  //               // getPopupContainer={(triggerNode) => triggerNode}
  //               overlayClassName="edit-tooltip"
  //             >
  //               <Button
  //                 style={{ background: "transparent" }}
  //                 className="textTypeBtn textBtnIcon"
  //                 onClick={() => handleViewAction(record)}
  //               >
  //                 {`${text}`}
  //               </Button>
  //             </Tooltip>
  //           </TooltipSelector>
  //         ) : text != "-" ? (
  //           // </Styled>
  //           <Button
  //             style={{ background: "transparent" }}
  //             className="textTypeBtn textBtnIcon"
  //             onClick={() => handleViewAction(record)}
  //           >
  //             {`${text}`}
  //           </Button>
  //         ) : (
  //           <span style={{ textAlign: "center" }}>{text}</span>
  //         )}
  //         {record?.previous_state?.old &&
  //           record?.previous_state?.new &&
  //           (record?.previous_state?.old === "review" ||
  //             record?.previous_state?.old === "approved" ||
  //             record?.previous_state?.old === "cancel") &&
  //           record.status === "Pending" && (
  //             <div>
  //               <span
  //                 style={{
  //                   color: "rgb(234, 101, 91)",
  //                   fontStyle: "italic",
  //                   fontSize: "10px",
  //                 }}
  //               >
  //                 Resent for approval
  //               </span>
  //             </div>
  //           )}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "PO/SO Date",
  //     dataIndex: "poDate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => {
  //         const dateA = new Date(a.category === "SO" ? a.soDate : a.poDate);
  //         const dateB = new Date(b.category === "SO" ? b.soDate : b.poDate);
  //         return dateA - dateB;
  //       },
  //     },
  //     render: (text, record) =>
  //       record.category === "SO" ? record.soDate : record.poDate,
  //   },
  //   { title: "Category", dataIndex: "category",width: "7%",
  //     align: "left", },

  //   {
  //     title: "Customer",
  //     dataIndex: "customer_alias",
  //     width: "7%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.customercode}-${record.customerName}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.customer_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Consignee",
  //     dataIndex: "consignee_alias",
  //     width: "7%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.consignee}-${record.consignee_name}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.consignee_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Prod. Code",
  //   //   dataIndex: "productcode",
  //   //   width: "5.8%",
  //   // },
  //   {
  //     title: (
  //       <div>
  //         Product
  //         <Styled style={{ display: "inline-flex" }}>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <span className="infoIcon"></span>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         <span style={{ fontSize: "10px" }}>{record.productspec} </span>
  //         <br />
  //         <span style={{ textAlign: "center" }}>{record.productcode}</span>
  //       </Styled>
  //     ),
  //     //dataIndex: "productspec",
  //     width: "10.8%",
  //   },
  //   // {
  //   //   title: "Type",
  //   //   dataIndex: "type",
  //   //   width: "5.8%",
  //   // },
  //   {
  //     title: "Size(WxL)",
  //     dataIndex: "size",
  //     width: "8.4%",
  //   },
  //   {
  //     title: "PLY",
  //     dataIndex: "ply",
  //     width: "8.4%",
  //   },
  //   {
  //     title: "Order Quantity",
  //     dataIndex: "quantity",
  //     width: "7.4%",
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         {record.type.toLowerCase() == "sheet" &&
  //         record.quantity_type.toLowerCase() == "reel_sheet" ? (
  //           <>
  //             <span style={{ textAlign: "center" }}>{text}</span>
  //             <br /> <span> {record.no_of_sheets + " Sheets"} </span>
  //           </>
  //         ) : (
  //           `${text} `
  //         )}
  //       </Styled>
  //     ),
  //   },
  //   {
  //     title: "Processed Quantity",
  //     dataIndex: "processQuantity",
  //     width: "10%",
  //     render: (text, record) => {
  //       return (
  //         <div
  //           className="actionBtn"
  //           style={{ marginTop: "14px", justifyContent: "left" }}
  //         >
  //           <Col span={12}>
  //             {parseFloat(text) && record.type ? (
  //               <span dangerouslySetInnerHTML={{ __html: text }} />
  //             ) : parseFloat(text) ? (
  //               `${text} `
  //             ) : (
  //               "-"
  //             )}
  //           </Col>
  //           {parseFloat(text) ? (
  //             <Col span={12}>
  //               <Styled style={{ marginTop: "-8px" }}>
  //                 <Tooltip
  //                   placement="bottomRight"
  //                   title={"View Processed Quantity Details"}
  //                   className="edit-tooltip"
  //                   getPopupContainer={(triggerNode) => triggerNode}
  //                 >
  //                   <Button
  //                     onClick={() => {
  //                       handleViewProcessedQtyAction(record);
  //                     }}
  //                   >
  //                     <Iconmoon
  //                       icon="viewPODetails"
  //                       size={16}
  //                       color="rgb(96, 94, 92)"
  //                     />
  //                   </Button>
  //                 </Tooltip>
  //               </Styled>
  //             </Col>
  //           ) : (
  //             ""
  //           )}
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     title: "Pending Quantity",
  //     dataIndex: "pendingQuantity",
  //     width: "10%",
  //     render: (text, record) => {
  //       return (
  //         <div
  //           className="actionBtn"
  //           style={{ marginTop: "14px", justifyContent: "left" }}
  //         >
  //           <Col span={12}>
  //             {parseFloat(text) && record.type
  //               ? `${text}`
  //               : parseFloat(text)
  //               ? `${text} `
  //               : "-"}
  //           </Col>
  //           {parseFloat(text) ? (
  //             <Col span={12}>
  //               <Styled style={{ marginTop: "-8px" }}>
  //                 <Tooltip
  //                   placement="bottomRight"
  //                   title={"View Pending Quantity Details"}
  //                   className="edit-tooltip"
  //                   getPopupContainer={(triggerNode) => triggerNode}
  //                 >
  //                   <Button
  //                     onClick={() => {
  //                       handleViewPendingQtyAction(record);
  //                     }}
  //                   >
  //                     <Iconmoon
  //                       icon="viewPODetails"
  //                       size={16}
  //                       color="rgb(96, 94, 92)"
  //                     />
  //                   </Button>
  //                 </Tooltip>
  //               </Styled>
  //             </Col>
  //           ) : (
  //             ""
  //           )}
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     title: "Cancelled Quantity",
  //     dataIndex: "cancelledQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text}`
  //         : "-",
  //   },
  //   // {
  //   //   title: "Order Weight",
  //   //   dataIndex: "weight",
  //   //   width: "9%",
  //   //   render: (text, record) =>
  //   //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
  //   // },
  //   // {
  //   //   title: "Planned Weight",
  //   //   dataIndex: "plannedweight",
  //   //   width: "9%",
  //   //   render: (text, record) =>
  //   //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
  //   // },
  //   // {
  //   //   title: "Core ID",
  //   //   dataIndex: "coreid",
  //   //   width: "6%",
  //   //   render: (text, record) =>
  //   //     parseFloat(text.split(" ")[0]) ? record.coreid : "-",
  //   // },
  //   // {
  //   //   title: "Reel OD",
  //   //   dataIndex: "reelod",
  //   //   width: "6%",
  //   //   render: (text, record, index) => (
  //   //     <Styled>
  //   //       <div style={{ display: "flex" }}>
  //   //         {record.id_od_type == "range" && (
  //   //           <div
  //   //             style={{
  //   //               color: "var(--para-text)",
  //   //               display: "flex",
  //   //               width: "100%",
  //   //               alignSelf: "center",
  //   //             }}
  //   //           >
  //   //             {record.minimum_reel_od +
  //   //               "-" +
  //   //               record.maximum_reel_od +
  //   //               " " +
  //   //               lengthUnit[record.units.maximum_reel_od].displayName}
  //   //           </div>
  //   //         )}
  //   //         {record.id_od_type == "constant" && (
  //   //           <div
  //   //             style={{
  //   //               display: "flex",
  //   //               width: "70%",
  //   //               flexDirection: "column",
  //   //               alignSelf: "center",
  //   //             }}
  //   //           >
  //   //             {record.reelod &&
  //   //               record.reelod?.map((item, index) => {
  //   //                 return (
  //   //                   index < 2 && (
  //   //                     <div>
  //   //                       {item}{" "}
  //   //                       {index == 1
  //   //                         ? "...,"
  //   //                         : record.reelod.length > 1
  //   //                         ? ","
  //   //                         : ""}
  //   //                     </div>
  //   //                   )
  //   //                 );
  //   //               })}

  //   //             {record.reelod &&
  //   //               record.reelod?.length >= 2 &&
  //   //               record.reelod?.map((item, index) => {
  //   //                 let tooltipData = "";
  //   //                 for (
  //   //                   let index = 2;
  //   //                   index < record.reelod?.length;
  //   //                   index++
  //   //                 ) {
  //   //                   const data = record.reelod[index];
  //   //                   tooltipData = tooltipData + data + ", ";
  //   //                 }
  //   //                 tooltipData = tooltipData.substring(
  //   //                   0,
  //   //                   tooltipData.length - 1
  //   //                 );
  //   //                 return (
  //   //                   index == 2 && (
  //   //                     <Tooltip title={tooltipData}>
  //   //                       {" "}
  //   //                       <span
  //   //                         style={{
  //   //                           display: "flex",
  //   //                           fontSize: "10px",
  //   //                           fontWeight: "bold",
  //   //                         }}
  //   //                       >
  //   //                         & {record.reelod.length - 2} More
  //   //                       </span>
  //   //                     </Tooltip>
  //   //                   )
  //   //                 );
  //   //               })}
  //   //           </div>
  //   //         )}
  //   //       </div>
  //   //     </Styled>
  //   //   ),
  //   // },
  //   // {
  //   //   title: "Rewinder Reels",
  //   //   dataIndex: "rewinder_reels",
  //   //   width: "9%",
  //   //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
  //   // },
  //   // {
  //   //   title: "QUO.PRICE",
  //   //   dataIndex: "price",
  //   //   width: "8%",
  //   //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
  //   // },
  //   {
  //     title: "Price",
  //     width: "8%",
  //     dataIndex: "netprice",
  //     render: (text, record) => (
  //       <Styled>
  //         {record.category === "SO" ? (
  //           "-"
  //         ) : (
  //           <>
  //             {record.type !== "reel" &&
  //               record.quantity_type !== "reel_sheet" && (
  //                 <span style={{ fontSize: "10px" }}>{record.netprice}</span>
  //               )}
  //             <br />
  //             <span style={{ textAlign: "center" }}>
  //               Rate: {record.dealerPrice}
  //             </span>
  //           </>
  //         )}
  //       </Styled>
  //     ),
  //     // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
  //   },
  //   {
  //     title: "Delivery Date",
  //     dataIndex: "deliverydate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
  //     },
  //     // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
  //   },
  //   {
  //     title: "Created Date",
  //     dataIndex: "createddate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
  //     },
  //     // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
  //   },
  //   {
  //     title: "Approver By",
  //     dataIndex: "approvedby",
  //     width: "6.4%",
  //     align: "center",
  //     render: (text, record) =>
  //       record.status === "Open" || record.status === "Pending" ? "-" : text,
  //   },
  //   {
  //     title: "Priority",
  //     dataIndex: "priority",
  //     width: "5%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Button style={{ cursor: "default" }}>
  //           <Iconmoon
  //             icon={record.priority ? "correct" : "wrong"}
  //             size={16}
  //             color={record.priority ? "#3FBD61" : "#a19f9d"}
  //           />
  //         </Button>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "remarks",
  //     width: "6%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={record.remarks}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button style={{ cursor: "default" }}>
  //               <Iconmoon icon="message" size={16} color="#EA655B" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Status",
  //     dataIndex: "status",
  //     width: "7.6%",
  //     render: (text, record) => (
  //       <div className="statusVal" dataval={record.status}>
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               record.status === "Changes Req"
  //                 ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
  //                 : record.status === "Approved"
  //                 ? "The order has been approved"
  //                 : record.status === "Pending"
  //                 ? "The order is pending for approval"
  //                 : record.status === "Open"
  //                 ? "The order is not sent for approval yet. Go to PO to send orders for approval"
  //                 : record.status === "Rejected"
  //                 ? "The order is rejected by the approver. Click on View Order to see approver remarks"
  //                 : record.status === "On Hold"
  //                 ? "The order has been put on hold by the approver"
  //                 : record.status === "Cancelled"
  //                 ? "The order has been cancelled"
  //                 : record.status === "Merged"
  //                 ? "The quantity in this order is merged with other orders"
  //                 : record.status === "Complete"
  //                 ? "The order has been produced"
  //                 : null
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {" "}
  //             {record.status === "In_production" ? "Approved" : record.status}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Progress",
  //     dataIndex: "progress",
  //     width: "6.8%",
  //     render: (text, record) => {
  //       // if(record.item_type && record.item_type === "order"){
  //       if (
  //         record?.order_type === "sheet" ||
  //         (record?.order_type === "reel" && record?.quantity_type === "weight")
  //       ) {
  //         const totalProd =
  //           ((record?.progressbar_info?.completed?.weight +
  //             record?.progressbar_info?.in_production?.weight) /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         const totalCompleted =
  //           (record?.progressbar_info?.completed?.weight /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? (record?.progressbar_info?.completed?.weight).toFixed(3)
  //                     : 0.0
  //                 } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.completed?.units?.weight
  //                   ].displayName
  //                 )} Weight produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? (record?.progressbar_info?.in_production?.weight).toFixed(
  //                                 3
  //                               )
  //                             : 0.0
  //                         } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.in_production?.units?.weight
  //                   ].displayName
  //                 )} Weight in production
  //                       ${
  //                         record?.progressbar_info?.pending
  //                           ? (record?.progressbar_info?.pending?.weight).toFixed(
  //                               3
  //                             )
  //                           : 0.0
  //                       } ${capitalize(
  //                   weightUnit[record?.progressbar_info?.pending?.units?.weight]
  //                     .displayName
  //                 )} Weight pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={totalProd}
  //                   success={{
  //                     percent: totalCompleted,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       } else {
  //         const production =
  //           ((record?.progressbar_info?.completed?.quantity +
  //             record?.progressbar_info?.in_production?.quantity) /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;
  //         const completed =
  //           (record?.progressbar_info?.completed?.quantity /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;

  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? record?.progressbar_info?.completed?.quantity
  //                     : 0
  //                 } Reels produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? record?.progressbar_info?.in_production
  //                                 ?.quantity
  //                             : 0
  //                         } Reels in production
  //                         ${
  //                           record?.progressbar_info?.pending
  //                             ? record?.progressbar_info?.pending?.quantity
  //                             : 0
  //                         } Reels pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={production}
  //                   success={{
  //                     percent: completed,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       }
  //     },
  //     align: "center",
  //   },
  //   {
  //     title: "Actions",
  //     dataIndex: "action",
  //     width: "9%",
  //     render: (text, record) =>
  //       record.item_type === "order" ? (
  //         <div className="actionBtn">
  //           {!["Approved", "Rejected", "On Hold"].includes(record?.status) &&
  //             (userDetails?.roles?.order_records.edit_all ||
  //               (userDetails?.roles?.order_records.edit_own &&
  //                 userDetails.id == record.user)) && (
  //               <Styled>
  //                 <Tooltip
  //                   placement="bottomRight"
  //                   title={"Edit this order"}
  //                   className="edit-tooltip"
  //                   getPopupContainer={(triggerNode) => triggerNode}
  //                 >
  //                   <Button
  //                     onClick={() => {
  //                       handleEditAction(record);
  //                     }}
  //                   >
  //                     <Iconmoon icon="edit" size={16} color="#605E5C" />
  //                   </Button>
  //                 </Tooltip>
  //               </Styled>
  //             )}
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={"View details of this order"}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button
  //                 onClick={() => {
  //                   handleViewAction(record);
  //                 }}
  //               >
  //                 <Iconmoon icon="file-view" size={16} color="#605E5C" />
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //           {/* {((userDetails?.roles?.order_records.edit_all) || (userDetails?.roles?.order_records.edit_own)) ? (
  //         <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={record.priority ? "Remove priority" : "Prioritize this order"}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button
  //                 onClick={() => {
  //                   handlePriorityAction(record);
  //                 }}
  //               >
  //                 <Iconmoon
  //                 // icon={"edit"} size={17} color="#A19F9D" />
  //                 icon={record.priority ? "low-priority" : "high-priority"}
  //                 size={16}
  //                 color={record.priority ? "#ea4e2c" : "#3fbd61"}/>
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //         ) : (
  //           <div style={{ width: "38px" }}></div>
  //         )} */}
  //           {/* {(((userDetails?.roles?.order_records.edit_all) || ((userDetails?.roles?.order_records.edit_own) && (userDetails.id == record.user))) && ((record?.status == "Approved") && (!record?.priority) && (record?.pending != 0))) ? (
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={"Split this order"}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button
  //                 onClick={() => {
  //                   handleSplitAction(record);
  //                 }}
  //               >
  //                 <Iconmoon icon={"Mapping"} size={16} color="#605E5C" />
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //         ) : (
  //           <div style={{ width: "38px" }}></div>
  //         )}           */}
  //           {
  //             //   [
  //             //   "Approved",
  //             //   "On Hold",
  //             //   "Complete",
  //             // ].includes(record?.status) ?
  //             <Dropdown
  //               overlay={
  //                 <Menu>
  //                   {(userDetails?.roles?.order_records.edit_all ||
  //                     userDetails?.roles?.order_records.edit_own) &&
  //                     record?.status == "Approved" && (
  //                       <Menu.Item key="1" style={{ padding: "0px 12px" }}>
  //                         <Button
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                           onClick={() => {
  //                             handlePriorityAction(record);
  //                           }}
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "8px" }}>
  //                               <Iconmoon
  //                                 icon={
  //                                   record.priority
  //                                     ? "low-priority"
  //                                     : "high-priority"
  //                                 }
  //                                 size={17}
  //                                 color={
  //                                   record.priority ? "#ea4e2c" : "#3fbd61"
  //                                 }
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "5px", marginLeft: "6px" }}
  //                             >
  //                               {record.priority
  //                                 ? "Remove Priority"
  //                                 : "Prioritize this order"}
  //                             </div>
  //                           </div>
  //                         </Button>
  //                       </Menu.Item>
  //                     )}
  //                   {(userDetails?.roles?.order_records.edit_all ||
  //                     (userDetails?.roles?.order_records.edit_own &&
  //                       userDetails.id == record.user)) &&
  //                     record?.status == "Approved" &&
  //                     !record?.priority &&
  //                     record?.pendingQuantityValue != 0 && (
  //                       <Menu.Item key="2" style={{ padding: "0px 12px" }}>
  //                         <Button
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                           onClick={() => {
  //                             handleSplitAction(record);
  //                           }}
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "8px" }}>
  //                               <Iconmoon
  //                                 icon={"Mapping"}
  //                                 size={17}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "5px", marginLeft: "6px" }}
  //                             >
  //                               Split this order
  //                             </div>
  //                           </div>
  //                         </Button>
  //                       </Menu.Item>
  //                     )}
  //                   {record.status !== "Cancelled" &&
  //                     record?.split_type != "auto" &&
  //                     record.split_group &&
  //                     record.status == "Approved" &&
  //                     !record?.priority &&
  //                     record.completed == 0 &&
  //                     record.in_production == 0 &&
  //                     record.in_process == 0 &&
  //                     record.parent && (
  //                       <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
  //                         <DisabledButtonStyle>
  //                           <Button
  //                             style={{
  //                               border: "none",
  //                               background: "none",
  //                               padding: "0",
  //                               font: "inherit",
  //                               textAlign: "left",
  //                               width: "100%",
  //                               color: "black",
  //                             }}
  //                             className="themeBtn noBg"
  //                             onClick={() =>
  //                               onMergeOrderHandler(record, "menuEle")
  //                             }
  //                           >
  //                             <div
  //                               style={{
  //                                 display: "flex",
  //                                 flexDirection: "row",
  //                               }}
  //                             >
  //                               <div style={{ marginTop: "-1px" }}>
  //                                 <Iconmoon
  //                                   icon={"export"}
  //                                   size={14}
  //                                   color="#605E5C"
  //                                 />{" "}
  //                               </div>
  //                               <div
  //                                 style={{
  //                                   marginTop: "-3px",
  //                                   marginLeft: "11px",
  //                                 }}
  //                               >
  //                                 Merge order
  //                               </div>
  //                             </div>
  //                           </Button>
  //                         </DisabledButtonStyle>
  //                       </Menu.Item>
  //                     )}
  //                   {record.status == "Approved" &&
  //                     record.pendingQuantityValue > 0 && (
  //                       <Menu.Item key="4" style={{ marginBottom: "-10px" }}>
  //                         <Button
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                           onClick={() =>
  //                             handleCancelledQuantityAction(record)
  //                           }
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "0px" }}>
  //                               <Iconmoon
  //                                 icon={"wrong"}
  //                                 size={15}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                             >
  //                               Cancel Quantity
  //                             </div>
  //                           </div>
  //                         </Button>
  //                       </Menu.Item>
  //                     )}
  //                   {["On Hold", "Approved"].includes(record?.status) && (
  //                     <Menu.Item key="5" style={{ padding: "0px 12px" }}>
  //                       <Button
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                         onClick={() => {
  //                           handleViewProdDetailsAction(record);
  //                         }}
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "8px" }}>
  //                             <Iconmoon
  //                               icon={"production"}
  //                               size={17}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "5px", marginLeft: "6px" }}
  //                           >
  //                             View Production Details
  //                           </div>
  //                         </div>
  //                       </Button>
  //                     </Menu.Item>
  //                   )}
  //                   {["On Hold", "Approved"].includes(record?.status) ? (
  //                     <Menu.Item key="6" style={{ padding: "0px 12px" }}>
  //                       <Button
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                         onClick={() => {
  //                           handleViewProcessedQtyDetails(record);
  //                         }}
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "8px" }}>
  //                             <Iconmoon
  //                               icon={"viewPODetails"}
  //                               size={17}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "5px", marginLeft: "6px" }}
  //                           >
  //                             View Processed Quantity Details
  //                           </div>
  //                         </div>
  //                       </Button>
  //                     </Menu.Item>
  //                   ) : (
  //                     ""
  //                   )}

  //                   {[
  //                     "On Hold",
  //                     "Approved",
  //                     "Open",
  //                     "Changes Req",
  //                     "Pending",
  //                   ].includes(record?.status) ? (
  //                     <Menu.Item key="7" style={{ padding: "0px 12px" }}>
  //                       <Button
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                         onClick={() => {
  //                           handleViewPendingQtyDetails(record);
  //                         }}
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "8px" }}>
  //                             <Iconmoon
  //                               icon={"viewPODetails"}
  //                               size={17}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "5px", marginLeft: "6px" }}
  //                           >
  //                             View Pending Quantity Details
  //                           </div>
  //                         </div>
  //                       </Button>
  //                     </Menu.Item>
  //                   ) : (
  //                     ""
  //                   )}

  //                   <Menu.Item key="8" style={{ marginBottom: "-10px" }}>
  //                     <DisabledButtonStyle>
  //                       <Button
  //                         onClick={() => {
  //                           onViewPODetailsHandler(record);
  //                         }}
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "0px" }}>
  //                             <Iconmoon
  //                               icon={"viewPODetails"}
  //                               size={17}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                           >
  //                             {record.category === "PO"
  //                               ? "View PO Details"
  //                               : "View SO Details"}
  //                           </div>
  //                         </div>
  //                       </Button>{" "}
  //                     </DisabledButtonStyle>
  //                   </Menu.Item>
  //                   <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
  //                     <DisabledButtonStyle>
  //                       <Button
  //                         onClick={() => {
  //                           onViewChangeHandler(record);
  //                         }}
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "0px" }}>
  //                             <Iconmoon
  //                               icon={"changeHistory"}
  //                               size={19}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "-2px", marginLeft: "5px" }}
  //                           >
  //                             View Change History
  //                           </div>
  //                         </div>
  //                       </Button>{" "}
  //                     </DisabledButtonStyle>
  //                   </Menu.Item>
  //                   {record.status == "Open" ? (
  //                     <Menu.Item key="10" style={{ marginBottom: "-10px" }}>
  //                       <DisabledButtonStyle>
  //                         <Button
  //                           onClick={() => handleDelete(record)}
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "0px" }}>
  //                               <Iconmoon
  //                                 icon={"delete"}
  //                                 size={15}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                             >
  //                               Delete Order
  //                             </div>
  //                           </div>
  //                         </Button>{" "}
  //                       </DisabledButtonStyle>
  //                     </Menu.Item>
  //                   ) : (
  //                     ""
  //                   )}
  //                   {(record.status == "Approved" &&
  //                     record.processQuantity?.split(" ")[0] == 0) ||
  //                   record.status == "On Hold" ||
  //                   record.status == "Pending" ||
  //                   record.status == "Changes Req" ||
  //                   record.status == "Rejected" ? (
  //                     <Menu.Item key="11" style={{ marginBottom: "-10px" }}>
  //                       <DisabledButtonStyle>
  //                         <Button
  //                           onClick={() => handleCancel(record)}
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "0px" }}>
  //                               <Iconmoon
  //                                 icon={"wrong"}
  //                                 size={15}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                             >
  //                               Cancel Order
  //                             </div>
  //                           </div>
  //                         </Button>{" "}
  //                       </DisabledButtonStyle>
  //                     </Menu.Item>
  //                   ) : (
  //                     ""
  //                   )}
  //                   {record.status == "Approved" &&
  //                   record.pendingQuantityValue ? (
  //                     <Menu.Item key="12" style={{ marginBottom: "-10px" }}>
  //                       <DisabledButtonStyle>
  //                         <Button
  //                           onClick={() => handleHold(record)}
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div
  //                               style={{ marginTop: "0px", marginLeft: "2px" }}
  //                             >
  //                               <Iconmoon
  //                                 icon={"hold"}
  //                                 size={14}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "-2px", marginLeft: "9px" }}
  //                             >
  //                               Hold Order
  //                             </div>
  //                           </div>
  //                         </Button>{" "}
  //                       </DisabledButtonStyle>
  //                     </Menu.Item>
  //                   ) : (
  //                     ""
  //                   )}
  //                   {record.status == "On Hold" ? (
  //                     <Menu.Item key="13" style={{ marginBottom: "-10px" }}>
  //                       <DisabledButtonStyle>
  //                         <Button
  //                           onClick={() => handleRelease(record)}
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "0px" }}>
  //                               <Iconmoon
  //                                 icon={"production"}
  //                                 size={17}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                             >
  //                               Release Order
  //                             </div>
  //                           </div>
  //                         </Button>{" "}
  //                       </DisabledButtonStyle>
  //                     </Menu.Item>
  //                   ) : (
  //                     ""
  //                   )}
  //                 </Menu>
  //               }
  //               placement="bottom"
  //               arrow
  //             >
  //               <DisabledButtonStyle>
  //                 <Button>
  //                   <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
  //                 </Button>
  //               </DisabledButtonStyle>
  //             </Dropdown>
  //             //   : (
  //             //   <div style={{ display: "flex" }}>
  //             //     <div style={{ width: "38px" }}></div>
  //             //   </div>
  //             // )
  //           }
  //         </div>
  //       ) : (
  //         "-"
  //       ),
  //     align: "center",
  //   },
  // ]);
  // const columnsNonPriorityHead = useRef([
  //   {
  //     title: "Po/So.No",
  //     dataIndex: "pono",
  //     width: "8.6%",
  //     fixed: "left",
  //     align: "left",
  //     sorter: () => {},
  //     // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
  //     render: (text, record) => (
  //       <div className="">
  //         <Button
  //           style={{ background: "transparent" }}
  //           className="textTypeBtn textBtnIcon"
  //           onClick={() => handlePo(record)}
  //         >
  //           <div
  //                 style={{
  //                   whiteSpace: "normal",
  //                   lineHeight: "1.2",
  //                   textAlign: "left",
  //                 }}
  //               >
  //                 {`#${record.category === "PO" ? record.pono : record.sono}`
  //                   .match(/.{1,15}/g)
  //                   ?.map((chunk, index) => (
  //                     <span key={index}>
  //                       {chunk}
  //                       <br />
  //                     </span>
  //                   ))}
  //               </div>
  //         </Button>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Group No",
  //   //   dataIndex: "groupno",
  //   //   width: "5.6%",
  //   //   fixed: "left",
  //   //   sorter: () => { },
  //   // },
  //   {
  //     title: "Order No",
  //     dataIndex: "orderno",
  //     key: "orderno",
  //     width: "8%",
  //     fixed: "left",
  //     sorter: () => {},
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         {text != "-" ? (
  //           // </Styled>
  //           <Button
  //             style={{ background: "transparent" }}
  //             className="textTypeBtn textBtnIcon"
  //             onClick={() => handleViewAction(record)}
  //           >
  //             {`${text}`}
  //           </Button>
  //         ) : (
  //           <span style={{ textAlign: "center" }}>{text}</span>
  //         )}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "PO/SO Date",
  //     dataIndex: "poDate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => {
  //         const dateA = new Date(a.category === "SO" ? a.soDate : a.poDate);
  //         const dateB = new Date(b.category === "SO" ? b.soDate : b.poDate);
  //         return dateA - dateB;
  //       },
  //     },
  //     render: (text, record) =>
  //       record.category === "SO" ? record.soDate : record.poDate,
  //   },
  //   { title: "Category", dataIndex: "category",width: "7%",
  //     align: "left", },

  //   {
  //     title: "Customer",
  //     dataIndex: "customer_alias",
  //     width: "7%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.customercode}-${record.customerName}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.customer_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Consignee",
  //     dataIndex: "consignee_alias",
  //     width: "7%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.consignee}-${record.consignee_name}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.consignee_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Prod. Code",
  //   //   dataIndex: "productcode",
  //   //   width: "5.8%",
  //   // },
  //   {
  //     title: (
  //       <div>
  //         Product
  //         <Styled style={{ display: "inline-flex" }}>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <span className="infoIcon"></span>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         <span style={{ fontSize: "10px" }}>{record.productspec} </span>
  //         <br />
  //         <span style={{ textAlign: "center" }}>{record.productcode}</span>
  //       </Styled>
  //     ),
  //     //dataIndex: "productspec",
  //     width: "10.8%",
  //   },
  //   // {
  //   //   title: "Type",
  //   //   dataIndex: "type",
  //   //   width: "5.8%",
  //   // },
  //   {
  //     title: "Size(WxL)",
  //     dataIndex: "size",
  //     width: "8.4%",
  //   },
  //   {
  //     title: "PLY",
  //     dataIndex: "ply",
  //     width: "8.4%",
  //   },
  //   {
  //     title: "Order Quantity",
  //     dataIndex: "quantity",
  //     width: "7.4%",
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         {record.type.toLowerCase() == "sheet" &&
  //         record.quantity_type.toLowerCase() == "reel_sheet" ? (
  //           <>
  //             <span style={{ textAlign: "center" }}>{text}</span>
  //             <br /> <span> {record.no_of_sheets + " Sheets"} </span>
  //           </>
  //         ) : (
  //           `${text} `
  //         )}
  //       </Styled>
  //     ),
  //   },
  //   {
  //     title: "Processed Quantity",
  //     dataIndex: "processQuantity",
  //     width: "10%",
  //     render: (text, record) => {
  //       return (
  //         <div
  //           className="actionBtn"
  //           style={{ marginTop: "14px", justifyContent: "left" }}
  //         >
  //           <Col span={12}>
  //             {parseFloat(text) && record.type ? (
  //               <span dangerouslySetInnerHTML={{ __html: text }} />
  //             ) : parseFloat(text) ? (
  //               `${text} `
  //             ) : (
  //               "-"
  //             )}
  //           </Col>
  //           {parseFloat(text) ? (
  //             <Col span={12}>
  //               <Styled style={{ marginTop: "-8px" }}>
  //                 <Tooltip
  //                   placement="bottomRight"
  //                   title={"View Processed Quantity Details"}
  //                   className="edit-tooltip"
  //                   getPopupContainer={(triggerNode) => triggerNode}
  //                 >
  //                   <Button
  //                     onClick={() => {
  //                       handleViewProcessedQtyAction(record);
  //                     }}
  //                   >
  //                     <Iconmoon
  //                       icon="viewPODetails"
  //                       size={16}
  //                       color="rgb(96, 94, 92)"
  //                     />
  //                   </Button>
  //                 </Tooltip>
  //               </Styled>
  //             </Col>
  //           ) : (
  //             ""
  //           )}
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     title: "Pending Quantity",
  //     dataIndex: "pendingQuantity",
  //     width: "10%",
  //     render: (text, record) => {
  //       return (
  //         <div
  //           className="actionBtn"
  //           style={{ marginTop: "14px", justifyContent: "left" }}
  //         >
  //           <Col span={12}>
  //             {parseFloat(text) && record.type
  //               ? `${text}`
  //               : parseFloat(text)
  //               ? `${text} `
  //               : "-"}
  //           </Col>
  //           {parseFloat(text) ? (
  //             <Col span={12}>
  //               <Styled style={{ marginTop: "-8px" }}>
  //                 <Tooltip
  //                   placement="bottomRight"
  //                   title={"View Pending Quantity Details"}
  //                   className="edit-tooltip"
  //                   getPopupContainer={(triggerNode) => triggerNode}
  //                 >
  //                   <Button
  //                     onClick={() => {
  //                       handleViewPendingQtyAction(record);
  //                     }}
  //                   >
  //                     <Iconmoon
  //                       icon="viewPODetails"
  //                       size={16}
  //                       color="rgb(96, 94, 92)"
  //                     />
  //                   </Button>
  //                 </Tooltip>
  //               </Styled>
  //             </Col>
  //           ) : (
  //             ""
  //           )}
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     title: "Cancelled Quantity",
  //     dataIndex: "cancelledQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text}`
  //         : "-",
  //   },
  //   // {
  //   //   title: "Order Weight",
  //   //   dataIndex: "weight",
  //   //   width: "9%",
  //   //   render: (text, record) =>
  //   //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
  //   // },
  //   // {
  //   //   title: "Planned Weight",
  //   //   dataIndex: "plannedweight",
  //   //   width: "9%",
  //   //   render: (text, record) =>
  //   //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
  //   // },
  //   //   {
  //   //     title: "Core ID",
  //   //     dataIndex: "coreid",
  //   //     width: "6%",
  //   //     render: (text, record) =>
  //   //       parseFloat(text.split(" ")[0]) ? record.coreid : "-",
  //   //   },
  //   //   {
  //   //     title: "Reel OD",
  //   //     dataIndex: "reelod",
  //   //     width: "6%",
  //   //     render: (text, record, index) => (
  //   //       <Styled>
  //   //         <div style={{ display: "flex" }}>
  //   //           {record.id_od_type == "range" && (
  //   //             <div
  //   //               style={{
  //   //                 color: "var(--para-text)",
  //   //                 display: "flex",
  //   //                 width: "100%",
  //   //                 alignSelf: "center",
  //   //               }}
  //   //             >
  //   //               {record.minimum_reel_od +
  //   //                 "-" +
  //   //                 record.maximum_reel_od +
  //   //                 " " +
  //   //                 lengthUnit[record.units.maximum_reel_od].displayName}
  //   //             </div>
  //   //           )}
  //   //           {record.id_od_type == "constant" && (
  //   //             <div
  //   //               style={{
  //   //                 display: "flex",
  //   //                 width: "70%",
  //   //                 flexDirection: "column",
  //   //                 alignSelf: "center",
  //   //               }}
  //   //             >
  //   //               {record.reelod &&
  //   //                 record.reelod?.map((item, index) => {
  //   //                   return (
  //   //                     index < 2 && (
  //   //                       <div>
  //   //                         {item}{" "}
  //   //                         {index == 1
  //   //                           ? "...,"
  //   //                           : record.reelod.length > 1
  //   //                           ? ","
  //   //                           : ""}
  //   //                       </div>
  //   //                     )
  //   //                   );
  //   //                 })}

  //   //               {record.reelod &&
  //   //                 record.reelod?.length >= 2 &&
  //   //                 record.reelod?.map((item, index) => {
  //   //                   let tooltipData = "";
  //   //                   for (
  //   //                     let index = 2;
  //   //                     index < record.reelod?.length;
  //   //                     index++
  //   //                   ) {
  //   //                     const data = record.reelod[index];
  //   //                     tooltipData = tooltipData + data + ", ";
  //   //                   }
  //   //                   tooltipData = tooltipData.substring(
  //   //                     0,
  //   //                     tooltipData.length - 1
  //   //                   );
  //   //                   return (
  //   //                     index == 2 && (
  //   //                       <Tooltip title={tooltipData}>
  //   //                         {" "}
  //   //                         <span
  //   //                           style={{
  //   //                             display: "flex",
  //   //                             fontSize: "10px",
  //   //                             fontWeight: "bold",
  //   //                           }}
  //   //                         >
  //   //                           & {record.reelod.length - 2} More
  //   //                         </span>
  //   //                       </Tooltip>
  //   //                     )
  //   //                   );
  //   //                 })}
  //   //             </div>
  //   //           )}
  //   //         </div>
  //   //       </Styled>
  //   //     )
  //   //  },
  //   // {
  //   //   title: "Rewinder Reels",
  //   //   dataIndex: "rewinder_reels",
  //   //   width: "9%",
  //   //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
  //   // },
  //   // {
  //   //   title: "QUO.PRICE",
  //   //   dataIndex: "price",
  //   //   width: "8%",
  //   //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
  //   // },
  //   {
  //     title: "Price",
  //     width: "8%",
  //     dataIndex: "netprice",
  //     render: (text, record) => (
  //       <Styled>
  //         {record.category === "SO" ? (
  //           "-"
  //         ) : (
  //           <>
  //             {record.type !== "reel" &&
  //               record.quantity_type !== "reel_sheet" && (
  //                 <span style={{ fontSize: "10px" }}>{record.netprice}</span>
  //               )}
  //             <br />
  //             <span style={{ textAlign: "center" }}>
  //               Rate: {record.dealerPrice}
  //             </span>
  //           </>
  //         )}
  //       </Styled>
  //     ),
  //     // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
  //   },
  //   {
  //     title: "Delivery Date",
  //     dataIndex: "deliverydate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
  //     },
  //     // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
  //   },
  //   {
  //     title: "Created Date",
  //     dataIndex: "createddate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
  //     },
  //     // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
  //   },
  //   {
  //     title: "Approver By",
  //     dataIndex: "approvedby",
  //     width: "5.8%",
  //   },
  //   {
  //     title: "Priority",
  //     dataIndex: "priority",
  //     width: "5%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Button style={{ cursor: "default" }}>
  //           <Iconmoon
  //             icon={record.priority ? "correct" : "wrong"}
  //             size={16}
  //             color={record.priority ? "#3FBD61" : "#a19f9d"}
  //           />
  //         </Button>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "remarks",
  //     width: "6%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={record.remarks}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button style={{ cursor: "default" }}>
  //               <Iconmoon icon="message" size={16} color="#EA655B" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Status",
  //     dataIndex: "status",
  //     width: "7.6%",
  //     render: (text, record) => (
  //       <div className="statusVal" dataval={record.status}>
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               record.status === "Changes Req"
  //                 ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
  //                 : record.status === "Approved"
  //                 ? "The order has been approved"
  //                 : record.status === "Pending"
  //                 ? "The order is pending for approval"
  //                 : record.status === "Open"
  //                 ? "The order is not sent for approval yet. Go to PO to send orders for approval"
  //                 : record.status === "Rejected"
  //                 ? "The order is rejected by the approver. Click on View Order to see approver remarks"
  //                 : record.status === "On Hold"
  //                 ? "The order has been put on hold by the approver"
  //                 : record.status === "Cancelled"
  //                 ? "The order has been cancelled"
  //                 : record.status === "Merged"
  //                 ? "The quantity in this order is merged with other orders"
  //                 : record.status === "Complete"
  //                 ? "The order has been produced"
  //                 : null
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {" "}
  //             {record.status === "In_production" ? "Approved" : record.status}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Progress",
  //     dataIndex: "progress",
  //     width: "6.8%",
  //     render: (text, record) => {
  //       // if(record.item_type && record.item_type === "order"){
  //       if (
  //         record?.order_type === "sheet" ||
  //         (record?.order_type === "reel" && record?.quantity_type === "weight")
  //       ) {
  //         const totalProd =
  //           ((record?.progressbar_info?.completed?.weight +
  //             record?.progressbar_info?.in_production?.weight) /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         const totalCompleted =
  //           (record?.progressbar_info?.completed?.weight /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? (record?.progressbar_info?.completed?.weight).toFixed(3)
  //                     : 0.0
  //                 } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.completed?.units?.weight
  //                   ].displayName
  //                 )} Weight produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? (record?.progressbar_info?.in_production?.weight).toFixed(
  //                                 3
  //                               )
  //                             : 0.0
  //                         } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.in_production?.units?.weight
  //                   ].displayName
  //                 )} Weight in production
  //                       ${
  //                         record?.progressbar_info?.pending
  //                           ? (record?.progressbar_info?.pending?.weight).toFixed(
  //                               3
  //                             )
  //                           : 0.0
  //                       } ${capitalize(
  //                   weightUnit[record?.progressbar_info?.pending?.units?.weight]
  //                     .displayName
  //                 )} Weight pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={totalProd}
  //                   success={{
  //                     percent: totalCompleted,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       } else {
  //         const production =
  //           ((record?.progressbar_info?.completed?.quantity +
  //             record?.progressbar_info?.in_production?.quantity) /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;
  //         const completed =
  //           (record?.progressbar_info?.completed?.quantity /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;

  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? record?.progressbar_info?.completed?.quantity
  //                     : 0
  //                 } Reels produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? record?.progressbar_info?.in_production
  //                                 ?.quantity
  //                             : 0
  //                         } Reels in production
  //                         ${
  //                           record?.progressbar_info?.pending
  //                             ? record?.progressbar_info?.pending?.quantity
  //                             : 0
  //                         } Reels pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={production}
  //                   success={{
  //                     percent: completed,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       }
  //     },
  //     align: "center",
  //   },
  //   {
  //     title: "Actions",
  //     dataIndex: "action",
  //     width: "9%",
  //     render: (text, record) =>
  //       record.item_type === "order" ? (
  //         <div className="actionBtn">
  //           {!["Approved", "Rejected", "On Hold", "Cancelled"].includes(
  //             record?.status
  //           ) &&
  //             (userDetails?.roles?.order_records.edit_all ||
  //               (userDetails?.roles?.order_records.edit_own &&
  //                 userDetails.id == record.user)) && (
  //               <Styled>
  //                 <Tooltip
  //                   placement="bottomRight"
  //                   title={"Edit this order"}
  //                   className="edit-tooltip"
  //                   getPopupContainer={(triggerNode) => triggerNode}
  //                 >
  //                   <Button
  //                     onClick={() => {
  //                       handleEditAction(record);
  //                     }}
  //                   >
  //                     <Iconmoon icon="edit" size={16} color="#605E5C" />
  //                   </Button>
  //                 </Tooltip>
  //               </Styled>
  //             )}
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={"View details of this order"}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button
  //                 onClick={() => {
  //                   handleViewAction(record);
  //                 }}
  //               >
  //                 <Iconmoon icon="file-view" size={16} color="#605E5C" />
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //           {/* {((userDetails?.roles?.order_records.edit_all) || (userDetails?.roles?.order_records.edit_own)) ? (
  //         <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={record.priority ? "Remove Priority" : "Prioritize this order"}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button
  //                 onClick={() => {
  //                   handlePriorityAction(record);
  //                 }}
  //               >
  //                 <Iconmoon
  //                 // icon={"edit"} size={17} color="#A19F9D" />
  //                 icon={record.priority ? "low-priority" : "high-priority"}
  //                 size={17}
  //                 color={record.priority ? "#ea4e2c" : "#3fbd61"}/>
  //                 </Button>
  //             </Tooltip>
  //           </Styled>
  //         ) : (
  //           <div style={{ width: "38px" }}></div>
  //         )} */}
  //           {/* {(((userDetails?.roles?.order_records.edit_all) || ((userDetails?.roles?.order_records.edit_own) && (userDetails.id == record.user))) && ((record?.status == "Approved") && (!record?.priority) && (record?.pending != 0))) ? (
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={"Split this order"}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button
  //                 onClick={() => {
  //                   handleSplitAction(record);
  //                 }}
  //               >
  //                 <Iconmoon icon={"Mapping"} size={17} color="#605E5C" />
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //         ) : (
  //           <div style={{ width: "38px" }}></div>
  //         )}           */}
  //           {
  //             //   [
  //             //   "Approved",
  //             //   "On Hold",
  //             //   "Complete",
  //             // ].includes(record?.status) ?
  //             <Dropdown
  //               overlay={
  //                 <Menu>
  //                   {(userDetails?.roles?.order_records.edit_all ||
  //                     userDetails?.roles?.order_records.edit_own) &&
  //                     record?.status == "Approved" && (
  //                       <Menu.Item key="1" style={{ padding: "0px 12px" }}>
  //                         <Button
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                           onClick={() => {
  //                             handlePriorityAction(record);
  //                           }}
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "8px" }}>
  //                               <Iconmoon
  //                                 icon={
  //                                   record.priority
  //                                     ? "low-priority"
  //                                     : "high-priority"
  //                                 }
  //                                 size={17}
  //                                 color={
  //                                   record.priority ? "#ea4e2c" : "#3fbd61"
  //                                 }
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "5px", marginLeft: "6px" }}
  //                             >
  //                               {record.priority
  //                                 ? "Remove Priority"
  //                                 : "Prioritize this order"}
  //                             </div>
  //                           </div>
  //                         </Button>
  //                       </Menu.Item>
  //                     )}
  //                   {(userDetails?.roles?.order_records.edit_all ||
  //                     (userDetails?.roles?.order_records.edit_own &&
  //                       userDetails.id == record.user)) &&
  //                     record?.status == "Approved" &&
  //                     !record?.priority &&
  //                     record?.pendingQuantityValue != 0 && (
  //                       <Menu.Item key="2" style={{ padding: "0px 12px" }}>
  //                         <Button
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                           onClick={() => {
  //                             handleSplitAction(record);
  //                           }}
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "8px" }}>
  //                               <Iconmoon
  //                                 icon={"Mapping"}
  //                                 size={17}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "5px", marginLeft: "6px" }}
  //                             >
  //                               Split this order
  //                             </div>
  //                           </div>
  //                         </Button>
  //                       </Menu.Item>
  //                     )}
  //                   {record.status !== "Cancelled" &&
  //                     record?.split_type != "auto" &&
  //                     record.split_group &&
  //                     record.status == "Approved" &&
  //                     !record?.priority &&
  //                     record.completed == 0 &&
  //                     record.in_production == 0 &&
  //                     record.in_process == 0 &&
  //                     record.parent && (
  //                       <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
  //                         <DisabledButtonStyle>
  //                           <Button
  //                             style={{
  //                               border: "none",
  //                               background: "none",
  //                               padding: "0",
  //                               font: "inherit",
  //                               textAlign: "left",
  //                               width: "100%",
  //                               color: "black",
  //                             }}
  //                             className="themeBtn noBg"
  //                             onClick={() =>
  //                               onMergeOrderHandler(record, "menuEle")
  //                             }
  //                           >
  //                             <div
  //                               style={{
  //                                 display: "flex",
  //                                 flexDirection: "row",
  //                               }}
  //                             >
  //                               <div style={{ marginTop: "-1px" }}>
  //                                 <Iconmoon
  //                                   icon={"export"}
  //                                   size={14}
  //                                   color="#605E5C"
  //                                 />{" "}
  //                               </div>
  //                               <div
  //                                 style={{
  //                                   marginTop: "-3px",
  //                                   marginLeft: "11px",
  //                                 }}
  //                               >
  //                                 Merge order
  //                               </div>
  //                             </div>
  //                           </Button>
  //                         </DisabledButtonStyle>
  //                       </Menu.Item>
  //                     )}
  //                   {record.status == "Approved" &&
  //                     record.pendingQuantityValue > 0 && (
  //                       <Menu.Item key="4" style={{ marginBottom: "-10px" }}>
  //                         <Button
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                           onClick={() =>
  //                             handleCancelledQuantityAction(record)
  //                           }
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "0px" }}>
  //                               <Iconmoon
  //                                 icon={"wrong"}
  //                                 size={15}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                             >
  //                               Cancel Quantity
  //                             </div>
  //                           </div>
  //                         </Button>
  //                       </Menu.Item>
  //                     )}
  //                   {["On Hold", "Approved"].includes(record?.status) && (
  //                     <Menu.Item key="5" style={{ padding: "0px 12px" }}>
  //                       <Button
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                         onClick={() => {
  //                           handleViewProdDetailsAction(record);
  //                         }}
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "8px" }}>
  //                             <Iconmoon
  //                               icon={"production"}
  //                               size={17}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "5px", marginLeft: "6px" }}
  //                           >
  //                             View Production Details
  //                           </div>
  //                         </div>
  //                       </Button>
  //                     </Menu.Item>
  //                   )}

  //                   {["On Hold", "Approved"].includes(record?.status) && (
  //                     <Menu.Item key="6" style={{ padding: "0px 12px" }}>
  //                       <Button
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                         onClick={() => {
  //                           handleViewProcessedQtyDetails(record);
  //                         }}
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "8px" }}>
  //                             <Iconmoon
  //                               icon={"viewPODetails"}
  //                               size={17}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "5px", marginLeft: "6px" }}
  //                           >
  //                             View Processed Quantity Details
  //                           </div>
  //                         </div>
  //                       </Button>
  //                     </Menu.Item>
  //                   )}

  //                   {[
  //                     "On Hold",
  //                     "Approved",
  //                     "Open",
  //                     "Changes Req",
  //                     "Pending",
  //                   ].includes(record?.status) && (
  //                     <Menu.Item key="7" style={{ padding: "0px 12px" }}>
  //                       <Button
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                         onClick={() => {
  //                           handleViewPendingQtyDetails(record);
  //                         }}
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "8px" }}>
  //                             <Iconmoon
  //                               icon={"viewPODetails"}
  //                               size={17}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "5px", marginLeft: "6px" }}
  //                           >
  //                             View Pending Quantity Details
  //                           </div>
  //                         </div>
  //                       </Button>
  //                     </Menu.Item>
  //                   )}

  //                   <Menu.Item key="8" style={{ marginBottom: "-10px" }}>
  //                     <DisabledButtonStyle>
  //                       <Button
  //                         onClick={() => {
  //                           onViewPODetailsHandler(record);
  //                         }}
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "0px" }}>
  //                             <Iconmoon
  //                               icon={"viewPODetails"}
  //                               size={17}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                           >
  //                             {record.category === "PO"
  //                               ? "View PO Details"
  //                               : "View SO Details"}
  //                           </div>
  //                         </div>
  //                       </Button>{" "}
  //                     </DisabledButtonStyle>
  //                   </Menu.Item>
  //                   <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
  //                     <DisabledButtonStyle>
  //                       <Button
  //                         onClick={() => {
  //                           onViewChangeHandler(record);
  //                         }}
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "0px" }}>
  //                             <Iconmoon
  //                               icon={"changeHistory"}
  //                               size={19}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "-2px", marginLeft: "5px" }}
  //                           >
  //                             View Change History
  //                           </div>
  //                         </div>
  //                       </Button>{" "}
  //                     </DisabledButtonStyle>
  //                   </Menu.Item>
  //                   {record.status == "Open" ? (
  //                     <Menu.Item key="10" style={{ marginBottom: "-10px" }}>
  //                       <DisabledButtonStyle>
  //                         <Button
  //                           onClick={() => handleDelete(record)}
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "0px" }}>
  //                               <Iconmoon
  //                                 icon={"delete"}
  //                                 size={15}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                             >
  //                               Delete Order
  //                             </div>
  //                           </div>
  //                         </Button>{" "}
  //                       </DisabledButtonStyle>
  //                     </Menu.Item>
  //                   ) : (
  //                     ""
  //                   )}
  //                   {(record.status == "Approved" &&
  //                     record.processQuantity?.split(" ")[0] == 0) ||
  //                   record.status == "On Hold" ||
  //                   record.status == "Pending" ||
  //                   record.status == "Changes Req" ||
  //                   record.status == "Rejected" ? (
  //                     <Menu.Item key="11" style={{ marginBottom: "-10px" }}>
  //                       <DisabledButtonStyle>
  //                         <Button
  //                           onClick={() => handleCancel(record)}
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "0px" }}>
  //                               <Iconmoon
  //                                 icon={"wrong"}
  //                                 size={15}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                             >
  //                               Cancel Order
  //                             </div>
  //                           </div>
  //                         </Button>{" "}
  //                       </DisabledButtonStyle>
  //                     </Menu.Item>
  //                   ) : (
  //                     ""
  //                   )}
  //                   {record.status == "Approved" &&
  //                   record.pendingQuantityValue ? (
  //                     <Menu.Item key="12" style={{ marginBottom: "-10px" }}>
  //                       <DisabledButtonStyle>
  //                         <Button
  //                           onClick={() => handleHold(record)}
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div
  //                               style={{ marginTop: "0px", marginLeft: "2px" }}
  //                             >
  //                               <Iconmoon
  //                                 icon={"hold"}
  //                                 size={14}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "-2px", marginLeft: "9px" }}
  //                             >
  //                               Hold Order
  //                             </div>
  //                           </div>
  //                         </Button>{" "}
  //                       </DisabledButtonStyle>
  //                     </Menu.Item>
  //                   ) : (
  //                     ""
  //                   )}
  //                   {record.status == "On Hold" ? (
  //                     <Menu.Item key="13" style={{ marginBottom: "-10px" }}>
  //                       <DisabledButtonStyle>
  //                         <Button
  //                           onClick={() => handleRelease(record)}
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "0px" }}>
  //                               <Iconmoon
  //                                 icon={"production"}
  //                                 size={17}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                             >
  //                               Release Order
  //                             </div>
  //                           </div>
  //                         </Button>{" "}
  //                       </DisabledButtonStyle>
  //                     </Menu.Item>
  //                   ) : (
  //                     ""
  //                   )}
  //                 </Menu>
  //               }
  //               placement="bottom"
  //               arrow
  //             >
  //               <DisabledButtonStyle>
  //                 <Button>
  //                   <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
  //                 </Button>
  //               </DisabledButtonStyle>
  //             </Dropdown>
  //             //   : (
  //             //   <div style={{ display: "flex" }}>
  //             //     <div style={{ width: "38px" }}></div>
  //             //   </div>
  //             // )
  //           }
  //         </div>
  //       ) : (
  //         "-"
  //       ),
  //     align: "center",
  //   },
  // ]);
  // const columnsNonStatusHead = useRef([
  //   {
  //     title: "Po/So.No",
  //     dataIndex: "pono",
  //     width: "8.6%",
  //     fixed: "left",
  //     key: "pono",
  //     align: "left",
  //     sorter: () => {},
  //     // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
  //     render: (text, record) => (
  //       <div className="">
  //         <Button
  //           style={{ background: "transparent" }}
  //           className="textTypeBtn textBtnIcon"
  //           onClick={() => handlePo(record)}
  //         >
  //           <div
  //                 style={{
  //                   whiteSpace: "normal",
  //                   lineHeight: "1.2",
  //                   textAlign: "left",
  //                 }}
  //               >
  //                 {`#${record.category === "PO" ? record.pono : record.sono}`
  //                   .match(/.{1,15}/g)
  //                   ?.map((chunk, index) => (
  //                     <span key={index}>
  //                       {chunk}
  //                       <br />
  //                     </span>
  //                   ))}
  //               </div>
  //         </Button>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Group No",
  //   //   dataIndex: "groupno",
  //   //   width: "6%",
  //   //   fixed: "left",
  //   //   sorter: () => { },
  //   // },
  //   {
  //     title: "Order No",
  //     dataIndex: "orderno",
  //     key: "orderno",
  //     width: "8%",
  //     fixed: "left",
  //     sorter: () => {},
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         {text != "-" ? (
  //           // </Styled>
  //           <Button
  //             style={{ background: "transparent" }}
  //             className="textTypeBtn textBtnIcon"
  //             onClick={() => handleViewAction(record)}
  //           >
  //             {`${text}`}
  //           </Button>
  //         ) : (
  //           <span style={{ textAlign: "center" }}>{text}</span>
  //         )}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "PO/SO Date",
  //     dataIndex: "poDate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => {
  //         const dateA = new Date(a.category === "SO" ? a.soDate : a.poDate);
  //         const dateB = new Date(b.category === "SO" ? b.soDate : b.poDate);
  //         return dateA - dateB;
  //       },
  //     },
  //     render: (text, record) =>
  //       record.category === "SO" ? record.soDate : record.poDate,
  //   },
  //   { title: "Category", dataIndex: "category",width: "7%",
  //     align: "left", },

  //   {
  //     title: "Customer",
  //     dataIndex: "customer_alias",
  //     width: "7%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.customercode}-${record.customerName}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.customer_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Consignee",
  //     dataIndex: "consignee_alias",
  //     width: "7%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.consignee}-${record.consignee_name}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.consignee_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Prod. Code",
  //   //   dataIndex: "productcode",
  //   //   width: "5.8%",
  //   // },
  //   {
  //     title: (
  //       <div>
  //         Product
  //         <Styled style={{ display: "inline-flex" }}>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <span className="infoIcon"></span>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         <span style={{ fontSize: "10px" }}>{record.productspec} </span>
  //         <br />
  //         <span style={{ textAlign: "center" }}>{record.productcode}</span>
  //       </Styled>
  //     ),
  //     //dataIndex: "productspec",
  //     width: "10.8%",
  //   },
  //   // {
  //   //   title: "Type",
  //   //   dataIndex: "type",
  //   //   width: "5.8%",
  //   // },
  //   {
  //     title: "Size(WxL)",
  //     dataIndex: "size",
  //     width: "8.4%",
  //   },
  //   {
  //     title: "PLY",
  //     dataIndex: "ply",
  //     width: "8.4%",
  //   },
  //   {
  //     title: "Order Quantity",
  //     dataIndex: "quantity",
  //     width: "7.4%",
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         {record.type.toLowerCase() == "sheet" &&
  //         record.quantity_type.toLowerCase() == "reel_sheet" ? (
  //           <>
  //             <span style={{ textAlign: "center" }}>{text}</span>
  //             <br /> <span> {record.no_of_sheets + " Sheets"} </span>
  //           </>
  //         ) : (
  //           `${text} `
  //         )}
  //       </Styled>
  //     ),
  //   },
  //   {
  //     title: "Processed Quantity",
  //     dataIndex: "processQuantity",
  //     width: "10%",
  //     render: (text, record) => {
  //       return (
  //         <div
  //           className="actionBtn"
  //           style={{ marginTop: "14px", justifyContent: "left" }}
  //         >
  //           <Col span={12}>
  //             {parseFloat(text) && record.type ? (
  //               <span dangerouslySetInnerHTML={{ __html: text }} />
  //             ) : parseFloat(text) ? (
  //               `${text} `
  //             ) : (
  //               "-"
  //             )}
  //           </Col>
  //           {parseFloat(text) ? (
  //             <Col span={12}>
  //               <Styled style={{ marginTop: "-8px" }}>
  //                 <Tooltip
  //                   placement="bottomRight"
  //                   title={"View Processed Quantity Details"}
  //                   className="edit-tooltip"
  //                   getPopupContainer={(triggerNode) => triggerNode}
  //                 >
  //                   <Button
  //                     onClick={() => {
  //                       handleViewProcessedQtyAction(record);
  //                     }}
  //                   >
  //                     <Iconmoon
  //                       icon="viewPODetails"
  //                       size={16}
  //                       color="rgb(96, 94, 92)"
  //                     />
  //                   </Button>
  //                 </Tooltip>
  //               </Styled>
  //             </Col>
  //           ) : (
  //             ""
  //           )}
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     title: "Pending Quantity",
  //     dataIndex: "pendingQuantity",
  //     width: "10%",
  //     render: (text, record) => {
  //       return (
  //         <div
  //           className="actionBtn"
  //           style={{ marginTop: "14px", justifyContent: "left" }}
  //         >
  //           <Col span={12}>
  //             {parseFloat(text) && record.type
  //               ? `${text}`
  //               : parseFloat(text)
  //               ? `${text} `
  //               : "-"}
  //           </Col>
  //           {parseFloat(text) ? (
  //             <Col span={12}>
  //               <Styled style={{ marginTop: "-8px" }}>
  //                 <Tooltip
  //                   placement="bottomRight"
  //                   title={"View Pending Quantity Details"}
  //                   className="edit-tooltip"
  //                   getPopupContainer={(triggerNode) => triggerNode}
  //                 >
  //                   <Button
  //                     onClick={() => {
  //                       handleViewPendingQtyAction(record);
  //                     }}
  //                   >
  //                     <Iconmoon
  //                       icon="viewPODetails"
  //                       size={16}
  //                       color="rgb(96, 94, 92)"
  //                     />
  //                   </Button>
  //                 </Tooltip>
  //               </Styled>
  //             </Col>
  //           ) : (
  //             ""
  //           )}
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     title: "Cancelled Quantity",
  //     dataIndex: "cancelledQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text}`
  //         : "-",
  //   },
  //   // {
  //   //   title: "Order Weight",
  //   //   dataIndex: "weight",
  //   //   width: "9%",
  //   //   render: (text, record) =>
  //   //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
  //   // },
  //   // {
  //   //   title: "Planned Weight",
  //   //   dataIndex: "plannedweight",
  //   //   width: "9%",
  //   //   render: (text, record) =>
  //   //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
  //   // },

  //   // {
  //   //   title: "Reel OD",
  //   //   dataIndex: "reelod",
  //   //   width: "6%",
  //   //   render: (text, record, index) => (
  //   //     <Styled>
  //   //       <div style={{ display: "flex" }}>
  //   //         {record.id_od_type == "range" && (
  //   //           <div
  //   //             style={{
  //   //               color: "var(--para-text)",
  //   //               display: "flex",
  //   //               width: "100%",
  //   //               alignSelf: "center",
  //   //             }}
  //   //           >
  //   //             {record.minimum_reel_od +
  //   //               "-" +
  //   //               record.maximum_reel_od +
  //   //               " " +
  //   //               lengthUnit[record.units.maximum_reel_od].displayName}
  //   //           </div>
  //   //         )}
  //   //         {record.id_od_type == "constant" && (
  //   //           <div
  //   //             style={{
  //   //               display: "flex",
  //   //               width: "70%",
  //   //               flexDirection: "column",
  //   //               alignSelf: "center",
  //   //             }}
  //   //           >
  //   //             {record.reelod &&
  //   //               record.reelod?.map((item, index) => {
  //   //                 return (
  //   //                   index < 2 && (
  //   //                     <div>
  //   //                       {item}{" "}
  //   //                       {index == 1
  //   //                         ? "...,"
  //   //                         : record.reelod.length > 1
  //   //                         ? ","
  //   //                         : ""}
  //   //                     </div>
  //   //                   )
  //   //                 );
  //   //               })}

  //   //             {record.reelod &&
  //   //               record.reelod?.length >= 2 &&
  //   //               record.reelod?.map((item, index) => {
  //   //                 let tooltipData = "";
  //   //                 for (
  //   //                   let index = 2;
  //   //                   index < record.reelod?.length;
  //   //                   index++
  //   //                 ) {
  //   //                   const data = record.reelod[index];
  //   //                   tooltipData = tooltipData + data + ", ";
  //   //                 }
  //   //                 tooltipData = tooltipData.substring(
  //   //                   0,
  //   //                   tooltipData.length - 1
  //   //                 );
  //   //                 return (
  //   //                   index == 2 && (
  //   //                     <Tooltip title={tooltipData}>
  //   //                       {" "}
  //   //                       <span
  //   //                         style={{
  //   //                           display: "flex",
  //   //                           fontSize: "10px",
  //   //                           fontWeight: "bold",
  //   //                         }}
  //   //                       >
  //   //                         & {record.reelod.length - 2} More
  //   //                       </span>
  //   //                     </Tooltip>
  //   //                   )
  //   //                 );
  //   //               })}
  //   //           </div>
  //   //         )}
  //   //       </div>
  //   //     </Styled>
  //   //   ),
  //   // },
  //   // {
  //   //   title: "Core ID",
  //   //   dataIndex: "coreid",
  //   //   width: "6%",
  //   //   render: (text, record) =>
  //   //     parseFloat(text.split(" ")[0]) ? record.coreid : "-",
  //   // },
  //   // {
  //   //   title: "Rewinder Reels",
  //   //   dataIndex: "rewinder_reels",
  //   //   width: "9%",
  //   //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
  //   // },
  //   // {
  //   //   title: "QUO.PRICE",
  //   //   dataIndex: "price",
  //   //   width: "8%",
  //   //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
  //   // },
  //   {
  //     title: "Price",
  //     width: "8%",
  //     dataIndex: "netprice",
  //     render: (text, record) => (
  //       <Styled>
  //         {record.category === "SO" ? (
  //           "-"
  //         ) : (
  //           <>
  //             {record.type !== "reel" &&
  //               record.quantity_type !== "reel_sheet" && (
  //                 <span style={{ fontSize: "10px" }}>{record.netprice}</span>
  //               )}
  //             <br />
  //             <span style={{ textAlign: "center" }}>
  //               Rate: {record.dealerPrice}
  //             </span>
  //           </>
  //         )}
  //       </Styled>
  //     ),
  //     // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
  //   },
  //   {
  //     title: "Delivery Date",
  //     dataIndex: "deliverydate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
  //     },
  //     // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
  //   },
  //   {
  //     title: "Created Date",
  //     dataIndex: "createddate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
  //     },
  //     // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
  //   },
  //   {
  //     title: "Approver By",
  //     dataIndex: "approvedby",
  //     width: "6.4%",
  //     align: "center",
  //     render: (text, record) =>
  //       record.status === "Open" || record.status === "Pending" ? "-" : text,
  //   },
  //   {
  //     title: "Priority",
  //     dataIndex: "priority",
  //     width: "5%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Button style={{ cursor: "default" }}>
  //           <Iconmoon
  //             icon={record.priority ? "correct" : "wrong"}
  //             size={16}
  //             color={record.priority ? "#3FBD61" : "#a19f9d"}
  //           />
  //         </Button>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "remarks",
  //     width: "6%",
  //     render: (text, record) =>
  //       record.item_type === "order" ? (
  //         <div className="actionBtn">
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={record.remarks}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button style={{ cursor: "default" }}>
  //                 <Iconmoon icon="message" size={16} color="#EA655B" />
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //         </div>
  //       ) : (
  //         "-"
  //       ),
  //     align: "center",
  //   },
  //   {
  //     title: "Priority",
  //     dataIndex: "priority",
  //     width: "5%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Button style={{ cursor: "default" }}>
  //           <Iconmoon
  //             icon={record.priority ? "correct" : "wrong"}
  //             size={16}
  //             color={record.priority ? "#3FBD61" : "#a19f9d"}
  //           />
  //         </Button>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Status",
  //     dataIndex: "status",
  //     width: "7.6%",
  //     render: (text, record) => (
  //       <div className="statusVal" dataval={record.status}>
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               record.status === "Changes Req"
  //                 ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
  //                 : record.status === "Approved"
  //                 ? "The order has been approved"
  //                 : record.status === "Pending"
  //                 ? "The order is pending for approval"
  //                 : record.status === "Open"
  //                 ? "The order is not sent for approval yet. Go to PO to send orders for approval"
  //                 : record.status === "Rejected"
  //                 ? "The order is rejected by the approver. Click on View Order to see approver remarks"
  //                 : record.status === "On Hold"
  //                 ? "The order has been put on hold by the approver"
  //                 : record.status === "Cancelled"
  //                 ? "The order has been cancelled"
  //                 : record.status === "Merged"
  //                 ? "The quantity in this order is merged with other orders"
  //                 : record.status === "Complete"
  //                 ? "The order has been produced"
  //                 : null
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {" "}
  //             {record.status === "In_production" ? "Approved" : record.status}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Progress",
  //     dataIndex: "progress",
  //     width: "6.8%",
  //     render: (text, record) => {
  //       // if(record.item_type && record.item_type === "order"){
  //       if (
  //         record?.order_type === "sheet" ||
  //         (record?.order_type === "reel" && record?.quantity_type === "weight")
  //       ) {
  //         const totalProd =
  //           ((record?.progressbar_info?.completed?.weight +
  //             record?.progressbar_info?.in_production?.weight) /
  //             (parseFloat(record.weight) -
  //               record?.cancelled_quantity?.weight)) *
  //           100;
  //         const totalCompleted =
  //           (record?.progressbar_info?.completed?.weight /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? (record?.progressbar_info?.completed?.weight).toFixed(3)
  //                     : 0.0
  //                 } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.completed?.units?.weight
  //                   ].displayName
  //                 )} Weight produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? (record?.progressbar_info?.in_production?.weight).toFixed(
  //                                 3
  //                               )
  //                             : 0.0
  //                         } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.in_production?.units?.weight
  //                   ].displayName
  //                 )} Weight in production
  //                       ${
  //                         record?.progressbar_info?.pending
  //                           ? (record?.progressbar_info?.pending?.weight).toFixed(
  //                               3
  //                             )
  //                           : 0.0
  //                       } ${capitalize(
  //                   weightUnit[record?.progressbar_info?.pending?.units?.weight]
  //                     .displayName
  //                 )} Weight pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={totalProd}
  //                   success={{
  //                     percent: totalCompleted,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       } else {
  //         const production =
  //           ((record?.progressbar_info?.completed?.quantity +
  //             record?.progressbar_info?.in_production?.quantity) /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;
  //         const completed =
  //           (record?.progressbar_info?.completed?.quantity /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;

  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? record?.progressbar_info?.completed?.quantity
  //                     : 0
  //                 } Reels produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? record?.progressbar_info?.in_production
  //                                 ?.quantity
  //                             : 0
  //                         } Reels in production
  //                         ${
  //                           record?.progressbar_info?.pending
  //                             ? record?.progressbar_info?.pending?.quantity
  //                             : 0
  //                         } Reels pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={production}
  //                   success={{
  //                     percent: completed,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       }
  //     },
  //     render: (text, record) => {
  //       // if(record.item_type && record.item_type === "order"){
  //       if (
  //         record?.order_type === "sheet" ||
  //         (record?.order_type === "reel" && record?.quantity_type === "weight")
  //       ) {
  //         const totalProd =
  //           ((record?.progressbar_info?.completed?.weight +
  //             record?.progressbar_info?.in_production?.weight) /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         const totalCompleted =
  //           (record?.progressbar_info?.completed?.weight /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? (record?.progressbar_info?.completed?.weight).toFixed(3)
  //                     : 0.0
  //                 } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.completed?.units?.weight
  //                   ].displayName
  //                 )} Weight produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? (record?.progressbar_info?.in_production?.weight).toFixed(
  //                                 3
  //                               )
  //                             : 0.0
  //                         } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.in_production?.units?.weight
  //                   ].displayName
  //                 )} Weight in production
  //                       ${
  //                         record?.progressbar_info?.pending
  //                           ? (record?.progressbar_info?.pending?.weight).toFixed(
  //                               3
  //                             )
  //                           : 0.0
  //                       } ${capitalize(
  //                   weightUnit[record?.progressbar_info?.pending?.units?.weight]
  //                     .displayName
  //                 )} Weight pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={totalProd}
  //                   success={{
  //                     percent: totalCompleted,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       } else {
  //         const production =
  //           ((record?.progressbar_info?.completed?.quantity +
  //             record?.progressbar_info?.in_production?.quantity) /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;
  //         const completed =
  //           (record?.progressbar_info?.completed?.quantity /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;

  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? record?.progressbar_info?.completed?.quantity
  //                     : 0
  //                 } Reels produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? record?.progressbar_info?.in_production
  //                                 ?.quantity
  //                             : 0
  //                         } Reels in production
  //                         ${
  //                           record?.progressbar_info?.pending
  //                             ? record?.progressbar_info?.pending?.quantity
  //                             : 0
  //                         } Reels pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={production}
  //                   success={{
  //                     percent: completed,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       }
  //     },
  //     align: "center",
  //   },
  //   {
  //     title: "Actions",
  //     dataIndex: "action",
  //     width: "11%",
  //     render: (text, record) =>
  //       record.item_type === "order" ? (
  //         <div className="actionBtn">
  //           {!["Rejected", "On Hold", "Complete"].includes(record?.status) &&
  //           (userDetails?.roles?.order_records.edit_all ||
  //             userDetails?.roles?.order_records.edit_own) &&
  //           ((record?.status == "Approved" &&
  //             record?.completed == 0 &&
  //             record?.in_production == 0) ||
  //             record?.status !== "Approved") ? (
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={"Edit this order"}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Button
  //                   onClick={() => {
  //                     handleEditAction(record);
  //                   }}
  //                 >
  //                   <Iconmoon icon="edit" size={16} color="#605E5C" />
  //                 </Button>
  //               </Tooltip>
  //             </Styled>
  //           ) : (
  //             <div style={{ display: "flex" }}>
  //               <div style={{ width: "38px" }}></div>
  //             </div>
  //           )}
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={"View details of this order"}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button
  //                 onClick={() => {
  //                   handleViewAction(record);
  //                 }}
  //               >
  //                 <Iconmoon icon="file-view" size={16} color="#605E5C" />
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //           {/* {(((userDetails?.roles?.order_records.edit_all) || (userDetails?.roles?.order_records.edit_own)) && (record?.status == "Approved")) ? (
  //         <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={record.priority ? "Remove Priority" : "Prioritize this order"}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button
  //                 onClick={() => {
  //                   handlePriorityAction(record);
  //                 }}
  //               >
  //                 <Iconmoon
  //                 // icon={"edit"} size={17} color="#A19F9D"
  //                 icon={record.priority ? "low-priority" : "high-priority"}
  //                 size={17}
  //                 color={record.priority ? "#ea4e2c" : "#3fbd61"}/>
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //         ) : (
  //           <div style={{ display: "flex" }}>
  //             <div style={{ width: "38px" }}></div>
  //           </div>
  //         )}
  //         {(((userDetails?.roles?.order_records.edit_all) || ((userDetails?.roles?.order_records.edit_own) && (userDetails.id == record.user))) && ((record?.status == "Approved") && (!record?.priority) && (record?.pending != 0))) ? (
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={"Split this order"}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button
  //                 onClick={() => {
  //                   handleSplitAction(record);
  //                 }}
  //               >
  //                 <Iconmoon icon={"Mapping"} size={14} color="#605E5C" />
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //         ) : (
  //           <div style={{ display: "flex" }}>
  //             <div style={{ width: "38px" }}></div>
  //           </div>
  //         )}
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"View Production Details"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button
  //               onClick={() => {
  //                 handleViewProdDetailsAction(record);
  //               }}
  //             >
  //               <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>           */}
  //           {/* <Dropdown
  //               overlay={
  //                 <Menu>

  //                     { (userDetails?.roles?.order_records.edit_all ||
  //             userDetails?.roles?.order_records.edit_own) &&
  //           record?.status == "Approved"  && (
  //              <Menu.Item key="1" style={{padding: "0px 12px"}}
  //           >
  //                     <Button
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color : 'black',
  //                     }}
  //                     className="themeBtn noBg"
  //                       onClick={() => {
  //                         handlePriorityAction(record);
  //                       }}
  //                     >
  //                       <div style={{display: "flex", flexDirection: "row"}}>
  //                         <div style={{marginTop: "8px"}}>
  //                       <Iconmoon
  //                         icon={record.priority ? "low-priority" : "high-priority"}
  //                         size={17}
  //                         color={record.priority ? "#ea4e2c" : "#3fbd61"}
  //                       /> </div><div style={{marginTop: "5px", marginLeft: "6px"}}>{
  //                         record.priority
  //                           ? "Remove Priority"
  //                           : "Prioritize this order"
  //                       }</div>

  //                       </div>
  //                     </Button>
  //                     </Menu.Item>
  //                    )
  //                   }
  //                   {
  //                     (userDetails?.roles?.order_records.edit_all ||
  //                       (userDetails?.roles?.order_records.edit_own &&
  //                         userDetails.id == record.user)) &&
  //                     record?.status == "Approved" &&
  //                     !record?.priority &&
  //                     record?.pending != 0  && ( <Menu.Item key="3" style={{padding: "0px 12px"}}>
  //                           <Button
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color : 'black',
  //                           }}
  //                           className="themeBtn noBg"
  //                             onClick={() => {
  //                               handleSplitAction(record);
  //                             }}
  //                           >
  //                             <div style={{display: "flex", flexDirection: "row"}}>
  //                               <div style={{marginTop: "8px"}}>
  //                             <Iconmoon
  //                               icon={"Mapping"}
  //                               size={17}
  //                               color="#605E5C"
  //                             /> </div><div style={{marginTop: "5px", marginLeft: "6px"}}>Split this order</div>

  //                             </div>
  //                           </Button>
  //                       </Menu.Item>)

  //                   }
  //                   {
  //                    ["On Hold", "Complete", "Approved"].includes(record?.status) && ( <Menu.Item key="3" style={{padding: "0px 12px"}}>
  //                     <Button
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color : 'black',
  //                     }}
  //                     className="themeBtn noBg"
  //                     onClick={() => {
  //                       handleViewProdDetailsAction(record);
  //                     }}
  //                     >
  //                       <div style={{display: "flex", flexDirection: "row"}}>
  //                         <div style={{marginTop: "8px"}}>
  //                       <Iconmoon
  //                         icon={"production"}
  //                         size={17}
  //                         color="#605E5C"
  //                       /> </div><div style={{marginTop: "5px", marginLeft: "6px"}}>View Production Details</div>

  //                       </div>
  //                     </Button>
  //                     </Menu.Item>)
  //                   }
  //                   { (["Approved"].includes(record?.status) && record.pendingQuantityValue > 0 ) && ( <Menu.Item key="4" style={{padding: "0px 12px"}}>
  //                       <Button
  //                       style={{
  //                         border: "none",
  //                         background: "none",
  //                         padding: "0",
  //                         font: "inherit",
  //                         textAlign: "left",
  //                         width: "100%",
  //                         color : 'black',
  //                       }}
  //                       className="themeBtn noBg"
  //                       onClick={() => {
  //                         handleCancelledQuantityAction(record);
  //                       }}
  //                       >
  //                         <div style={{display: "flex", flexDirection: "row"}}>
  //                           <div style={{marginTop: "8px"}}>
  //                         <Iconmoon
  //                           icon={"production"}
  //                           size={17}
  //                           color="#605E5C"
  //                         /> </div><div style={{marginTop: "5px", marginLeft: "6px"}}>Cancel Quantity</div>

  //                         </div>
  //                       </Button>
  //                       </Menu.Item>)}
  //                 </Menu>
  //               }
  //               placement="bottom"
  //               arrow
  //             >
  //               <DisabledButtonStyle>
  //               <Button

  //               >
  //                 <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
  //               </Button>
  //               </DisabledButtonStyle>
  //             </Dropdown> */}
  //           {
  //             //   [
  //             //   "Approved",
  //             //   "On Hold",
  //             //   "Complete",
  //             // ].includes(record?.status) ?
  //             <Dropdown
  //               overlay={
  //                 <Menu>
  //                   {(userDetails?.roles?.order_records.edit_all ||
  //                     userDetails?.roles?.order_records.edit_own) &&
  //                     record?.status == "Approved" && (
  //                       <Menu.Item key="1" style={{ padding: "0px 12px" }}>
  //                         <Button
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                           onClick={() => {
  //                             handlePriorityAction(record);
  //                           }}
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "8px" }}>
  //                               <Iconmoon
  //                                 icon={
  //                                   record.priority
  //                                     ? "low-priority"
  //                                     : "high-priority"
  //                                 }
  //                                 size={17}
  //                                 color={
  //                                   record.priority ? "#ea4e2c" : "#3fbd61"
  //                                 }
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "5px", marginLeft: "6px" }}
  //                             >
  //                               {record.priority
  //                                 ? "Remove Priority"
  //                                 : "Prioritize this order"}
  //                             </div>
  //                           </div>
  //                         </Button>
  //                       </Menu.Item>
  //                     )}
  //                   {(userDetails?.roles?.order_records.edit_all ||
  //                     (userDetails?.roles?.order_records.edit_own &&
  //                       userDetails.id == record.user)) &&
  //                     record?.status == "Approved" &&
  //                     !record?.priority &&
  //                     record?.pendingQuantityValue != 0 && (
  //                       <Menu.Item key="2" style={{ padding: "0px 12px" }}>
  //                         <Button
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                           onClick={() => {
  //                             handleSplitAction(record);
  //                           }}
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "8px" }}>
  //                               <Iconmoon
  //                                 icon={"Mapping"}
  //                                 size={17}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "5px", marginLeft: "6px" }}
  //                             >
  //                               Split this order
  //                             </div>
  //                           </div>
  //                         </Button>
  //                       </Menu.Item>
  //                     )}
  //                   {record.status !== "Cancelled" &&
  //                     record?.split_type != "auto" &&
  //                     record.split_group &&
  //                     record.status == "Approved" &&
  //                     !record?.priority &&
  //                     record.completed == 0 &&
  //                     record.in_production == 0 &&
  //                     record.in_process == 0 &&
  //                     record.parent && (
  //                       <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
  //                         <DisabledButtonStyle>
  //                           <Button
  //                             style={{
  //                               border: "none",
  //                               background: "none",
  //                               padding: "0",
  //                               font: "inherit",
  //                               textAlign: "left",
  //                               width: "100%",
  //                               color: "black",
  //                             }}
  //                             className="themeBtn noBg"
  //                             onClick={() =>
  //                               onMergeOrderHandler(record, "menuEle")
  //                             }
  //                           >
  //                             <div
  //                               style={{
  //                                 display: "flex",
  //                                 flexDirection: "row",
  //                               }}
  //                             >
  //                               <div style={{ marginTop: "-1px" }}>
  //                                 <Iconmoon
  //                                   icon={"export"}
  //                                   size={14}
  //                                   color="#605E5C"
  //                                 />{" "}
  //                               </div>
  //                               <div
  //                                 style={{
  //                                   marginTop: "-3px",
  //                                   marginLeft: "11px",
  //                                 }}
  //                               >
  //                                 Merge order
  //                               </div>
  //                             </div>
  //                           </Button>
  //                         </DisabledButtonStyle>
  //                       </Menu.Item>
  //                     )}
  //                   {record.status == "Approved" &&
  //                     record.pendingQuantityValue > 0 && (
  //                       <Menu.Item key="4" style={{ marginBottom: "-10px" }}>
  //                         <Button
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                           onClick={() =>
  //                             handleCancelledQuantityAction(record)
  //                           }
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "0px" }}>
  //                               <Iconmoon
  //                                 icon={"wrong"}
  //                                 size={15}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                             >
  //                               Cancel Quantity
  //                             </div>
  //                           </div>
  //                         </Button>
  //                       </Menu.Item>
  //                     )}
  //                   {["On Hold", "Approved"].includes(record?.status) && (
  //                     <Menu.Item key="5" style={{ padding: "0px 12px" }}>
  //                       <Button
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                         onClick={() => {
  //                           handleViewProdDetailsAction(record);
  //                         }}
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "8px" }}>
  //                             <Iconmoon
  //                               icon={"production"}
  //                               size={17}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "5px", marginLeft: "6px" }}
  //                           >
  //                             View Production Details
  //                           </div>
  //                         </div>
  //                       </Button>
  //                     </Menu.Item>
  //                   )}

  //                   {["On Hold", "Approved"].includes(record?.status) && (
  //                     <Menu.Item key="6" style={{ padding: "0px 12px" }}>
  //                       <Button
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                         onClick={() => {
  //                           handleViewProcessedQtyDetails(record);
  //                         }}
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "8px" }}>
  //                             <Iconmoon
  //                               icon={"viewPODetails"}
  //                               size={17}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "5px", marginLeft: "6px" }}
  //                           >
  //                             View Processed Quantity Details
  //                           </div>
  //                         </div>
  //                       </Button>
  //                     </Menu.Item>
  //                   )}

  //                   {[
  //                     "On Hold",
  //                     "Approved",
  //                     "Open",
  //                     "Changes Req",
  //                     "Pending",
  //                   ].includes(record?.status) && (
  //                     <Menu.Item key="7" style={{ padding: "0px 12px" }}>
  //                       <Button
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                         onClick={() => {
  //                           handleViewPendingQtyDetails(record);
  //                         }}
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "8px" }}>
  //                             <Iconmoon
  //                               icon={"viewPODetails"}
  //                               size={17}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "5px", marginLeft: "6px" }}
  //                           >
  //                             View Pending Quantity Details
  //                           </div>
  //                         </div>
  //                       </Button>
  //                     </Menu.Item>
  //                   )}

  //                   <Menu.Item key="8" style={{ marginBottom: "-10px" }}>
  //                     <DisabledButtonStyle>
  //                       <Button
  //                         onClick={() => {
  //                           onViewPODetailsHandler(record);
  //                         }}
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "0px" }}>
  //                             <Iconmoon
  //                               icon={"viewPODetails"}
  //                               size={17}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                           >
  //                             {record.category === "PO"
  //                               ? "View PO Details"
  //                               : "View SO Details"}
  //                           </div>
  //                         </div>
  //                       </Button>{" "}
  //                     </DisabledButtonStyle>
  //                   </Menu.Item>
  //                   <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
  //                     <DisabledButtonStyle>
  //                       <Button
  //                         onClick={() => {
  //                           onViewChangeHandler(record);
  //                         }}
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "0px" }}>
  //                             <Iconmoon
  //                               icon={"changeHistory"}
  //                               size={19}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "-2px", marginLeft: "5px" }}
  //                           >
  //                             View Change History
  //                           </div>
  //                         </div>
  //                       </Button>{" "}
  //                     </DisabledButtonStyle>
  //                   </Menu.Item>
  //                   {record.status == "Open" ? (
  //                     <Menu.Item key="10" style={{ marginBottom: "-10px" }}>
  //                       <DisabledButtonStyle>
  //                         <Button
  //                           onClick={() => handleDelete(record)}
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "0px" }}>
  //                               <Iconmoon
  //                                 icon={"delete"}
  //                                 size={15}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                             >
  //                               Delete Order
  //                             </div>
  //                           </div>
  //                         </Button>{" "}
  //                       </DisabledButtonStyle>
  //                     </Menu.Item>
  //                   ) : (
  //                     ""
  //                   )}
  //                   {(record.status == "Approved" &&
  //                     record.processQuantity?.split(" ")[0] == 0) ||
  //                   record.status == "On Hold" ||
  //                   record.status == "Pending" ||
  //                   record.status == "Changes Req" ||
  //                   record.status == "Rejected" ? (
  //                     <Menu.Item key="11" style={{ marginBottom: "-10px" }}>
  //                       <DisabledButtonStyle>
  //                         <Button
  //                           onClick={() => handleCancel(record)}
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "0px" }}>
  //                               <Iconmoon
  //                                 icon={"wrong"}
  //                                 size={15}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                             >
  //                               Cancel Order
  //                             </div>
  //                           </div>
  //                         </Button>{" "}
  //                       </DisabledButtonStyle>
  //                     </Menu.Item>
  //                   ) : (
  //                     ""
  //                   )}
  //                   {record.status == "Approved" &&
  //                   record.pendingQuantityValue ? (
  //                     <Menu.Item key="12" style={{ marginBottom: "-10px" }}>
  //                       <DisabledButtonStyle>
  //                         <Button
  //                           onClick={() => handleHold(record)}
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div
  //                               style={{ marginTop: "0px", marginLeft: "2px" }}
  //                             >
  //                               <Iconmoon
  //                                 icon={"hold"}
  //                                 size={14}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "-2px", marginLeft: "9px" }}
  //                             >
  //                               Hold Order
  //                             </div>
  //                           </div>
  //                         </Button>{" "}
  //                       </DisabledButtonStyle>
  //                     </Menu.Item>
  //                   ) : (
  //                     ""
  //                   )}
  //                   {record.status == "On Hold" ? (
  //                     <Menu.Item key="13" style={{ marginBottom: "-10px" }}>
  //                       <DisabledButtonStyle>
  //                         <Button
  //                           onClick={() => handleRelease(record)}
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "0px" }}>
  //                               <Iconmoon
  //                                 icon={"production"}
  //                                 size={17}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                             >
  //                               Release Order
  //                             </div>
  //                           </div>
  //                         </Button>{" "}
  //                       </DisabledButtonStyle>
  //                     </Menu.Item>
  //                   ) : (
  //                     ""
  //                   )}
  //                 </Menu>
  //               }
  //               placement="bottom"
  //               arrow
  //             >
  //               <DisabledButtonStyle>
  //                 <Button>
  //                   <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
  //                 </Button>
  //               </DisabledButtonStyle>
  //             </Dropdown>
  //             //   : (
  //             //   <div style={{ display: "flex" }}>
  //             //     <div style={{ width: "38px" }}></div>
  //             //   </div>
  //             // )
  //           }
  //         </div>
  //       ) : (
  //         "-"
  //       ),
  //     align: "center",
  //   },
  // ]);

  //hidden column list
  const columnBlacklist =
    settingsData?.settings?.orders_page?.tables?.order_records || [];
    // console.log("cbl",columnBlacklist)
  const filtersToBeShown =
    settingsData?.settings?.orders_page?.filters?.order_records || [];
  const format = settingsData?.settings?.product_spec?.format || "";
  // const filtersToBeShown = [
  //   "ply_type",
  //   "delivery_date",
  //   "reel_od",
  //   "core_id",
  //   "customer"
  // ];

  const filterOptions = [
    {
      key: 0,
      label: "Filter by Created Date",
      value: "created_date",
      type: "date",
      hiddenColValue: "createddate",
    },
    {
      key: 1,
      label: "Filter by PO Date",
      value: "po_date",
      type: "date",
      hiddenColValue: "poDate",
    },
    {
      key: 2,
      label: "Filter by GSM",
      value: "gsm",
      type: "inputSelect",
      hiddenColValue: "",
    },
    {
      key: 3,
      label: "Filter by Grade/Quality",
      value: "grade_quality",
      type: "grade",
      hiddenColValue: "",
    },
    {
      key: 4,
      label: "Filter by Burst Factor",
      value: "burst_factor",
      type: "inputSelect",
      hiddenColValue: "",
    },
    {
      key: 5,
      label: "Filter by Reel OD",
      value: "reel_od",
      type: "inputSelect",
      unitType: "length",
      hiddenColValue: "",
    },
    {
      key: 6,
      label: "Filter by Core ID",
      value: "core_id",
      type: "inputSelect",
      unitType: "length",
      hiddenColValue: "",
    },
    {
      key: 7,
      label: "Filter by Delivery Date",
      value: "delivery_date",
      type: "date",
      hiddenColValue: "deliverydate",
    },
    {
      key: 8,
      label: "Filter by Customer",
      value: "customer",
      type: "multiSelect",
      hiddenColValue: "",
    },
    // {
    //   key: 9,
    //   label: "Filter by Order Type",
    //   value: "order_type",
    //   type: "multiSelect",
    //   hiddenColValue: "",
    // },
    {
      key: 10,
      label: "Filter by Size",
      value: "size",
      type: "rangeTypeSelect",
      unitType: "length",
      hiddenColValue: "",
    },
    {
      key: 11,
      label: "Filter by Consignee",
      value: "consignee",
      type: "multiSelect",
      hiddenColValue: "consignee_alias",
    },
    {
      key: 12,
      label: "Filter by Ply Count",
      value: "ply_type",
      type: "multiSelect",
      hiddenColValue: "ply",
    },
    // {
    //   key: 10,
    //   label: "Filter by Status",
    //   value: "orderStatus",
    //   type: "multiSelect",
    // },
  ];

  //removing hidden columns
  const updatedFilterOptions = filterOptions.filter(
    (filter) => !columnBlacklist.includes(filter.hiddenColValue)
  );

  //removing first 4 filters
  const finalFilters = updatedFilterOptions
    .filter((filter) => !filtersToBeShown.includes(filter.value))
    .map((filter, index) => ({
      ...filter,
      key: index,
    }));

  const fullColumnsHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "8%",
      fixed: "left",
      key: "pono",
      align: "left",
      sorter: () => {},
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
      render: (text, record) => (
        <div className="" style={{display:"flex",alignItems:'center'}} >
          {/* Always reserve space for icon */}
      {record.isConflictingstate? (
       <span style={{}}> <Tooltip title= {`Conflicting order, part of ${record.jobcards?.length} conflicting job cards`} placement="top" >
                <Iconmoon icon="info_new" size={16} color="#EA655B" />
        </Tooltip>
        </span>
      ) : (
        // Invisible placeholder to maintain layout
        <span style={{ width: "16px" }}></span>
      )}
          <Button
            style={{ background: "transparent" }}
            className="textTypeBtn textBtnIcon"
            onClick={() => handlePo(record)}
          >
            <div
              style={{
                whiteSpace: "normal",
                lineHeight: "1.2",
                textAlign: "left",
              }}
            >
              {`#${
                record.category === "PO"
                  ? toHandlePOName(record.pono)
                  : toHandlePOName(record.sono)
              }`
                .match(/.{1,15}/g)
                ?.map((chunk, index) => (
                  <span key={index}>
                    {chunk}
                    <br />
                  </span>
                ))}
            </div>
          </Button>
        </div>
      ),
    },
    // {
    //   title: "Group No",
    //   dataIndex: "groupno",
    //   width: "6.5%",
    //   fixed: "left",
    //   sorter: () => {},
    //   // sortOrder: "null",
    // },
    {
      title: "Order No",
      dataIndex: "orderno",
      key: "orderno",
      width: "8%",
      fixed: "left",
      sorter: () => {},
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
      render: (text, record) => (
        <div className="actionBtn2">
          {record?.previous_state?.old &&
          record?.previous_state?.new &&
          (record?.previous_state?.old === "review" ||
            record?.previous_state?.old === "approved" ||
            record?.previous_state?.old === "cancel") &&
          (record.status === "Pending" || record.status == "Pending Confirmation") ? (
            // <Styled >
            <TooltipSelector>
              <Tooltip
                overlayInnerStyle={{
                  borderRadius: "8px",
                  background: "rgba(32, 31, 30, 0.85)",
                  padding: "7px",
                  background: "rgba(32, 31, 30, 0.85)",
                  fontFamily: "var(--sf-pro-display-m)",
                  fontStyle: "normal",
                  fontSize: "12px",
                  lineHeight: "16px",
                }}
                placement="bottomRight"
                title={
                  record?.previous_state?.old === "review"
                    ? "This order has been sent for approval again. Changes were requested in this order previously."
                    : record?.previous_state?.old === "cancel"
                    ? "This order has been sent for approval again. This order was cancelled previously."
                    : "This order has been sent for approval again. This order was approved previously."
                }
                // getPopupContainer={(triggerNode) => triggerNode}
                overlayClassName="edit-tooltip"
              >
                <Button
                  style={{ background: "transparent" }}
                  className="textTypeBtn textBtnIcon"
                  onClick={() => handleViewAction(record)}
                >
                  {`${text}`}
                </Button>
              </Tooltip>
            </TooltipSelector>
          ) : text != "-" ? (
            // </Styled>
            <Button
              style={{ background: "transparent" }}
              className="textTypeBtn textBtnIcon"
              onClick={() => handleViewAction(record)}
            >
              {`${text}`}
            </Button>
          ) : (
            <span style={{ textAlign: "center" }}>{text}</span>
          )}
          {record?.previous_state?.old &&
            record?.previous_state?.new &&
            (record?.previous_state?.old === "review" ||
              record?.previous_state?.old === "approved" ||
              record?.previous_state?.old === "cancel") &&
            (record.status === "Pending" || record.status == "Pending Confirmation") && (
              <div>
                <span
                  style={{
                    color: "rgb(234, 101, 91)",
                    fontStyle: "italic",
                    fontSize: "10px",
                  }}
                >
                  Resent for approval
                </span>
              </div>
            )}
        </div>
      ),
    },
    {
      title: "PO/SO Date",
      dataIndex: "poDate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => {
          const dateA = new Date(a.category === "SO" ? a.soDate : a.poDate);
          const dateB = new Date(b.category === "SO" ? b.soDate : b.poDate);
          return dateA - dateB;
        },
      },
      render: (text, record) =>
        record.category === "SO" ? record.soDate : record.poDate,
    },
    { title: "Category", dataIndex: "category", width: "7%", align: "left" },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customerName}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.consignee}-${record.consignee_name}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.consignee_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    // {
    //   title: "Prod. Code",
    //   dataIndex: "productcode",
    //   width: "5.8%",
    // },
    {
      title: (
        <div>
          Product
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={`The product specification is in the format of ${format}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      // render: (text, record) => (
      //   <Styled>
      //     {" "}
      //     <span style={{ fontSize: "10px" }}>{record.productspec} </span>
      //     <br />
      //     <span style={{ textAlign: "center" }}>{record.productcode}</span>
      //   </Styled>
      // ),
      dataIndex: "product_spec",
      width: "10.8%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5.8%",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    {
      title: "PLY",
      dataIndex: "ply",
      width: "8.4%",
    },
    {
      title: <span>Order<br/>Quantity</span>,
      dataIndex: "quantity",
      width: "7.4%",
      render: (text, record) => (
        <Styled>
          {" "}
          {record.type.toLowerCase() == "sheet" &&
          record.quantity_type.toLowerCase() == "reel_sheet" ? (
            <>
              <span style={{ textAlign: "center" }}>{text}</span>
              <br /> <span> {record.no_of_sheets + " Sheets"} </span>
            </>
          ) : (
            `${text} `
          )}
        </Styled>
      ),
    },
    {
      title: <span>Balance<br/>Quantity</span>,
      dataIndex: "balance_qty",
      width: "7.4%",
    },
    {
      title: <span>Processed<br/>Quantity</span>,
      dataIndex: "processQuantity",
      width: "10%",
      render: (text, record) => {
        return (
          // <div
          //   className="actionBtn"
          //   style={{ marginTop: "14px", justifyContent: "left" }}
          // >
            // <Col span={17}>
            //   {parseFloat(text) && record.type ? (
            //     <span dangerouslySetInnerHTML={{ __html: text }} />
            //   ) : parseFloat(text) ? (
            //     `${text} `
            //   ) : (
            //     "-"
            //   )}
            // </Col> 
            <Row className="actionBtn">
            <Col span={17} style={{alignContent:"center"}}>
              {parseFloat(text) && record.type
                ? `${text.replace("<br/>","")}`
                : parseFloat(text)
                ? `${text.replace("<br/>","")} `
                : "-"}
            </Col>
            {parseFloat(text) ? (
              <Col span={7}>
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={"View Processed Quantity Details"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleViewProcessedQtyAction(record);
                      }}
                    >
                      <Iconmoon
                        icon="viewPODetails"
                        size={16}
                        color="rgb(96, 94, 92)"
                      />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            ) : (
              ""
            )}
            </Row>
          // </div> 
        );
      },
    },
    {
      title: <span>Pending<br/>Quantity</span>,
      dataIndex: "pendingQuantity",
      width: "10%",
      render: (text, record) => {
        return (
          // <div
          //   className="actionBtn"
          //   style={{ marginTop: "13px", justifyContent: "left" }}
          // >
          record.isConflictingstate?
          <Row className="actionBtn" style={{display:"flex",justifyContent:"start"}}>
            <Col span={17} style={{alignContent:"center"}}>
            <span>ND</span>
            </Col>
            </Row>:
          <Row className="actionBtn">
            <Col span={17} style={{alignContent:"center"}}>
              {parseFloat(text) && record.type
                ? `${text}`
                : parseFloat(text)
                ? `${text} `
                : "-"}
            </Col>
            {parseFloat(text)&&["On Hold", "Approved"].includes(record?.status)  ? (
              <Col span={7}>
                <Styled >
                  <Tooltip
                    placement="bottomRight"
                    title={"View Production Details"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleViewProdDetailsAction(record);
                      }}
                    >
                      <Iconmoon
                        icon="viewPODetails"
                        size={16}
                        color="rgb(96, 94, 92)"
                      />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            ) : (
              <span style={{width:"16px"}}></span>
            )}
            </Row>
          // </div>
        );
      },
    },
    {
      title: "Cancelled Quantity",
      dataIndex: "cancelledQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text}`
          : "-",
    },
    // {
    //   title: "Order Weight",
    //   dataIndex: "weight",
    //   width: "9%",
    //   render: (text, record) =>
    //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
    // },
    // {
    //   title: "Planned Weight",
    //   dataIndex: "plannedweight",
    //   width: "9%",
    //   render: (text, record) =>
    //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
    // },
    // {
    //   title: "Core ID",
    //   dataIndex: "coreid",
    //   width: "6%",
    //   render: (text, record) =>
    //     parseFloat(text.split(" ")[0]) ? record.coreid : "-",
    // },
    // {
    //   title: "Reel OD",
    //   dataIndex: "reelod",
    //   width: "6%",
    //   render: (text, record, index) => (
    //     <Styled>
    //       <div style={{ display: "flex" }}>
    //         {record.id_od_type == "range" && (
    //           <div
    //             style={{
    //               color: "var(--para-text)",
    //               display: "flex",
    //               width: "100%",
    //               alignSelf: "center",
    //             }}
    //           >
    //             {record.minimum_reel_od +
    //               "-" +
    //               record.maximum_reel_od +
    //               " " +
    //               lengthUnit[record.units.maximum_reel_od].displayName}
    //           </div>
    //         )}
    //         {record.id_od_type == "constant" && (
    //           <div
    //             style={{
    //               display: "flex",
    //               width: "70%",
    //               flexDirection: "column",
    //               alignSelf: "center",
    //             }}
    //           >
    //             {record.reelod &&
    //               record.reelod?.map((item, index) => {
    //                 return (
    //                   index < 2 && (
    //                     <div>
    //                       {item}{" "}
    //                       {index == 1
    //                         ? "...,"
    //                         : record.reelod.length > 1
    //                         ? ","
    //                         : ""}
    //                     </div>
    //                   )
    //                 );
    //               })}

    //             {record.reelod &&
    //               record.reelod?.length >= 2 &&
    //               record.reelod?.map((item, index) => {
    //                 let tooltipData = "";
    //                 for (
    //                   let index = 2;
    //                   index < record.reelod?.length;
    //                   index++
    //                 ) {
    //                   const data = record.reelod[index];
    //                   tooltipData = tooltipData + data + ", ";
    //                 }
    //                 tooltipData = tooltipData.substring(
    //                   0,
    //                   tooltipData.length - 1
    //                 );
    //                 return (
    //                   index == 2 && (
    //                     <Tooltip title={tooltipData}>
    //                       {" "}
    //                       <span
    //                         style={{
    //                           display: "flex",
    //                           fontSize: "10px",
    //                           fontWeight: "bold",
    //                         }}
    //                       >
    //                         & {record.reelod.length - 2} More
    //                       </span>
    //                     </Tooltip>
    //                   )
    //                 );
    //               })}
    //           </div>
    //         )}
    //       </div>
    //     </Styled>
    //   ),
    // },
    // {
    //   title: "Rewinder Reels",
    //   dataIndex: "rewinder_reels",
    //   width: "9%",
    //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
    // },
    // {
    //   title: "QUO.PRICE",
    //   dataIndex: "price",
    //   width: "8%",
    //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
    // },
    {
      title: "Price",
      width: "8%",
      dataIndex: "netprice",
      render: (text, record) => (
        <Styled>
          {record.category === "SO" ? (
            "-"
          ) : (
            <>
              {record.type !== "reel" &&
                record.quantity_type !== "reel_sheet" && (
                  <span style={{ fontSize: "10px" }}>{record.netprice}</span>
                )}
              <br />
              <span style={{ textAlign: "center" }}>
                Rate: {record.dealerPrice}
              </span>
            </>
          )}
        </Styled>
      ),
      // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
    },
    {
      title: "Delivery Date",
      dataIndex: "deliverydate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
    },
    {
      title: "Created Date",
      dataIndex: "createddate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
      },
      // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
    },

    {
      title: "Approver By",
      dataIndex: "approvedby",
      width: "6.4%",
      align: "center",
      render: (text, record) =>
        ((record.status === "Open" || record.status == "Provisional") || (record.status === "Pending" || record.status == "Pending Confirmation")) ? "-" : text,
    },
    {
      title: "Priority",
      dataIndex: "priority",
      width: "5%",
      render: (text, record) => (
        <div className="actionBtn">
          <Button style={{ cursor: "default" }}>
            <Iconmoon
              icon={record.priority ? "correct" : "wrong"}
              size={16}
              color={record.priority ? "#3FBD61" : "#a19f9d"}
            />
          </Button>
        </div>
      ),
      align: "center",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "6%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={record.remarks}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button style={{ cursor: "default" }}>
                <Iconmoon icon="message" size={16} color="#EA655B" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },

    {
      title: "Status",
      dataIndex: "status",
      width: "7.6%",
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.status === "Changes Requested"
                  ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
                  : (record.status === "Approved" || record.status === "Active")
                  ? "The order has been approved"
                  : (record.status === "Pending" || record.status === "Pending Confirmation")
                  ? "The order is pending for approval"
                  : (record.status === "Open" || record.status === "Provisional")
                  ? "The order is not sent for approval yet. Go to PO to send orders for approval"
                  : (record.status === "Rejected" || record.status === "Confirmation Rejected")
                  ? "The order is rejected by the approver. Click on View Order to see approver remarks"
                  : record.status === "On Hold"
                  ? "The order has been put on hold by the approver"
                  : record.status === "Cancelled"
                  ? "The order has been cancelled"
                  : record.status === "Merged"
                  ? "The quantity in this order is merged with other orders"
                  : record.status === "Produced"
                  ? "The order has been produced"
                  : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {" "}
              {record.status === "In_production" ? "Active" : record.status}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Progress",
      dataIndex: "progress",
      width: "6.8%",
      render: (text, record) => {
        // if(record.item_type && record.item_type === "order"){
             if(!record.isConflictingstate){

        if (
          record?.order_type === "sheet" ||
          (record?.order_type === "reel" && record?.quantity_type === "weight")
        ) {
          const totalProd =
            ((record?.progressbar_info?.completed?.weight +
              record?.progressbar_info?.in_production?.weight) /
              (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
            100;
          const totalCompleted =
            (record?.progressbar_info?.completed?.weight /
              (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
            100;
          //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${
                    record?.progressbar_info?.completed
                      ? (record?.progressbar_info?.completed?.weight).toFixed(3)
                      : 0.0
                  } ${capitalize(
                    weightUnit[
                      record?.progressbar_info?.completed?.units?.weight
                    ].displayName
                  )} Weight produced
                          ${
                            record?.progressbar_info?.in_production
                              ? (record?.progressbar_info?.in_production?.weight).toFixed(
                                  3
                                )
                              : 0.0
                          } ${capitalize(
                    weightUnit[
                      record?.progressbar_info?.in_production?.units?.weight
                    ].displayName
                  )} Weight in production
                        ${
                          record?.progressbar_info?.pending
                            ? (record?.progressbar_info?.pending?.weight).toFixed(
                                3
                              )
                            : 0.0
                        } ${capitalize(
                    weightUnit[record?.progressbar_info?.pending?.units?.weight]
                      .displayName
                  )} Weight pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={totalProd}
                    success={{
                      percent: totalCompleted,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        } else {
          const production =
            ((record?.progressbar_info?.completed?.quantity +
              record?.progressbar_info?.in_production?.quantity) /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;
          const completed =
            (record?.progressbar_info?.completed?.quantity /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;

          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${
                    record?.progressbar_info?.completed
                      ? record?.progressbar_info?.completed?.quantity
                      : 0
                  } Reels produced
                          ${
                            record?.progressbar_info?.in_production
                              ? record?.progressbar_info?.in_production
                                  ?.quantity
                              : 0
                          } Reels in production
                          ${
                            record?.progressbar_info?.pending
                              ? record?.progressbar_info?.pending?.quantity
                              : 0
                          } Reels pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={production}
                    success={{
                      percent: completed,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        }
      }
      },
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "11%",
      render: (text, record) =>
        record.item_type === "order" ? (
          <div className="actionBtn">
            {record.isEditAllowed &&
            ![
              "Confirmation Rejected",
              "On Hold",
              "Produced",
              "Cancelled",
              "Merged",
              // 'Approved'
            ].includes(record?.status) &&
            (userDetails?.roles?.order_records.edit_all ||
              (userDetails?.roles?.order_records.edit_own &&
                userDetails.id == record.user)) &&
            ((record?.status == "Active" &&
              record?.completed == 0 &&
              record?.in_production == 0) ||
              record?.status !== "Active") ? (
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={"Edit this order"}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Button
                    onClick={() => {
                      handleEditAction(record);
                    }}
                  >
                    <Iconmoon
                      icon="edit"
                      size={16}
                      //  color="#A19F9D"
                      color="#605E5C"
                    />
                  </Button>
                </Tooltip>
              </Styled>
            ) : (
              <div style={{ display: "flex" }}>
                <div style={{ width: "38px" }}></div>
              </div>
            )}
            {/* {(userDetails?.roles?.order_records.edit_all || userDetails?.roles?.order_records.edit_own) ? ( */}
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View details of this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handleViewAction(record);
                  }}
                >
                  <Iconmoon icon="file-view" size={16} color="#605E5C" />
                </Button>
              </Tooltip>
            </Styled>
            {/* ) : (
          <div style={{ display:"flex", width: "38px" }}></div>
          )} */}
            {/* {(userDetails?.roles?.order_records.edit_all ||
              userDetails?.roles?.order_records.edit_own) &&
            record?.status == "Approved" ? (
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={
                    record.priority
                      ? "Remove Priority"
                      : "Prioritize this order"
                  }
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Button
                    onClick={() => {
                      handlePriorityAction(record);
                    }}
                  >
                    <Iconmoon
                      // icon={"low-priority"} size={17} color="#A19F9D"
                      icon={record.priority ? "low-priority" : "high-priority"}
                      size={17}
                      color={record.priority ? "#ea4e2c" : "#3fbd61"}
                    />
                  </Button>
                </Tooltip>
              </Styled>
            ) : (
              <div style={{ display: "flex" }}>
                <div style={{ width: "38px" }}></div>
              </div>
            )}
            {(userDetails?.roles?.order_records.edit_all ||
              (userDetails?.roles?.order_records.edit_own &&
                userDetails.id == record.user)) &&
            record?.status == "Approved" &&
            !record?.priority &&
            record?.pending != 0 ? (
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={"Split this order"}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Button
                    onClick={() => {
                      handleSplitAction(record);
                    }}
                  >
                    <Iconmoon icon={"Mapping"} size={17} color="#605E5C" />
                  </Button>
                </Tooltip>
              </Styled>
            ) : (
              <div style={{ display: "flex" }}>
                <div style={{ width: "38px" }}></div>
              </div>
            )}
            {["On Hold", "Complete", "Approved"].includes(record?.status) ? (
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={"View Production Details"}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Button
                    onClick={() => {
                      handleViewProdDetailsAction(record);
                    }}
                  >
                    <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" /> 
                  </Button>
                </Tooltip>
              </Styled>
            ) : (
              <div style={{ display: "flex" }}>
                <div style={{ width: "38px" }}></div>
              </div>
            )} */}

            {
              //   [
              //   "Approved",
              //   "On Hold",
              //   "Complete",
              // ].includes(record?.status) ?
              <Dropdown
                overlay={
                  <Menu>
                    {(userDetails?.roles?.order_records.edit_all ||
                      userDetails?.roles?.order_records.edit_own) &&
                      record?.status == "Active" &&
                      record.isEditAllowed && (
                        <Menu.Item key="1" style={{ padding: "0px 12px" }}>
                          <Button
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                            onClick={() => {
                              handlePriorityAction(record);
                            }}
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "8px" }}>
                                <Iconmoon
                                  icon={
                                    record.priority
                                      ? "low-priority"
                                      : "high-priority"
                                  }
                                  size={17}
                                  color={
                                    record.priority ? "#ea4e2c" : "#3fbd61"
                                  }
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "5px", marginLeft: "6px" }}
                              >
                                {record.priority
                                  ? "Remove Priority"
                                  : "Prioritize this order"}
                              </div>
                            </div>
                          </Button>
                        </Menu.Item>
                      )}
                    {(userDetails?.roles?.order_records.edit_all ||
                      (userDetails?.roles?.order_records.edit_own &&
                        userDetails.id == record.user)) &&
                      record?.status == "Active" &&
                      !record?.priority &&
                      record?.pendingQuantityValue != 0 &&
                      record.isEditAllowed && (
                        <Menu.Item key="2" style={{ padding: "0px 12px" }}>
                          <Button
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                            onClick={() => {
                              handleSplitAction(record);
                            }}
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "8px" }}>
                                <Iconmoon
                                  icon={"Mapping"}
                                  size={17}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "5px", marginLeft: "6px" }}
                              >
                                Split this order
                              </div>
                            </div>
                          </Button>
                        </Menu.Item>
                      )}
                    {record.status !== "Cancelled" &&
                      record?.split_type != "auto" &&
                      record.split_group &&
                      record.status == "Active" &&
                      !record?.priority &&
                      record.completed == 0 &&
                      record.in_production == 0 &&
                      record.in_process == 0 &&
                      record.parent &&
                      record.isEditAllowed && (
                        <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
                          <DisabledButtonStyle>
                            <Button
                              style={{
                                border: "none",
                                background: "none",
                                padding: "0",
                                font: "inherit",
                                textAlign: "left",
                                width: "100%",
                                color: "black",
                              }}
                              className="themeBtn noBg"
                              onClick={() =>
                                onMergeOrderHandler(record, "menuEle")
                              }
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <div style={{ marginTop: "-1px" }}>
                                  <Iconmoon
                                    icon={"export"}
                                    size={14}
                                    color="#605E5C"
                                  />{" "}
                                </div>
                                <div
                                  style={{
                                    marginTop: "-3px",
                                    marginLeft: "11px",
                                  }}
                                >
                                  Merge order
                                </div>
                              </div>
                            </Button>
                          </DisabledButtonStyle>
                        </Menu.Item>
                      )}
                    {record.status == "Active" &&
                      record.isEditAllowed &&
                      record.pendingQuantityValue > 0 && (
                        <Menu.Item key="4" style={{ marginBottom: "-10px" }}>
                          <Button
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                            onClick={() =>
                              handleCancelledQuantityAction(record)
                            }
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "0px" }}>
                                <Iconmoon
                                  icon={"wrong"}
                                  size={15}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "-2px", marginLeft: "6px" }}
                              >
                                Cancel Quantity
                              </div>
                            </div>
                          </Button>
                        </Menu.Item>
                      )}
                    {["On Hold", "Approved"].includes(record?.status) && (
                      <Menu.Item key="5" style={{ padding: "0px 12px" }}>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => {
                            handleViewProdDetailsAction(record);
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "8px" }}>
                              <Iconmoon
                                icon={"production"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "5px", marginLeft: "6px" }}
                            >
                              View Production Details
                            </div>
                          </div>
                        </Button>
                      </Menu.Item>
                    )}
                    {["On Hold", "Approved"].includes(record?.status) && (
                      <Menu.Item key="6" style={{ padding: "0px 12px" }}>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => {
                            handleViewProcessedQtyDetails(record);
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "8px" }}>
                              <Iconmoon
                                icon={"viewPODetails"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "5px", marginLeft: "6px" }}
                            >
                              View Processed Quantity Details
                            </div>
                          </div>
                        </Button>
                      </Menu.Item>
                    )}

                    {[
                      "On Hold",
                      "Approved",
                      "Open",
                      "Changes Req",
                      "Pending",
                    ].includes(record?.status) && (
                      <Menu.Item key="7" style={{ padding: "0px 12px" }}>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => {
                            handleViewPendingQtyDetails(record);
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "8px" }}>
                              <Iconmoon
                                icon={"viewPODetails"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "5px", marginLeft: "6px" }}
                            >
                              View Pending Quantity Details
                            </div>
                          </div>
                        </Button>
                      </Menu.Item>
                    )}

                    <Menu.Item key="8" style={{ marginBottom: "-10px" }}>
                      <DisabledButtonStyle>
                        <Button
                          onClick={() => {
                            onViewPODetailsHandler(record);
                          }}
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "0px" }}>
                              <Iconmoon
                                icon={"viewPODetails"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-2px", marginLeft: "6px" }}
                            >
                              {record.category === "PO"
                                ? "View PO Details"
                                : "View SO Details"}
                            </div>
                          </div>
                        </Button>{" "}
                      </DisabledButtonStyle>
                    </Menu.Item>
                    <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
                      <DisabledButtonStyle>
                        <Button
                          onClick={() => {
                            onViewChangeHandler(record);
                          }}
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "0px" }}>
                              <Iconmoon
                                icon={"changeHistory"}
                                size={19}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-2px", marginLeft: "5px" }}
                            >
                              View Change History
                            </div>
                          </div>
                        </Button>{" "}
                      </DisabledButtonStyle>
                    </Menu.Item>
                    {record.status == "Provisional" && record.isEditAllowed ? (
                      <Menu.Item key="10" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            onClick={() => handleDelete(record)}
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "0px" }}>
                                <Iconmoon
                                  icon={"delete"}
                                  size={15}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "-2px", marginLeft: "6px" }}
                              >
                                Delete Order
                              </div>
                            </div>
                          </Button>{" "}
                        </DisabledButtonStyle>
                      </Menu.Item>
                    ) : (
                      ""
                    )}
                    {(!switchFetchOrdersfromERP && (record.status == "Active" &&
                      record.processQuantity?.split(" ")[0] == 0) ||
                    record.status == "On Hold" ||
                    record.status == "Pending Confirmation" ||
                    record.status == "Changes Requested" ||
                    (record.status == "Confirmation Rejected" && record.isEditAllowed)) ? (
                      <Menu.Item key="11" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            onClick={() => handleCancel(record)}
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "0px" }}>
                                <Iconmoon
                                  icon={"wrong"}
                                  size={15}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "-2px", marginLeft: "6px" }}
                              >
                                Cancel Order
                              </div>
                            </div>
                          </Button>{" "}
                        </DisabledButtonStyle>
                      </Menu.Item>
                    ) : (
                      ""
                    )}
                    {record.status == "Active" &&
                    record.isEditAllowed &&
                    record.pendingQuantityValue ? (
                      <Menu.Item key="12" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            onClick={() => handleHold(record)}
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div
                                style={{ marginTop: "0px", marginLeft: "2px" }}
                              >
                                <Iconmoon
                                  icon={"hold"}
                                  size={14}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "-2px", marginLeft: "9px" }}
                              >
                                Hold Order
                              </div>
                            </div>
                          </Button>{" "}
                        </DisabledButtonStyle>
                      </Menu.Item>
                    ) : (
                      ""
                    )}
                    {record.status == "On Hold" && record.isEditAllowed ? (
                      <Menu.Item key="13" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            onClick={() => handleRelease(record)}
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "0px" }}>
                                <Iconmoon
                                  icon={"production"}
                                  size={17}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "-2px", marginLeft: "6px" }}
                              >
                                Release Order
                              </div>
                            </div>
                          </Button>{" "}
                        </DisabledButtonStyle>
                      </Menu.Item>
                    ) : (
                      ""
                    )}
                    <></>
                  </Menu>
                }
                placement="bottom"
                arrow
              >
                <DisabledButtonStyle>
                  <Button>
                    <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
                  </Button>
                </DisabledButtonStyle>
              </Dropdown>
              //   : (
              //   <div style={{ display: "flex" }}>
              //     <div style={{ width: "38px" }}></div>
              //   </div>
              // )
            }
          </div>
        ) : (
          "-"
        ),
      align: "center",
    },
  ];
  const fullColumnsNonApproverHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "6%",
      fixed: "left",
      align: "left",
      sorter: () => {},
      // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
      render: (text, record) => (
                <div className="" style={{display:"flex",alignItems:'center'}} >
          {record.isConflictingstate? (
       <span style={{paddingBottom:'5px'}}> <Tooltip title= {`Conflicting order, part of ${record.jobcards?.length} conflicting job cards`} placement="top" >
                <Iconmoon icon="info_new" size={16} color="#EA655B" />
        </Tooltip>
        </span>
      ) : (
        // Invisible placeholder to maintain layout
        <span style={{ width: "16px" }}></span>
      )}
          <Button
            style={{ background: "transparent" }}
            className="textTypeBtn textBtnIcon"
            onClick={() => handlePo(record)}
          >
            <div
              style={{
                whiteSpace: "normal",
                lineHeight: "1.2",
                textAlign: "left",
              }}
            >
              {`#${
                record.category === "PO"
                  ? toHandlePOName(record.pono)
                  : toHandlePOName(record.sono)
              }`
                .match(/.{1,15}/g)
                ?.map((chunk, index) => (
                  <span key={index}>
                    {chunk}
                    <br />
                  </span>
                ))}
            </div>
          </Button>
        </div>
      ),
    },
    // {
    //   title: "Group No",
    //   dataIndex: "groupno",
    //   width: "5.6%",
    //   fixed: "left",
    //   sorter: () => { },
    // },
    {
      title: "Order No",
      dataIndex: "orderno",
      key: "orderno",
      width: "8%",
      fixed: "left",
      sorter: () => {},
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
      render: (text, record) => (
        <div className="actionBtn2">
          {record?.previous_state?.old &&
          record?.previous_state?.new &&
          (record?.previous_state?.old === "review" ||
            record?.previous_state?.old === "approved" ||
            record?.previous_state?.old === "cancel") &&
          record.status === "Pending Confirmation" ? (
            // <Styled >
            <TooltipSelector>
              <Tooltip
                overlayInnerStyle={{
                  borderRadius: "8px",
                  background: "rgba(32, 31, 30, 0.85)",
                  padding: "7px",
                  background: "rgba(32, 31, 30, 0.85)",
                  fontFamily: "var(--sf-pro-display-m)",
                  fontStyle: "normal",
                  fontSize: "12px",
                  lineHeight: "16px",
                }}
                placement="bottomRight"
                title={
                  record?.previous_state?.old === "review"
                    ? "This order has been sent for approval again. Changes were requested in this order previously."
                    : record?.previous_state?.old === "cancel"
                    ? "This order has been sent for approval again. This order was cancelled previously."
                    : "This order has been sent for approval again. This order was approved previously."
                }
                // getPopupContainer={(triggerNode) => triggerNode}
                overlayClassName="edit-tooltip"
              >
                <Button
                  style={{ background: "transparent" }}
                  className="textTypeBtn textBtnIcon"
                  onClick={() => handleViewAction(record)}
                >
                  {`${text}`}
                </Button>
              </Tooltip>
            </TooltipSelector>
          ) : text != "-" ? (
            // </Styled>
            <Button
              style={{ background: "transparent" }}
              className="textTypeBtn textBtnIcon"
              onClick={() => handleViewAction(record)}
            >
              {`${text}`}
            </Button>
          ) : (
            <span style={{ textAlign: "center" }}>{text}</span>
          )}
          {record?.previous_state?.old &&
            record?.previous_state?.new &&
            (record?.previous_state?.old === "review" ||
              record?.previous_state?.old === "approved" ||
              record?.previous_state?.old === "cancel") &&
            record.status === "Pending Confirmation" && (
              <div>
                <span
                  style={{
                    color: "rgb(234, 101, 91)",
                    fontStyle: "italic",
                    fontSize: "10px",
                  }}
                >
                  Resent for approval
                </span>
              </div>
            )}
        </div>
      ),
    },
    {
      title: "PO/SO Date",
      dataIndex: "poDate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => {
          const dateA = new Date(a.category === "SO" ? a.soDate : a.poDate);
          const dateB = new Date(b.category === "SO" ? b.soDate : b.poDate);
          return dateA - dateB;
        },
      },
      render: (text, record) =>
        record.category === "SO" ? record.soDate : record.poDate,
    },
    { title: "Category", dataIndex: "category", width: "7%", align: "left" },

    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customerName}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.consignee}-${record.consignee_name}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.consignee_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    // {
    //   title: "Prod. Code",
    //   dataIndex: "productcode",
    //   width: "5.8%",
    // },
    {
      title: (
        <div>
          Product
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={`The product specification is in the format of ${format}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      // render: (text, record) => (
      //   <Styled>
      //     {" "}
      //     <span style={{ fontSize: "10px" }}>{record.productspec} </span>
      //     <br />
      //     <span style={{ textAlign: "center" }}>{record.productcode}</span>
      //   </Styled>
      // ),
      //dataIndex: "productspec",
      // title: "Product",
      dataIndex: "product_spec",
      width: "10.8%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5.8%",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    {
      title: "PLY",
      dataIndex: "ply",
      width: "8.4%",
    },
    {
      title: <span>Order<br/>Quantity</span>,
      dataIndex: "quantity",
      width: "7.4%",
      render: (text, record) => (
        <Styled>
          {" "}
          {record.type.toLowerCase() == "sheet" &&
          record.quantity_type.toLowerCase() == "reel_sheet" ? (
            <>
              <span style={{ textAlign: "center" }}>{text}</span>
              <br /> <span> {record.no_of_sheets + " Sheets"} </span>
            </>
          ) : (
            `${text} `
          )}
        </Styled>
      ),
    },
    {
      title: <span>Balance<br/>Quantity</span>,
      dataIndex: "balance_qty",
      width: "7.4%",
    },
    {
      title: <span>Processed<br/>Quantity</span>,
      dataIndex: "processQuantity",
      width: "10%",
      render: (text, record) => {
        return (
          // <div
          //   className="actionBtn"
          //   style={{ marginTop: "14px", justifyContent: "left" }}
          // >
          <Row className="acitonBtn">
            <Col span={17} style={{alignContent:'center'}}>
              {/* {parseFloat(text) && record.type ? (
                <span dangerouslySetInnerHTML={{ __html: text }} />
              ) : parseFloat(text) ? (
                `${text} `
              ) : (
                "-"
              )} */}
              {parseFloat(text) && record.type
                ? `${text.replace("<br/>","")}`
                : parseFloat(text)
                ? `${text.replace("<br/>","")} `
                : "-"}
            </Col>
            
            {parseFloat(text) ? (
              <Col span={7}>
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={"View Processed Quantity Details"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleViewProcessedQtyAction(record);
                      }}
                    >
                      <Iconmoon
                        icon="viewPODetails"
                        size={16}
                        color="rgb(96, 94, 92)"
                      />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            ) : (
              ""
            )}
            </Row>
          // </div>
        );
      },
    },
    {
      title: <span>Pending<br/>Quantity</span>,
      dataIndex: "pendingQuantity",
      width: "10%",
      render: (text, record) => {
        return (
          // <div
          //   className="actionBtn"
          //   style={{ marginTop: "11px", justifyContent: "left" }}
          // >
          record.isConflictingstate?<Row className="actionBtn" style={{display:"flex",justifyContent:"start"}}>
            <Col span={17} style={{alignContent:"center"}}>
            <span>ND</span>
            </Col>
            </Row>:
          <Row className="actionBtn">
            <Col span={17} style={{alignContent:"center"}}>
              {parseFloat(text) && record.type
                ? `${text}`
                : parseFloat(text)
                ? `${text} `
                : "-"}
            </Col>
            {parseFloat(text) && ["On Hold", "Approved"].includes(record?.status)  ? (
              <Col span={7}>
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={"View Pending Quantity Details"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleViewPendingQtyAction(record);
                      }}
                    >
                      <Iconmoon
                        icon="viewPODetails"
                        size={16}
                        color="rgb(96, 94, 92)"
                      />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            ) : (
                            <span style={{width:"16px"}}></span>

            )}
            </Row>
          // </div>
        );
      },
    },
    {
      title: <span>Cancelled<br/>Quantity</span>,
      dataIndex: "cancelledQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text}`
          : "-",
    },
    // {
    //   title: "Order Weight",
    //   dataIndex: "weight",
    //   width: "9%",
    //   render: (text, record) =>
    //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
    // },
    // {
    //   title: "Planned Weight",
    //   dataIndex: "plannedweight",
    //   width: "9%",
    //   render: (text, record) =>
    //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
    // },
    // {
    //   title: "Core ID",
    //   dataIndex: "coreid",
    //   width: "6%",
    //   render: (text, record) =>
    //     parseFloat(text.split(" ")[0]) ? record.coreid : "-",
    // },
    // {
    //   title: "Reel OD",
    //   dataIndex: "reelod",
    //   width: "6%",
    //   render: (text, record, index) => (
    //     <Styled>
    //       <div style={{ display: "flex" }}>
    //         {record.id_od_type == "range" && (
    //           <div
    //             style={{
    //               color: "var(--para-text)",
    //               display: "flex",
    //               width: "100%",
    //               alignSelf: "center",
    //             }}
    //           >
    //             {record.minimum_reel_od +
    //               "-" +
    //               record.maximum_reel_od +
    //               " " +
    //               lengthUnit[record.units.maximum_reel_od].displayName}
    //           </div>
    //         )}
    //         {record.id_od_type == "constant" && (
    //           <div
    //             style={{
    //               display: "flex",
    //               width: "70%",
    //               flexDirection: "column",
    //               alignSelf: "center",
    //             }}
    //           >
    //             {record.reelod &&
    //               record.reelod?.map((item, index) => {
    //                 return (
    //                   index < 2 && (
    //                     <div>
    //                       {item}{" "}
    //                       {index == 1
    //                         ? "...,"
    //                         : record.reelod.length > 1
    //                         ? ","
    //                         : ""}
    //                     </div>
    //                   )
    //                 );
    //               })}

    //             {record.reelod &&
    //               record.reelod?.length >= 2 &&
    //               record.reelod?.map((item, index) => {
    //                 let tooltipData = "";
    //                 for (
    //                   let index = 2;
    //                   index < record.reelod?.length;
    //                   index++
    //                 ) {
    //                   const data = record.reelod[index];
    //                   tooltipData = tooltipData + data + ", ";
    //                 }
    //                 tooltipData = tooltipData.substring(
    //                   0,
    //                   tooltipData.length - 1
    //                 );
    //                 return (
    //                   index == 2 && (
    //                     <Tooltip title={tooltipData}>
    //                       {" "}
    //                       <span
    //                         style={{
    //                           display: "flex",
    //                           fontSize: "10px",
    //                           fontWeight: "bold",
    //                         }}
    //                       >
    //                         & {record.reelod.length - 2} More
    //                       </span>
    //                     </Tooltip>
    //                   )
    //                 );
    //               })}
    //           </div>
    //         )}
    //       </div>
    //     </Styled>
    //   ),
    // },
    // {
    //   title: "Rewinder Reels",
    //   dataIndex: "rewinder_reels",
    //   width: "9%",
    //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
    // },
    // {
    //   title: "QUO.PRICE",
    //   dataIndex: "price",
    //   width: "8%",
    //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
    // },
    {
      title: "Price",
      width: "8%",
      dataIndex: "netprice",
      render: (text, record) => (
        <Styled>
          {record.category === "SO" ? (
            "-"
          ) : (
            <>
              {record.type !== "reel" &&
                record.quantity_type !== "reel_sheet" && (
                  <span style={{ fontSize: "10px" }}>{record.netprice}</span>
                )}
              <br />
              <span style={{ textAlign: "center" }}>
                Rate: {record.dealerPrice}
              </span>
            </>
          )}
        </Styled>
      ),
      // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
    },
    {
      title: "Delivery Date",
      dataIndex: "deliverydate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
      // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
    },
    {
      title: "Created Date",
      dataIndex: "createddate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
      },
      // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
    },
    {
      title: "Approver By",
      dataIndex: "approvedby",
      width: "6.4%",
      align: "center",
      render: (text, record) =>
        record.status === "Provisional" || record.status === "Pending Confirmation" ? "-" : text,
    },
    {
      title: "Priority",
      dataIndex: "priority",
      width: "5%",
      render: (text, record) => (
        <div className="actionBtn">
          <Button style={{ cursor: "default" }}>
            <Iconmoon
              icon={record.priority ? "correct" : "wrong"}
              size={16}
              color={record.priority ? "#3FBD61" : "#a19f9d"}
            />
          </Button>
        </div>
      ),
      align: "center",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "6%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={record.remarks}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button style={{ cursor: "default" }}>
                <Iconmoon icon="message" size={16} color="#EA655B" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "status",
      width: "7.6%",
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.status === "Changes Requested"
                  ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
                  : record.status === "Active"
                  ? "The order has been approved"
                  : record.status === "Pending Confirmation"
                  ? "The order is pending for approval"
                  : record.status === "Provisional"
                  ? "The order is not sent for approval yet. Go to PO to send orders for approval"
                  : record.status === "Confirmation Rejected"
                  ? "The order is rejected by the approver. Click on View Order to see approver remarks"
                  : record.status === "On Hold"
                  ? "The order has been put on hold by the approver"
                  : record.status === "Cancelled"
                  ? "The order has been cancelled"
                  : record.status === "Merged"
                  ? "The quantity in this order is merged with other orders"
                  : record.status === "Produced"
                  ? "The order has been produced"
                  : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {" "}
              {record.status === "In_production" ? "Active" : record.status}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Progress",
      dataIndex: "progress",
      width: "6.8%",
      render: (text, record) => {
        // if(record.item_type && record.item_type === "order"){
             if(!record.isConflictingstate){

        if (
          record?.order_type === "sheet" ||
          (record?.order_type === "reel" && record?.quantity_type === "weight")
        ) {
          const totalProd =
            ((record?.progressbar_info?.completed?.weight +
              record?.progressbar_info?.in_production?.weight) /
              (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
            100;
          const totalCompleted =
            (record?.progressbar_info?.completed?.weight /
              (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
            100;
          //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${
                    record?.progressbar_info?.completed
                      ? (record?.progressbar_info?.completed?.weight).toFixed(3)
                      : 0.0
                  } ${capitalize(
                    weightUnit[
                      record?.progressbar_info?.completed?.units?.weight
                    ].displayName
                  )} Weight produced
                          ${
                            record?.progressbar_info?.in_production
                              ? (record?.progressbar_info?.in_production?.weight).toFixed(
                                  3
                                )
                              : 0.0
                          } ${capitalize(
                    weightUnit[
                      record?.progressbar_info?.in_production?.units?.weight
                    ].displayName
                  )} Weight in production
                        ${
                          record?.progressbar_info?.pending
                            ? (record?.progressbar_info?.pending?.weight).toFixed(
                                3
                              )
                            : 0.0
                        } ${capitalize(
                    weightUnit[record?.progressbar_info?.pending?.units?.weight]
                      .displayName
                  )} Weight pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={totalProd}
                    success={{
                      percent: totalCompleted,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        } else {
          const production =
            ((record?.progressbar_info?.completed?.quantity +
              record?.progressbar_info?.in_production?.quantity) /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;
          const completed =
            (record?.progressbar_info?.completed?.quantity /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;

          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${
                    record?.progressbar_info?.completed
                      ? record?.progressbar_info?.completed?.quantity
                      : 0
                  } Reels produced
                          ${
                            record?.progressbar_info?.in_production
                              ? record?.progressbar_info?.in_production
                                  ?.quantity
                              : 0
                          } Reels in production
                          ${
                            record?.progressbar_info?.pending
                              ? record?.progressbar_info?.pending?.quantity
                              : 0
                          } Reels pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={production}
                    success={{
                      percent: completed,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        }
      }
      },
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "9%",
      render: (text, record) =>
        record.item_type === "order" ? (
          <div className="actionBtn">
            {!["Active", "Confirmation Rejected", "On Hold"].includes(record?.status) &&
              (userDetails?.roles?.order_records.edit_all ||
                (userDetails?.roles?.order_records.edit_own &&
                  userDetails.id == record.user)) &&
              record.isEditAllowed && (
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={"Edit this order"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleEditAction(record);
                      }}
                    >
                      <Iconmoon icon="edit" size={16} color="#605E5C" />
                    </Button>
                  </Tooltip>
                </Styled>
              )}
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View details of this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handleViewAction(record);
                  }}
                >
                  <Iconmoon icon="file-view" size={16} color="#605E5C" />
                </Button>
              </Tooltip>
            </Styled>
            {/* {((userDetails?.roles?.order_records.edit_all) || (userDetails?.roles?.order_records.edit_own)) ? (
          <Styled>
              <Tooltip
                placement="bottomRight"
                title={record.priority ? "Remove priority" : "Prioritize this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handlePriorityAction(record);
                  }}
                >
                  <Iconmoon 
                  // icon={"edit"} size={17} color="#A19F9D" />
                  icon={record.priority ? "low-priority" : "high-priority"}
                  size={16}
                  color={record.priority ? "#ea4e2c" : "#3fbd61"}/>
                </Button>
              </Tooltip>
            </Styled>
          ) : (
            <div style={{ width: "38px" }}></div>
          )} */}
            {/* {(((userDetails?.roles?.order_records.edit_all) || ((userDetails?.roles?.order_records.edit_own) && (userDetails.id == record.user))) && ((record?.status == "Approved") && (!record?.priority) && (record?.pending != 0))) ? (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"Split this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handleSplitAction(record);
                  }}
                >
                  <Iconmoon icon={"Mapping"} size={16} color="#605E5C" />
                </Button>
              </Tooltip>
            </Styled>
          ) : (
            <div style={{ width: "38px" }}></div>
          )}           */}
            {
              //   [
              //   "Approved",
              //   "On Hold",
              //   "Complete",
              // ].includes(record?.status) ?
              <Dropdown
                overlay={
                  <Menu>
                    {(userDetails?.roles?.order_records.edit_all ||
                      userDetails?.roles?.order_records.edit_own) &&
                      record?.status == "Active" &&
                      record.isEditAllowed && (
                        <Menu.Item key="1" style={{ padding: "0px 12px" }}>
                          <Button
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                            onClick={() => {
                              handlePriorityAction(record);
                            }}
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "8px" }}>
                                <Iconmoon
                                  icon={
                                    record.priority
                                      ? "low-priority"
                                      : "high-priority"
                                  }
                                  size={17}
                                  color={
                                    record.priority ? "#ea4e2c" : "#3fbd61"
                                  }
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "5px", marginLeft: "6px" }}
                              >
                                {record.priority
                                  ? "Remove Priority"
                                  : "Prioritize this order"}
                              </div>
                            </div>
                          </Button>
                        </Menu.Item>
                      )}
                    {(userDetails?.roles?.order_records.edit_all ||
                      (userDetails?.roles?.order_records.edit_own &&
                        userDetails.id == record.user)) &&
                      record?.status == "Active" &&
                      !record?.priority &&
                      record?.pendingQuantityValue != 0 &&
                      record.isEditAllowed && (
                        <Menu.Item key="2" style={{ padding: "0px 12px" }}>
                          <Button
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                            onClick={() => {
                              handleSplitAction(record);
                            }}
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "8px" }}>
                                <Iconmoon
                                  icon={"Mapping"}
                                  size={17}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "5px", marginLeft: "6px" }}
                              >
                                Split this order
                              </div>
                            </div>
                          </Button>
                        </Menu.Item>
                      )}
                    {record.status !== "Cancelled" &&
                      record?.split_type != "auto" &&
                      record.split_group &&
                      record.status == "Active" &&
                      !record?.priority &&
                      record.completed == 0 &&
                      record.in_production == 0 &&
                      record.in_process == 0 &&
                      record.parent &&
                      record.isEditAllowed && (
                        <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
                          <DisabledButtonStyle>
                            <Button
                              style={{
                                border: "none",
                                background: "none",
                                padding: "0",
                                font: "inherit",
                                textAlign: "left",
                                width: "100%",
                                color: "black",
                              }}
                              className="themeBtn noBg"
                              onClick={() =>
                                onMergeOrderHandler(record, "menuEle")
                              }
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <div style={{ marginTop: "-1px" }}>
                                  <Iconmoon
                                    icon={"export"}
                                    size={14}
                                    color="#605E5C"
                                  />{" "}
                                </div>
                                <div
                                  style={{
                                    marginTop: "-3px",
                                    marginLeft: "11px",
                                  }}
                                >
                                  Merge order
                                </div>
                              </div>
                            </Button>
                          </DisabledButtonStyle>
                        </Menu.Item>
                      )}
                    {record.status == "Active" &&
                      record.pendingQuantityValue > 0 &&
                      record.isEditAllowed && (
                        <Menu.Item key="4" style={{ marginBottom: "-10px" }}>
                          <Button
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                            onClick={() =>
                              handleCancelledQuantityAction(record)
                            }
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "0px" }}>
                                <Iconmoon
                                  icon={"wrong"}
                                  size={15}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "-2px", marginLeft: "6px" }}
                              >
                                Cancel Quantity
                              </div>
                            </div>
                          </Button>
                        </Menu.Item>
                      )}
                    {["On Hold", "Approved"].includes(record?.status) && (
                      <Menu.Item key="5" style={{ padding: "0px 12px" }}>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => {
                            handleViewProdDetailsAction(record);
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "8px" }}>
                              <Iconmoon
                                icon={"production"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "5px", marginLeft: "6px" }}
                            >
                              View Production Details
                            </div>
                          </div>
                        </Button>
                      </Menu.Item>
                    )}
                    {["On Hold", "Approved"].includes(record?.status) ? (
                      <Menu.Item key="6" style={{ padding: "0px 12px" }}>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => {
                            handleViewProcessedQtyDetails(record);
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "8px" }}>
                              <Iconmoon
                                icon={"viewPODetails"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "5px", marginLeft: "6px" }}
                            >
                              View Processed Quantity Details
                            </div>
                          </div>
                        </Button>
                      </Menu.Item>
                    ) : (
                      ""
                    )}

                    {[
                      "On Hold",
                      "Approved",
                      "Open",
                      "Changes Req",
                      "Pending",
                    ].includes(record?.status) ? (
                      <Menu.Item key="7" style={{ padding: "0px 12px" }}>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => {
                            handleViewPendingQtyDetails(record);
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "8px" }}>
                              <Iconmoon
                                icon={"viewPODetails"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "5px", marginLeft: "6px" }}
                            >
                              View Pending Quantity Details
                            </div>
                          </div>
                        </Button>
                      </Menu.Item>
                    ) : (
                      ""
                    )}

                    <Menu.Item key="8" style={{ marginBottom: "-10px" }}>
                      <DisabledButtonStyle>
                        <Button
                          onClick={() => {
                            onViewPODetailsHandler(record);
                          }}
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "0px" }}>
                              <Iconmoon
                                icon={"viewPODetails"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-2px", marginLeft: "6px" }}
                            >
                              {record.category === "PO"
                                ? "View PO Details"
                                : "View SO Details"}
                            </div>
                          </div>
                        </Button>{" "}
                      </DisabledButtonStyle>
                    </Menu.Item>
                    <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
                      <DisabledButtonStyle>
                        <Button
                          onClick={() => {
                            onViewChangeHandler(record);
                          }}
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "0px" }}>
                              <Iconmoon
                                icon={"changeHistory"}
                                size={19}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-2px", marginLeft: "5px" }}
                            >
                              View Change History
                            </div>
                          </div>
                        </Button>{" "}
                      </DisabledButtonStyle>
                    </Menu.Item>
                    {record.status == "Provisional" && record.isEditAllowed ? (
                      <Menu.Item key="10" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            onClick={() => handleDelete(record)}
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "0px" }}>
                                <Iconmoon
                                  icon={"delete"}
                                  size={15}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "-2px", marginLeft: "6px" }}
                              >
                                Delete Order
                              </div>
                            </div>
                          </Button>{" "}
                        </DisabledButtonStyle>
                      </Menu.Item>
                    ) : (
                      ""
                    )}
                    {(!switchFetchOrdersfromERP && (record.status == "Active" &&
                      record.processQuantity?.split(" ")[0] == 0) ||
                    record.status == "On Hold" ||
                    record.status == "Pending Confirmation" ||
                    record.status == "Changes Requested" ||
                    (record.status == "Confirmation Rejected" && record.isEditAllowed) )? (
                      <Menu.Item key="11" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            onClick={() => handleCancel(record)}
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "0px" }}>
                                <Iconmoon
                                  icon={"wrong"}
                                  size={15}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "-2px", marginLeft: "6px" }}
                              >
                                Cancel Order
                              </div>
                            </div>
                          </Button>{" "}
                        </DisabledButtonStyle>
                      </Menu.Item>
                    ) : (
                      ""
                    )}
                    {record.status == "Active" &&
                    record.pendingQuantityValue &&
                    record.isEditAllowed ? (
                      <Menu.Item key="12" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            onClick={() => handleHold(record)}
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div
                                style={{ marginTop: "0px", marginLeft: "2px" }}
                              >
                                <Iconmoon
                                  icon={"hold"}
                                  size={14}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "-2px", marginLeft: "9px" }}
                              >
                                Hold Order
                              </div>
                            </div>
                          </Button>{" "}
                        </DisabledButtonStyle>
                      </Menu.Item>
                    ) : (
                      ""
                    )}
                    {record.status == "On Hold" && record.isEditAllowed ? (
                      <Menu.Item key="13" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            onClick={() => handleRelease(record)}
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "0px" }}>
                                <Iconmoon
                                  icon={"production"}
                                  size={17}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "-2px", marginLeft: "6px" }}
                              >
                                Release Order
                              </div>
                            </div>
                          </Button>{" "}
                        </DisabledButtonStyle>
                      </Menu.Item>
                    ) : (
                      ""
                    )}
                  </Menu>
                }
                placement="bottom"
                arrow
              >
                <DisabledButtonStyle>
                  <Button>
                    <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
                  </Button>
                </DisabledButtonStyle>
              </Dropdown>
              //   : (
              //   <div style={{ display: "flex" }}>
              //     <div style={{ width: "38px" }}></div>
              //   </div>
              // )
            }
          </div>
        ) : (
          "-"
        ),
      align: "center",
    },
  ];
  const fullColumnsNonPriorityHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "6%",
      fixed: "left",
      align: "left",
      sorter: () => {},
      // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
      render: (text, record) => (
          <div className="" style={{display:"flex",alignItems:'center'}} >
          {record.isConflictingstate? (
       <span style={{paddingBottom:'5px'}}> <Tooltip title= {`Conflicting order, part of ${record.jobcards?.length} conflicting job cards`} placement="top" >
                <Iconmoon icon="info_new" size={16} color="#EA655B" />
        </Tooltip>
        </span>
      ) : (
        // Invisible placeholder to maintain layout
        <span style={{ width: "16px" }}></span>
      )}
          <Button
            style={{ background: "transparent" }}
            className="textTypeBtn textBtnIcon"
            onClick={() => handlePo(record)}
          >
            <div
              style={{
                whiteSpace: "normal",
                lineHeight: "1.2",
                textAlign: "left",
              }}
            >
              {`#${
                record.category === "PO"
                  ? toHandlePOName(record.pono)
                  : toHandlePOName(record.sono)
              }`
                .match(/.{1,15}/g)
                ?.map((chunk, index) => (
                  <span key={index}>
                    {chunk}
                    <br />
                  </span>
                ))}
            </div>
          </Button>
        </div>
      ),
    },
    // {
    //   title: "Group No",
    //   dataIndex: "groupno",
    //   width: "5.6%",
    //   fixed: "left",
    //   sorter: () => { },
    // },
    {
      title: "Order No",
      dataIndex: "orderno",
      key: "orderno",
      width: "8%",
      fixed: "left",
      sorter: () => {},
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
      render: (text, record) => (
        <div className="actionBtn2">
          {text != "-" ? (
            // </Styled>
            <Button
              style={{ background: "transparent" }}
              className="textTypeBtn textBtnIcon"
              onClick={() => handleViewAction(record)}
            >
              {`${text}`}
            </Button>
          ) : (
            <span style={{ textAlign: "center" }}>{text}</span>
          )}
        </div>
      ),
    },
    {
      title: "PO/SO Date",
      dataIndex: "poDate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => {
          const dateA = new Date(a.category === "SO" ? a.soDate : a.poDate);
          const dateB = new Date(b.category === "SO" ? b.soDate : b.poDate);
          return dateA - dateB;
        },
      },
      render: (text, record) =>
        record.category === "SO" ? record.soDate : record.poDate,
    },
    { title: "Category", dataIndex: "category", width: "7%", align: "left" },

    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customerName}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.consignee}-${record.consignee_name}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.consignee_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    // {
    //   title: "Prod. Code",
    //   dataIndex: "productcode",
    //   width: "5.8%",
    // },
    {
      title: (
        <div>
          Product
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={`The product specification is in the format of ${format}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      // render: (text, record) => (
      //   <Styled>
      //     {" "}
      //     <span style={{ fontSize: "10px" }}>{record.productspec} </span>
      //     <br />
      //     <span style={{ textAlign: "center" }}>{record.productcode}</span>
      //   </Styled>
      // ),
      //dataIndex: "productspec",
      // title: "Product",
      dataIndex: "product_spec",
      width: "10.8%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5.8%",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    {
      title: "PLY",
      dataIndex: "ply",
      width: "8.4%",
    },
    {
      title:<span>Order<br/>Quantity</span>,
      dataIndex: "quantity",
      width: "7.4%",
      render: (text, record) => (
        <Styled>
          {" "}
          {record.type.toLowerCase() == "sheet" &&
          record.quantity_type.toLowerCase() == "reel_sheet" ? (
            <>
              <span style={{ textAlign: "center" }}>{text}</span>
              <br /> <span> {record.no_of_sheets + " Sheets"} </span>
            </>
          ) : (
            `${text} `
          )}
        </Styled>
      ),
    },
    {
      title: <span>Balance<br/>Quantity</span>,
      dataIndex: "balance_qty",
      width: "7.4%",
    },
    {
      title: <span>Processed<br/>Quantity</span>,
      dataIndex: "processQuantity",
      width: "10%",
      render: (text, record) => {
        return (
          // <div
          //   className="actionBtn"
          //   style={{ marginTop: "14px", justifyContent: "left" }}
          // >
           <Row className="actionBtn">
            <Col span={17} style={{alignContent:"center"}}>
              {/* {parseFloat(text) && record.type ? (
                <span dangerouslySetInnerHTML={{ __html: text }} />
              ) : parseFloat(text) ? (
                `${text} `
              ) : (
                "-"
              )} */}
              {parseFloat(text) && record.type
                ? `${text.replace("<br/>","")}`
                : parseFloat(text)
                ? `${text.replace("<br/>","")} `
                : "-"}
            </Col>
            {parseFloat(text) ? (
              <Col span={7}>
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={"View Processed Quantity Details"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleViewProcessedQtyAction(record);
                      }}
                    >
                      <Iconmoon
                        icon="viewPODetails"
                        size={16}
                        color="rgb(96, 94, 92)"
                      />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            ) : (
              ""
            )}
            </Row>
          // </div> 
        );
      },
    },
    {
      title: <span>Pending<br/>Quantity</span>,
      dataIndex: "pendingQuantity",
      width: "10%",
      render: (text, record) => {
        return (
          // <div
          //   className="actionBtn"
          //   style={{ marginTop: "11px", justifyContent: "left" }}
          // >
          record.isConflictingstate?<Row className="actionBtn" style={{display:"flex",justifyContent:"start"}}>
            <Col span={17} style={{alignContent:"center"}}>
            <span>ND</span>
            </Col>
            </Row>:
          <Row className="actionBtn">
            <Col span={17} style={{alignContent:"center"}}>
              {parseFloat(text) && record.type
                ? `${text}`
                : parseFloat(text)
                ? `${text} `
                : "-"}
            </Col>
            {parseFloat(text)&&["On Hold", "Approved"].includes(record?.status)  ? (
              <Col span={7}>
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={"View Production Details"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleViewProdDetailsAction(record);
                      }}
                    >
                      <Iconmoon
                        icon="viewPODetails"
                        size={16}
                        color="rgb(96, 94, 92)"
                      />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            ) : (
                            <span style={{width:"16px"}}></span>

            )}
            </Row>
          // </div>
        );
      },
    },
    {
      title: <span>Cancelled<br/>Quantity</span>,
      dataIndex: "cancelledQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text}`
          : "-",
    },
    // {
    //   title: "Order Weight",
    //   dataIndex: "weight",
    //   width: "9%",
    //   render: (text, record) =>
    //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
    // },
    // {
    //   title: "Planned Weight",
    //   dataIndex: "plannedweight",
    //   width: "9%",
    //   render: (text, record) =>
    //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
    // },
    //   {
    //     title: "Core ID",
    //     dataIndex: "coreid",
    //     width: "6%",
    //     render: (text, record) =>
    //       parseFloat(text.split(" ")[0]) ? record.coreid : "-",
    //   },
    //   {
    //     title: "Reel OD",
    //     dataIndex: "reelod",
    //     width: "6%",
    //     render: (text, record, index) => (
    //       <Styled>
    //         <div style={{ display: "flex" }}>
    //           {record.id_od_type == "range" && (
    //             <div
    //               style={{
    //                 color: "var(--para-text)",
    //                 display: "flex",
    //                 width: "100%",
    //                 alignSelf: "center",
    //               }}
    //             >
    //               {record.minimum_reel_od +
    //                 "-" +
    //                 record.maximum_reel_od +
    //                 " " +
    //                 lengthUnit[record.units.maximum_reel_od].displayName}
    //             </div>
    //           )}
    //           {record.id_od_type == "constant" && (
    //             <div
    //               style={{
    //                 display: "flex",
    //                 width: "70%",
    //                 flexDirection: "column",
    //                 alignSelf: "center",
    //               }}
    //             >
    //               {record.reelod &&
    //                 record.reelod?.map((item, index) => {
    //                   return (
    //                     index < 2 && (
    //                       <div>
    //                         {item}{" "}
    //                         {index == 1
    //                           ? "...,"
    //                           : record.reelod.length > 1
    //                           ? ","
    //                           : ""}
    //                       </div>
    //                     )
    //                   );
    //                 })}

    //               {record.reelod &&
    //                 record.reelod?.length >= 2 &&
    //                 record.reelod?.map((item, index) => {
    //                   let tooltipData = "";
    //                   for (
    //                     let index = 2;
    //                     index < record.reelod?.length;
    //                     index++
    //                   ) {
    //                     const data = record.reelod[index];
    //                     tooltipData = tooltipData + data + ", ";
    //                   }
    //                   tooltipData = tooltipData.substring(
    //                     0,
    //                     tooltipData.length - 1
    //                   );
    //                   return (
    //                     index == 2 && (
    //                       <Tooltip title={tooltipData}>
    //                         {" "}
    //                         <span
    //                           style={{
    //                             display: "flex",
    //                             fontSize: "10px",
    //                             fontWeight: "bold",
    //                           }}
    //                         >
    //                           & {record.reelod.length - 2} More
    //                         </span>
    //                       </Tooltip>
    //                     )
    //                   );
    //                 })}
    //             </div>
    //           )}
    //         </div>
    //       </Styled>
    //     )
    //  },
    // {
    //   title: "Rewinder Reels",
    //   dataIndex: "rewinder_reels",
    //   width: "9%",
    //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
    // },
    // {
    //   title: "QUO.PRICE",
    //   dataIndex: "price",
    //   width: "8%",
    //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
    // },
    {
      title: "Price",
      width: "8%",
      dataIndex: "netprice",
      render: (text, record) => (
        <Styled>
          {record.category === "SO" ? (
            "-"
          ) : (
            <>
              {record.type !== "reel" &&
                record.quantity_type !== "reel_sheet" && (
                  <span style={{ fontSize: "10px" }}>{record.netprice}</span>
                )}
              <br />
              <span style={{ textAlign: "center" }}>
                Rate: {record.dealerPrice}
              </span>
            </>
          )}
        </Styled>
      ),
      // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
    },
    {
      title: "Delivery Date",
      dataIndex: "deliverydate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
      // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
    },
    {
      title: "Created Date",
      dataIndex: "createddate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
      },
      // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
    },
    {
      title: "Approver By",
      dataIndex: "approvedby",
      width: "5.8%",
    },
    {
      title: "Priority",
      dataIndex: "priority",
      width: "5%",
      render: (text, record) => (
        <div className="actionBtn">
          <Button style={{ cursor: "default" }}>
            <Iconmoon
              icon={record.priority ? "correct" : "wrong"}
              size={16}
              color={record.priority ? "#3FBD61" : "#a19f9d"}
            />
          </Button>
        </div>
      ),
      align: "center",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "6%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={record.remarks}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button style={{ cursor: "default" }}>
                <Iconmoon icon="message" size={16} color="#EA655B" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "status",
      width: "7.6%",
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.status === "Changes Requested"
                  ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
                  : record.status === "Active"
                  ? "The order has been approved"
                  : record.status === "Pending Confirmation"
                  ? "The order is pending for approval"
                  : record.status === "Provisional"
                  ? "The order is not sent for approval yet. Go to PO to send orders for approval"
                  : record.status === "Confirmation Rejected"
                  ? "The order is rejected by the approver. Click on View Order to see approver remarks"
                  : record.status === "On Hold"
                  ? "The order has been put on hold by the approver"
                  : record.status === "Cancelled"
                  ? "The order has been cancelled"
                  : record.status === "Merged"
                  ? "The quantity in this order is merged with other orders"
                  : record.status === "Produced"
                  ? "The order has been produced"
                  : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {" "}
              {record.status === "In_production" ? "Active" : record.status}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Progress",
      dataIndex: "progress",
      width: "6.8%",
      render: (text, record) => {
        // if(record.item_type && record.item_type === "order"){
          if(!record.isConflictingstate){
        if (
          record?.order_type === "sheet" ||
          (record?.order_type === "reel" && record?.quantity_type === "weight")
        ) {
          const totalProd =
            ((record?.progressbar_info?.completed?.weight +
              record?.progressbar_info?.in_production?.weight) /
              (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
            100;
          const totalCompleted =
            (record?.progressbar_info?.completed?.weight /
              (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
            100;
          //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${
                    record?.progressbar_info?.completed
                      ? (record?.progressbar_info?.completed?.weight).toFixed(3)
                      : 0.0
                  } ${capitalize(
                    weightUnit[
                      record?.progressbar_info?.completed?.units?.weight
                    ].displayName
                  )} Weight produced
                          ${
                            record?.progressbar_info?.in_production
                              ? (record?.progressbar_info?.in_production?.weight).toFixed(
                                  3
                                )
                              : 0.0
                          } ${capitalize(
                    weightUnit[
                      record?.progressbar_info?.in_production?.units?.weight
                    ].displayName
                  )} Weight in production
                        ${
                          record?.progressbar_info?.pending
                            ? (record?.progressbar_info?.pending?.weight).toFixed(
                                3
                              )
                            : 0.0
                        } ${capitalize(
                    weightUnit[record?.progressbar_info?.pending?.units?.weight]
                      .displayName
                  )} Weight pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={totalProd}
                    success={{
                      percent: totalCompleted,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        } else {
          const production =
            ((record?.progressbar_info?.completed?.quantity +
              record?.progressbar_info?.in_production?.quantity) /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;
          const completed =
            (record?.progressbar_info?.completed?.quantity /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;

          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${
                    record?.progressbar_info?.completed
                      ? record?.progressbar_info?.completed?.quantity
                      : 0
                  } Reels produced
                          ${
                            record?.progressbar_info?.in_production
                              ? record?.progressbar_info?.in_production
                                  ?.quantity
                              : 0
                          } Reels in production
                          ${
                            record?.progressbar_info?.pending
                              ? record?.progressbar_info?.pending?.quantity
                              : 0
                          } Reels pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={production}
                    success={{
                      percent: completed,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        }
      }
      },
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "9%",
      render: (text, record) =>
        record.item_type === "order" ? (
          <div className="actionBtn">
            {!["Active", "Confirmation Rejected", "On Hold", "Cancelled"].includes(
              record?.status
            ) &&
              (userDetails?.roles?.order_records.edit_all ||
                (userDetails?.roles?.order_records.edit_own &&
                  userDetails.id == record.user)) &&
              record.isEditAllowed && (
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={"Edit this order"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleEditAction(record);
                      }}
                    >
                      <Iconmoon icon="edit" size={16} color="#605E5C" />
                    </Button>
                  </Tooltip>
                </Styled>
              )}
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View details of this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handleViewAction(record);
                  }}
                >
                  <Iconmoon icon="file-view" size={16} color="#605E5C" />
                </Button>
              </Tooltip>
            </Styled>
            {/* {((userDetails?.roles?.order_records.edit_all) || (userDetails?.roles?.order_records.edit_own)) ? (
          <Styled>
              <Tooltip
                placement="bottomRight"
                title={record.priority ? "Remove Priority" : "Prioritize this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handlePriorityAction(record);
                  }}
                >
                  <Iconmoon 
                  // icon={"edit"} size={17} color="#A19F9D" />
                  icon={record.priority ? "low-priority" : "high-priority"}
                  size={17}
                  color={record.priority ? "#ea4e2c" : "#3fbd61"}/>
                  </Button>
              </Tooltip>
            </Styled>
          ) : (
            <div style={{ width: "38px" }}></div>
          )} */}
            {/* {(((userDetails?.roles?.order_records.edit_all) || ((userDetails?.roles?.order_records.edit_own) && (userDetails.id == record.user))) && ((record?.status == "Approved") && (!record?.priority) && (record?.pending != 0))) ? (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"Split this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handleSplitAction(record);
                  }}
                >
                  <Iconmoon icon={"Mapping"} size={17} color="#605E5C" />
                </Button>
              </Tooltip>
            </Styled>
          ) : (
            <div style={{ width: "38px" }}></div>
          )}           */}
            {
              //   [
              //   "Approved",
              //   "On Hold",
              //   "Complete",
              // ].includes(record?.status) ?
              <Dropdown
                overlay={
                  <Menu>
                    {(userDetails?.roles?.order_records.edit_all ||
                      userDetails?.roles?.order_records.edit_own) &&
                      record?.status == "Active" &&
                      record.isEditAllowed && (
                        <Menu.Item key="1" style={{ padding: "0px 12px" }}>
                          <Button
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                            onClick={() => {
                              handlePriorityAction(record);
                            }}
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "8px" }}>
                                <Iconmoon
                                  icon={
                                    record.priority
                                      ? "low-priority"
                                      : "high-priority"
                                  }
                                  size={17}
                                  color={
                                    record.priority ? "#ea4e2c" : "#3fbd61"
                                  }
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "5px", marginLeft: "6px" }}
                              >
                                {record.priority
                                  ? "Remove Priority"
                                  : "Prioritize this order"}
                              </div>
                            </div>
                          </Button>
                        </Menu.Item>
                      )}
                    {(userDetails?.roles?.order_records.edit_all ||
                      (userDetails?.roles?.order_records.edit_own &&
                        userDetails.id == record.user)) &&
                      record?.status == "Active" &&
                      !record?.priority &&
                      record?.pendingQuantityValue != 0 &&
                      record.isEditAllowed && (
                        <Menu.Item key="2" style={{ padding: "0px 12px" }}>
                          <Button
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                            onClick={() => {
                              handleSplitAction(record);
                            }}
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "8px" }}>
                                <Iconmoon
                                  icon={"Mapping"}
                                  size={17}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "5px", marginLeft: "6px" }}
                              >
                                Split this order
                              </div>
                            </div>
                          </Button>
                        </Menu.Item>
                      )}
                    {record.status !== "Cancelled" &&
                      record?.split_type != "auto" &&
                      record.split_group &&
                      record.status == "Active" &&
                      !record?.priority &&
                      record.completed == 0 &&
                      record.in_production == 0 &&
                      record.in_process == 0 &&
                      record.parent &&
                      record.isEditAllowed && (
                        <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
                          <DisabledButtonStyle>
                            <Button
                              style={{
                                border: "none",
                                background: "none",
                                padding: "0",
                                font: "inherit",
                                textAlign: "left",
                                width: "100%",
                                color: "black",
                              }}
                              className="themeBtn noBg"
                              onClick={() =>
                                onMergeOrderHandler(record, "menuEle")
                              }
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <div style={{ marginTop: "-1px" }}>
                                  <Iconmoon
                                    icon={"export"}
                                    size={14}
                                    color="#605E5C"
                                  />{" "}
                                </div>
                                <div
                                  style={{
                                    marginTop: "-3px",
                                    marginLeft: "11px",
                                  }}
                                >
                                  Merge order
                                </div>
                              </div>
                            </Button>
                          </DisabledButtonStyle>
                        </Menu.Item>
                      )}
                    {record.status == "Active" &&
                      record.pendingQuantityValue > 0 &&
                      record.isEditAllowed && (
                        <Menu.Item key="4" style={{ marginBottom: "-10px" }}>
                          <Button
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                            onClick={() =>
                              handleCancelledQuantityAction(record)
                            }
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "0px" }}>
                                <Iconmoon
                                  icon={"wrong"}
                                  size={15}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "-2px", marginLeft: "6px" }}
                              >
                                Cancel Quantity
                              </div>
                            </div>
                          </Button>
                        </Menu.Item>
                      )}
                    {["On Hold", "Approved"].includes(record?.status) && (
                      <Menu.Item key="5" style={{ padding: "0px 12px" }}>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => {
                            handleViewProdDetailsAction(record);
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "8px" }}>
                              <Iconmoon
                                icon={"production"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "5px", marginLeft: "6px" }}
                            >
                              View Production Details
                            </div>
                          </div>
                        </Button>
                      </Menu.Item>
                    )}

                    {["On Hold", "Approved"].includes(record?.status) && (
                      <Menu.Item key="6" style={{ padding: "0px 12px" }}>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => {
                            handleViewProcessedQtyDetails(record);
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "8px" }}>
                              <Iconmoon
                                icon={"viewPODetails"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "5px", marginLeft: "6px" }}
                            >
                              View Processed Quantity Details
                            </div>
                          </div>
                        </Button>
                      </Menu.Item>
                    )}

                    {[
                      "On Hold",
                      "Approved",
                      "Open",
                      "Changes Req",
                      "Pending",
                    ].includes(record?.status) && (
                      <Menu.Item key="7" style={{ padding: "0px 12px" }}>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => {
                            handleViewPendingQtyDetails(record);
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "8px" }}>
                              <Iconmoon
                                icon={"viewPODetails"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "5px", marginLeft: "6px" }}
                            >
                              View Pending Quantity Details
                            </div>
                          </div>
                        </Button>
                      </Menu.Item>
                    )}

                    <Menu.Item key="8" style={{ marginBottom: "-10px" }}>
                      <DisabledButtonStyle>
                        <Button
                          onClick={() => {
                            onViewPODetailsHandler(record);
                          }}
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "0px" }}>
                              <Iconmoon
                                icon={"viewPODetails"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-2px", marginLeft: "6px" }}
                            >
                              {record.category === "PO"
                                ? "View PO Details"
                                : "View SO Details"}
                            </div>
                          </div>
                        </Button>{" "}
                      </DisabledButtonStyle>
                    </Menu.Item>
                    <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
                      <DisabledButtonStyle>
                        <Button
                          onClick={() => {
                            onViewChangeHandler(record);
                          }}
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "0px" }}>
                              <Iconmoon
                                icon={"changeHistory"}
                                size={19}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-2px", marginLeft: "5px" }}
                            >
                              View Change History
                            </div>
                          </div>
                        </Button>{" "}
                      </DisabledButtonStyle>
                    </Menu.Item>
                    {record.status == "Provisional" && record.isEditAllowed ? (
                      <Menu.Item key="10" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            onClick={() => handleDelete(record)}
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "0px" }}>
                                <Iconmoon
                                  icon={"delete"}
                                  size={15}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "-2px", marginLeft: "6px" }}
                              >
                                Delete Order
                              </div>
                            </div>
                          </Button>{" "}
                        </DisabledButtonStyle>
                      </Menu.Item>
                    ) : (
                      ""
                    )}
                    {(!switchFetchOrdersfromERP && (record.status == "Active" &&
                      record.processQuantity?.split(" ")[0] == 0) ||
                    record.status == "On Hold" ||
                    record.status == "Pending Confirmation" ||
                    record.status == "Changes Requested" ||
                    (record.status == "Confirmation Rejected" && record.isEditAllowed) )? (
                      <Menu.Item key="11" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            onClick={() => handleCancel(record)}
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "0px" }}>
                                <Iconmoon
                                  icon={"wrong"}
                                  size={15}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "-2px", marginLeft: "6px" }}
                              >
                                Cancel Order
                              </div>
                            </div>
                          </Button>{" "}
                        </DisabledButtonStyle>
                      </Menu.Item>
                    ) : (
                      ""
                    )}
                    {(record.status == "Approved" || record.status == "Active") &&
                    record.pendingQuantityValue &&
                    record.isEditAllowed ? (
                      <Menu.Item key="12" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            onClick={() => handleHold(record)}
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div
                                style={{ marginTop: "0px", marginLeft: "2px" }}
                              >
                                <Iconmoon
                                  icon={"hold"}
                                  size={14}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "-2px", marginLeft: "9px" }}
                              >
                                Hold Order
                              </div>
                            </div>
                          </Button>{" "}
                        </DisabledButtonStyle>
                      </Menu.Item>
                    ) : (
                      ""
                    )}
                    {record.status == "On Hold" && record.isEditAllowed ? (
                      <Menu.Item key="13" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            onClick={() => handleRelease(record)}
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "0px" }}>
                                <Iconmoon
                                  icon={"production"}
                                  size={17}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "-2px", marginLeft: "6px" }}
                              >
                                Release Order
                              </div>
                            </div>
                          </Button>{" "}
                        </DisabledButtonStyle>
                      </Menu.Item>
                    ) : (
                      ""
                    )}
                  </Menu>
                }
                placement="bottom"
                arrow
              >
                <DisabledButtonStyle>
                  <Button>
                    <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
                  </Button>
                </DisabledButtonStyle>
              </Dropdown>
              //   : (
              //   <div style={{ display: "flex" }}>
              //     <div style={{ width: "38px" }}></div>
              //   </div>
              // )
            }
          </div>
        ) : (
          "-"
        ),
      align: "center",
    },
  ];
  const fullColumnsNonStatusHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "6%",
      fixed: "left",
      key: "pono",
      align: "left",
      sorter: () => {},
      // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
      render: (text, record) => (
               <div className="" style={{display:"flex",alignItems:'center'}} >
          {record.isConflictingstate? (
       <span style={{paddingBottom:'5px'}}> <Tooltip title= {`Conflicting order, part of ${record.jobcards?.length} conflicting job cards`} placement="top" >
                <Iconmoon icon="info_new" size={16} color="#EA655B" />
        </Tooltip>
        </span>
      ) : (
        // Invisible placeholder to maintain layout
        <span style={{ width: "16px" }}></span>
      )}
          <Button
            style={{ background: "transparent" }}
            className="textTypeBtn textBtnIcon"
            onClick={() => handlePo(record)}
          >
            <div
              style={{
                whiteSpace: "normal",
                lineHeight: "1.2",
                textAlign: "left",
              }}
            >
              {`#${
                record.category === "PO"
                  ? toHandlePOName(record.pono)
                  : toHandlePOName(record.sono)
              }`
                .match(/.{1,15}/g)
                ?.map((chunk, index) => (
                  <span key={index}>
                    {chunk}
                    <br />
                  </span>
                ))}
            </div>
          </Button>
        </div>
      ),
    },
    // {
    //   title: "Group No",
    //   dataIndex: "groupno",
    //   width: "6%",
    //   fixed: "left",
    //   sorter: () => { },
    // },
    {
      title: "Order No",
      dataIndex: "orderno",
      key: "orderno",
      width: "8%",
      fixed: "left",
      sorter: () => {},
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
      render: (text, record) => (
        <div className="actionBtn2">
          {text != "-" ? (
            // </Styled>
            <Button
              style={{ background: "transparent" }}
              className="textTypeBtn textBtnIcon"
              onClick={() => handleViewAction(record)}
            >
              {`${text}`}
            </Button>
          ) : (
            <span style={{ textAlign: "center" }}>{text}</span>
          )}
        </div>
      ),
    },
    {
      title: "PO/SO Date",
      dataIndex: "poDate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => {
          const dateA = new Date(a.category === "SO" ? a.soDate : a.poDate);
          const dateB = new Date(b.category === "SO" ? b.soDate : b.poDate);
          return dateA - dateB;
        },
      },
      render: (text, record) =>
        record.category === "SO" ? record.soDate : record.poDate,
    },
    { title: "Category", dataIndex: "category", width: "7%", align: "left" },

    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customerName}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.consignee}-${record.consignee_name}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.consignee_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    // {
    //   title: "Prod. Code",
    //   dataIndex: "productcode",
    //   width: "5.8%",
    // },
    {
      title: (
        <div>
          Product
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={`The product specification is in the format of ${format}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      // render: (text, record) => (
      //   <Styled>
      //     {" "}
      //     <span style={{ fontSize: "10px" }}>{record.productspec} </span>
      //     <br />
      //     <span style={{ textAlign: "center" }}>{record.productcode}</span>
      //   </Styled>
      // ),
      // //dataIndex: "productspec",
      // width: "10.8%",
      // title: "Product",
      dataIndex: "product_spec",
      width: "10.8%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5.8%",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    {
      title: "PLY",
      dataIndex: "ply",
      width: "8.4%",
    },
    {
      title: <span>Order<br/>Quantity</span>,
      dataIndex: "quantity",
      width: "7.4%",
      render: (text, record) => (
        <Styled>
          {" "}
          {record.type.toLowerCase() == "sheet" &&
          record.quantity_type.toLowerCase() == "reel_sheet" ? (
            <>
              <span style={{ textAlign: "center" }}>{text}</span>
              <br /> <span> {record.no_of_sheets + " Sheets"} </span>
            </>
          ) : (
            `${text} `
          )}
        </Styled>
      ),
    },
    {
      title: <span>Balance<br/>Quantity</span>,
      dataIndex: "balance_qty",
      width: "7.4%",
    },
    {
      title: <span>Processed<br/>Quantity</span>,
      dataIndex: "processQuantity",
      width: "10%",
      render: (text, record) => {
        return (
          // <div
          //   className="actionBtn"
          //   style={{ marginTop: "14px", justifyContent: "left" }}
          // >
          <Row className="actionBtn">
            <Col span={17} style={{alignContent:"center"}}>
              {/* {parseFloat(text) && record.type ? (
                <span dangerouslySetInnerHTML={{ __html: text }} />
              ) : parseFloat(text) ? (
                `${text} `
              ) : (
                "-"
              )} */}
              {parseFloat(text) && record.type
                ? `${text.replace("<br/>","")}`
                : parseFloat(text)
                ? `${text.replace("<br/>","")} `
                : "-"}
            </Col>
            {parseFloat(text) ? (
              <Col span={7}>
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={"View Processed Quantity Details"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleViewProcessedQtyAction(record);
                      }}
                    >
                      <Iconmoon
                        icon="viewPODetails"
                        size={16}
                        color="rgb(96, 94, 92)"
                      />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            ) : (
              ""
            )}
            </Row>
          // </div>
        );
      },
    },
    {
      title: <span>Pending<br/>Quantity</span>,
      dataIndex: "pendingQuantity",
      width: "10%",
      render: (text, record) => {
        return (
          // <div
          //   className="actionBtn"
          //   style={{ marginTop: "11px", justifyContent: "left" }}
          // >
          record.isConflictingstate?<Row className="actionBtn" style={{display:"flex",justifyContent:"start"}}>
            <Col span={17} style={{alignContent:"center"}}>
            <span>ND</span>
            </Col>
            </Row>:
          <Row className="actionBtn">
            <Col span={17} style={{alignContent:"center"}}>
              {parseFloat(text) && record.type
                ? `${text}`
                : parseFloat(text)
                ? `${text} `
                : "-"}
            </Col>
            {parseFloat(text)&&["On Hold", "Approved"].includes(record?.status)  ? (
              <Col span={7}>
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={"View Production Details"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleViewProdDetailsAction(record);
                      }}
                    >
                      <Iconmoon
                        icon="viewPODetails"
                        size={16}
                        color="rgb(96, 94, 92)"
                      />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            ) : (
                            <span style={{width:"16px"}}></span>

            )}
            </Row>
          // </div>
        );
      },
    },
    {
      title: <span>Cancelled<br/>Quantity</span>,
      dataIndex: "cancelledQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text}`
          : "-",
    },
    // {
    //   title: "Order Weight",
    //   dataIndex: "weight",
    //   width: "9%",
    //   render: (text, record) =>
    //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
    // },
    // {
    //   title: "Planned Weight",
    //   dataIndex: "plannedweight",
    //   width: "9%",
    //   render: (text, record) =>
    //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
    // },

    // {
    //   title: "Reel OD",
    //   dataIndex: "reelod",
    //   width: "6%",
    //   render: (text, record, index) => (
    //     <Styled>
    //       <div style={{ display: "flex" }}>
    //         {record.id_od_type == "range" && (
    //           <div
    //             style={{
    //               color: "var(--para-text)",
    //               display: "flex",
    //               width: "100%",
    //               alignSelf: "center",
    //             }}
    //           >
    //             {record.minimum_reel_od +
    //               "-" +
    //               record.maximum_reel_od +
    //               " " +
    //               lengthUnit[record.units.maximum_reel_od].displayName}
    //           </div>
    //         )}
    //         {record.id_od_type == "constant" && (
    //           <div
    //             style={{
    //               display: "flex",
    //               width: "70%",
    //               flexDirection: "column",
    //               alignSelf: "center",
    //             }}
    //           >
    //             {record.reelod &&
    //               record.reelod?.map((item, index) => {
    //                 return (
    //                   index < 2 && (
    //                     <div>
    //                       {item}{" "}
    //                       {index == 1
    //                         ? "...,"
    //                         : record.reelod.length > 1
    //                         ? ","
    //                         : ""}
    //                     </div>
    //                   )
    //                 );
    //               })}

    //             {record.reelod &&
    //               record.reelod?.length >= 2 &&
    //               record.reelod?.map((item, index) => {
    //                 let tooltipData = "";
    //                 for (
    //                   let index = 2;
    //                   index < record.reelod?.length;
    //                   index++
    //                 ) {
    //                   const data = record.reelod[index];
    //                   tooltipData = tooltipData + data + ", ";
    //                 }
    //                 tooltipData = tooltipData.substring(
    //                   0,
    //                   tooltipData.length - 1
    //                 );
    //                 return (
    //                   index == 2 && (
    //                     <Tooltip title={tooltipData}>
    //                       {" "}
    //                       <span
    //                         style={{
    //                           display: "flex",
    //                           fontSize: "10px",
    //                           fontWeight: "bold",
    //                         }}
    //                       >
    //                         & {record.reelod.length - 2} More
    //                       </span>
    //                     </Tooltip>
    //                   )
    //                 );
    //               })}
    //           </div>
    //         )}
    //       </div>
    //     </Styled>
    //   ),
    // },
    // {
    //   title: "Core ID",
    //   dataIndex: "coreid",
    //   width: "6%",
    //   render: (text, record) =>
    //     parseFloat(text.split(" ")[0]) ? record.coreid : "-",
    // },
    // {
    //   title: "Rewinder Reels",
    //   dataIndex: "rewinder_reels",
    //   width: "9%",
    //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
    // },
    // {
    //   title: "QUO.PRICE",
    //   dataIndex: "price",
    //   width: "8%",
    //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
    // },
    {
      title: "Price",
      width: "8%",
      dataIndex: "netprice",
      render: (text, record) => (
        <Styled>
          {record.category === "SO" ? (
            "-"
          ) : (
            <>
              {record.type !== "reel" &&
                record.quantity_type !== "reel_sheet" && (
                  <span style={{ fontSize: "10px" }}>{record.netprice}</span>
                )}
              <br />
              <span style={{ textAlign: "center" }}>
                Rate: {record.dealerPrice}
              </span>
            </>
          )}
        </Styled>
      ),
      // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
    },
    {
      title: "Delivery Date",
      dataIndex: "deliverydate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
      // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
    },
    {
      title: "Created Date",
      dataIndex: "createddate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
      },
      // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
    },
    {
      title: "Approver By",
      dataIndex: "approvedby",
      width: "6.4%",
      align: "center",
      render: (text, record) =>
        record.status === "Provisional" || record.status === "Pending Confirmation" ? "-" : text,
    },
    // {
    //   title: "Priority",
    //   dataIndex: "priority",
    //   width: "5%",
    //   render: (text, record) => (
    //     <div className="actionBtn">
    //       <Button style={{ cursor: "default" }}>
    //         <Iconmoon
    //           icon={record.priority ? "correct" : "wrong"}
    //           size={16}
    //           color={record.priority ? "#3FBD61" : "#a19f9d"}
    //         />
    //       </Button>
    //     </div>
    //   ),
    //   align: "center",
    // },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "6%",
      render: (text, record) =>
        record.item_type === "order" ? (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={record.remarks}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button style={{ cursor: "default" }}>
                  <Iconmoon icon="message" size={16} color="#EA655B" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ) : (
          "-"
        ),
      align: "center",
    },
    {
      title: "Priority",
      dataIndex: "priority",
      width: "5%",
      render: (text, record) => (
        <div className="actionBtn">
          <Button style={{ cursor: "default" }}>
            <Iconmoon
              icon={record.priority ? "correct" : "wrong"}
              size={16}
              color={record.priority ? "#3FBD61" : "#a19f9d"}
            />
          </Button>
        </div>
      ),
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "status",
      width: "7.6%",
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.status === "Changes Requested"
                  ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
                  : record.status === "Active"
                  ? "The order has been approved"
                  : record.status === "Pending Confirmation"
                  ? "The order is pending for approval"
                  : record.status === "Provisional"
                  ? "The order is not sent for approval yet. Go to PO to send orders for approval"
                  : record.status === "Confirmation Rejected"
                  ? "The order is rejected by the approver. Click on View Order to see approver remarks"
                  : record.status === "On Hold"
                  ? "The order has been put on hold by the approver"
                  : record.status === "Cancelled"
                  ? "The order has been cancelled"
                  : record.status === "Merged"
                  ? "The quantity in this order is merged with other orders"
                  : record.status === "Produced"
                  ? "The order has been produced"
                  : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {" "}
              {record.status === "In_production" ? "Active" : record.status}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Progress",
      dataIndex: "progress",
      width: "6.8%",
      render: (text, record) => {
             if(!record.isConflictingstate){
        if (
          record?.order_type === "sheet" ||
          (record?.order_type === "reel" && record?.quantity_type === "weight")
        ) {
          const totalProd =
            ((record?.progressbar_info?.completed?.weight +
              record?.progressbar_info?.in_production?.weight) /
              (parseFloat(record.weight) -
                record?.cancelled_quantity?.weight)) *
            100;
          const totalCompleted =
            (record?.progressbar_info?.completed?.weight /
              (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
            100;
          //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${
                    record?.progressbar_info?.completed
                      ? (record?.progressbar_info?.completed?.weight).toFixed(3)
                      : 0.0
                  } ${capitalize(
                    weightUnit[
                      record?.progressbar_info?.completed?.units?.weight
                    ].displayName
                  )} Weight produced
                          ${
                            record?.progressbar_info?.in_production
                              ? (record?.progressbar_info?.in_production?.weight).toFixed(
                                  3
                                )
                              : 0.0
                          } ${capitalize(
                    weightUnit[
                      record?.progressbar_info?.in_production?.units?.weight
                    ].displayName
                  )} Weight in production
                        ${
                          record?.progressbar_info?.pending
                            ? (record?.progressbar_info?.pending?.weight).toFixed(
                                3
                              )
                            : 0.0
                        } ${capitalize(
                    weightUnit[record?.progressbar_info?.pending?.units?.weight]
                      .displayName
                  )} Weight pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={totalProd}
                    success={{
                      percent: totalCompleted,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        } else {
          const production =
            ((record?.progressbar_info?.completed?.quantity +
              record?.progressbar_info?.in_production?.quantity) /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;
          const completed =
            (record?.progressbar_info?.completed?.quantity /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;

          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${
                    record?.progressbar_info?.completed
                      ? record?.progressbar_info?.completed?.quantity
                      : 0
                  } Reels produced
                          ${
                            record?.progressbar_info?.in_production
                              ? record?.progressbar_info?.in_production
                                  ?.quantity
                              : 0
                          } Reels in production
                          ${
                            record?.progressbar_info?.pending
                              ? record?.progressbar_info?.pending?.quantity
                              : 0
                          } Reels pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={production}
                    success={{
                      percent: completed,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        }
      }
      },
      
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "11%",
      render: (text, record) =>
        record.item_type === "order" ? (
          <div className="actionBtn">
            {record.isEditAllowed &&
            !["Confirmation Rejected", "On Hold", "Produced"].includes(record?.status) &&
            (userDetails?.roles?.order_records.edit_all ||
              userDetails?.roles?.order_records.edit_own) &&
            (((record?.status == "Approved" || record?.status == "Active") &&
              record?.completed == 0 &&
              record?.in_production == 0) ||
              (record?.status !== "Approved" || record?.status !== "Active")) ? (
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={"Edit this order"}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Button
                    onClick={() => {
                      handleEditAction(record);
                    }}
                  >
                    <Iconmoon icon="edit" size={16} color="#605E5C" />
                  </Button>
                </Tooltip>
              </Styled>
            ) : (
              <div style={{ display: "flex" }}>
                <div style={{ width: "38px" }}></div>
              </div>
            )}
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View details of this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handleViewAction(record);
                  }}
                >
                  <Iconmoon icon="file-view" size={16} color="#605E5C" />
                </Button>
              </Tooltip>
            </Styled>
            {/* {(((userDetails?.roles?.order_records.edit_all) || (userDetails?.roles?.order_records.edit_own)) && (record?.status == "Approved")) ? (
          <Styled>
              <Tooltip
                placement="bottomRight"
                title={record.priority ? "Remove Priority" : "Prioritize this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handlePriorityAction(record);
                  }}
                >
                  <Iconmoon 
                  // icon={"edit"} size={17} color="#A19F9D" 
                  icon={record.priority ? "low-priority" : "high-priority"}
                  size={17}
                  color={record.priority ? "#ea4e2c" : "#3fbd61"}/>
                </Button>
              </Tooltip>
            </Styled>
          ) : (
            <div style={{ display: "flex" }}>
              <div style={{ width: "38px" }}></div>
            </div>
          )}
          {(((userDetails?.roles?.order_records.edit_all) || ((userDetails?.roles?.order_records.edit_own) && (userDetails.id == record.user))) && ((record?.status == "Approved") && (!record?.priority) && (record?.pending != 0))) ? (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"Split this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handleSplitAction(record);
                  }}
                >
                  <Iconmoon icon={"Mapping"} size={14} color="#605E5C" />
                </Button>
              </Tooltip>
            </Styled>
          ) : (
            <div style={{ display: "flex" }}>
              <div style={{ width: "38px" }}></div>
            </div>
          )}
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View Production Details"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleViewProdDetailsAction(record);
                }}
              >
                <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
              </Button>
            </Tooltip>
          </Styled>           */}
            {/* <Dropdown
                overlay={
                  <Menu>
                    
                      { (userDetails?.roles?.order_records.edit_all ||
              userDetails?.roles?.order_records.edit_own) &&
            record?.status == "Approved"  && (
               <Menu.Item key="1" style={{padding: "0px 12px"}}
            >
                      <Button
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color : 'black',
                      }}
                      className="themeBtn noBg"
                        onClick={() => {
                          handlePriorityAction(record);
                        }}
                      >
                        <div style={{display: "flex", flexDirection: "row"}}>
                          <div style={{marginTop: "8px"}}>
                        <Iconmoon
                          icon={record.priority ? "low-priority" : "high-priority"}
                          size={17}
                          color={record.priority ? "#ea4e2c" : "#3fbd61"}
                        /> </div><div style={{marginTop: "5px", marginLeft: "6px"}}>{
                          record.priority
                            ? "Remove Priority"
                            : "Prioritize this order"
                        }</div>
                        
                        </div>
                      </Button>
                      </Menu.Item>
                     )
                    }
                    { 
                      (userDetails?.roles?.order_records.edit_all ||
                        (userDetails?.roles?.order_records.edit_own &&
                          userDetails.id == record.user)) &&
                      record?.status == "Approved" &&
                      !record?.priority &&
                      record?.pending != 0  && ( <Menu.Item key="3" style={{padding: "0px 12px"}}>
                            <Button
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color : 'black',
                            }}
                            className="themeBtn noBg"
                              onClick={() => {
                                handleSplitAction(record);
                              }}
                            >
                              <div style={{display: "flex", flexDirection: "row"}}>
                                <div style={{marginTop: "8px"}}>
                              <Iconmoon
                                icon={"Mapping"}
                                size={17}
                                color="#605E5C"
                              /> </div><div style={{marginTop: "5px", marginLeft: "6px"}}>Split this order</div>
                              
                              </div>
                            </Button>
                        </Menu.Item>) 
                        
                    }
                    {
                     ["On Hold", "Complete", "Approved"].includes(record?.status) && ( <Menu.Item key="3" style={{padding: "0px 12px"}}>
                      <Button
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color : 'black',
                      }}
                      className="themeBtn noBg"
                      onClick={() => {
                        handleViewProdDetailsAction(record);
                      }}
                      >
                        <div style={{display: "flex", flexDirection: "row"}}>
                          <div style={{marginTop: "8px"}}>
                        <Iconmoon
                          icon={"production"}
                          size={17}
                          color="#605E5C"
                        /> </div><div style={{marginTop: "5px", marginLeft: "6px"}}>View Production Details</div>
                        
                        </div>
                      </Button>
                      </Menu.Item>)
                    }
                    { (["Approved"].includes(record?.status) && record.pendingQuantityValue > 0 ) && ( <Menu.Item key="4" style={{padding: "0px 12px"}}>
                        <Button
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color : 'black',
                        }}
                        className="themeBtn noBg"
                        onClick={() => {
                          handleCancelledQuantityAction(record);
                        }}
                        >
                          <div style={{display: "flex", flexDirection: "row"}}>
                            <div style={{marginTop: "8px"}}>
                          <Iconmoon
                            icon={"production"}
                            size={17}
                            color="#605E5C"
                          /> </div><div style={{marginTop: "5px", marginLeft: "6px"}}>Cancel Quantity</div>
                          
                          </div>
                        </Button>
                        </Menu.Item>)}
                  </Menu>
                }
                placement="bottom"
                arrow
              >
                <DisabledButtonStyle>
                <Button
                  
                >
                  <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
                </Button>
                </DisabledButtonStyle>
              </Dropdown> */}
            {
              //   [
              //   "Approved",
              //   "On Hold",
              //   "Complete",
              // ].includes(record?.status) ?
              <Dropdown
                overlay={
                  <Menu>
                    {(userDetails?.roles?.order_records.edit_all ||
                      userDetails?.roles?.order_records.edit_own) &&
                      (record.status == "Approved" || record.status == "Active") &&
                      record.isEditAllowed && (
                        <Menu.Item key="1" style={{ padding: "0px 12px" }}>
                          <Button
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                            onClick={() => {
                              handlePriorityAction(record);
                            }}
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "8px" }}>
                                <Iconmoon
                                  icon={
                                    record.priority
                                      ? "low-priority"
                                      : "high-priority"
                                  }
                                  size={17}
                                  color={
                                    record.priority ? "#ea4e2c" : "#3fbd61"
                                  }
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "5px", marginLeft: "6px" }}
                              >
                                {record.priority
                                  ? "Remove Priority"
                                  : "Prioritize this order"}
                              </div>
                            </div>
                          </Button>
                        </Menu.Item>
                      )}
                    {(userDetails?.roles?.order_records.edit_all ||
                      (userDetails?.roles?.order_records.edit_own &&
                        userDetails.id == record.user)) &&
                      (record.status == "Approved" || record.status == "Active") &&
                      !record?.priority &&
                      record?.pendingQuantityValue != 0 &&
                      record.isEditAllowed && (
                        <Menu.Item key="2" style={{ padding: "0px 12px" }}>
                          <Button
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                            onClick={() => {
                              handleSplitAction(record);
                            }}
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "8px" }}>
                                <Iconmoon
                                  icon={"Mapping"}
                                  size={17}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "5px", marginLeft: "6px" }}
                              >
                                Split this order
                              </div>
                            </div>
                          </Button>
                        </Menu.Item>
                      )}
                    {record.status !== "Cancelled" &&
                      record?.split_type != "auto" &&
                      record.split_group &&
                      (record.status == "Approved" || record.status == "Active") &&
                      !record?.priority &&
                      record.completed == 0 &&
                      record.in_production == 0 &&
                      record.in_process == 0 &&
                      record.parent &&
                      record.isEditAllowed && (
                        <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
                          <DisabledButtonStyle>
                            <Button
                              style={{
                                border: "none",
                                background: "none",
                                padding: "0",
                                font: "inherit",
                                textAlign: "left",
                                width: "100%",
                                color: "black",
                              }}
                              className="themeBtn noBg"
                              onClick={() =>
                                onMergeOrderHandler(record, "menuEle")
                              }
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <div style={{ marginTop: "-1px" }}>
                                  <Iconmoon
                                    icon={"export"}
                                    size={14}
                                    color="#605E5C"
                                  />{" "}
                                </div>
                                <div
                                  style={{
                                    marginTop: "-3px",
                                    marginLeft: "11px",
                                  }}
                                >
                                  Merge order
                                </div>
                              </div>
                            </Button>
                          </DisabledButtonStyle>
                        </Menu.Item>
                      )}
                    {(record.status == "Approved" || record.status == "Active") &&
                      record.pendingQuantityValue > 0 &&
                      record.isEditAllowed && (
                        <Menu.Item key="4" style={{ marginBottom: "-10px" }}>
                          <Button
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                            onClick={() =>
                              handleCancelledQuantityAction(record)
                            }
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "0px" }}>
                                <Iconmoon
                                  icon={"wrong"}
                                  size={15}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "-2px", marginLeft: "6px" }}
                              >
                                Cancel Quantity
                              </div>
                            </div>
                          </Button>
                        </Menu.Item>
                      )}
                    {["On Hold", "Approved"].includes(record?.status) && (
                      <Menu.Item key="5" style={{ padding: "0px 12px" }}>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => {
                            handleViewProdDetailsAction(record);
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "8px" }}>
                              <Iconmoon
                                icon={"production"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "5px", marginLeft: "6px" }}
                            >
                              View Production Details
                            </div>
                          </div>
                        </Button>
                      </Menu.Item>
                    )}

                    {["On Hold", "Approved"].includes(record?.status) && (
                      <Menu.Item key="6" style={{ padding: "0px 12px" }}>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => {
                            handleViewProcessedQtyDetails(record);
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "8px" }}>
                              <Iconmoon
                                icon={"viewPODetails"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "5px", marginLeft: "6px" }}
                            >
                              View Processed Quantity Details
                            </div>
                          </div>
                        </Button>
                      </Menu.Item>
                    )}

                    {[
                      "On Hold",
                      "Approved",
                      "Open",
                      "Changes Req",
                      "Pending",
                    ].includes(record?.status) && (
                      <Menu.Item key="7" style={{ padding: "0px 12px" }}>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => {
                            handleViewPendingQtyDetails(record);
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "8px" }}>
                              <Iconmoon
                                icon={"viewPODetails"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "5px", marginLeft: "6px" }}
                            >
                              View Pending Quantity Details
                            </div>
                          </div>
                        </Button>
                      </Menu.Item>
                    )}

                    <Menu.Item key="8" style={{ marginBottom: "-10px" }}>
                      <DisabledButtonStyle>
                        <Button
                          onClick={() => {
                            onViewPODetailsHandler(record);
                          }}
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "0px" }}>
                              <Iconmoon
                                icon={"viewPODetails"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-2px", marginLeft: "6px" }}
                            >
                              {record.category === "PO"
                                ? "View PO Details"
                                : "View SO Details"}
                            </div>
                          </div>
                        </Button>{" "}
                      </DisabledButtonStyle>
                    </Menu.Item>
                    <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
                      <DisabledButtonStyle>
                        <Button
                          onClick={() => {
                            onViewChangeHandler(record);
                          }}
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "0px" }}>
                              <Iconmoon
                                icon={"changeHistory"}
                                size={19}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-2px", marginLeft: "5px" }}
                            >
                              View Change History
                            </div>
                          </div>
                        </Button>{" "}
                      </DisabledButtonStyle>
                    </Menu.Item>
                    {(record.status == "Open" || record.status == "Provisional") && record.isEditAllowed ? (
                      <Menu.Item key="10" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            onClick={() => handleDelete(record)}
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "0px" }}>
                                <Iconmoon
                                  icon={"delete"}
                                  size={15}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "-2px", marginLeft: "6px" }}
                              >
                                Delete Order
                              </div>
                            </div>
                          </Button>{" "}
                        </DisabledButtonStyle>
                      </Menu.Item>
                    ) : (
                      ""
                    )}
                    {(!switchFetchOrdersfromERP && ((record.status == "Approved" || record.status == "Active") &&
                      record.processQuantity?.split(" ")[0] == 0) ||
                    record.status == "On Hold" ||
                    (record.status == "Pending" || record.status == "Pending Confirmation") ||
                    (record.status == "Changes Req" || record.status == "Changes Requested") ||
                    ((record.status == "Rejected" || record.status == "Confirmation Rejected") && record.isEditAllowed)) ? (
                      <Menu.Item key="11" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            onClick={() => handleCancel(record)}
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "0px" }}>
                                <Iconmoon
                                  icon={"wrong"}
                                  size={15}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "-2px", marginLeft: "6px" }}
                              >
                                Cancel Order
                              </div>
                            </div>
                          </Button>{" "}
                        </DisabledButtonStyle>
                      </Menu.Item>
                    ) : (
                      ""
                    )}
                    {(record.status == "Approved" || record.status == "Active") &&
                    record.pendingQuantityValue &&
                    record.isEditAllowed ? (
                      <Menu.Item key="12" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            onClick={() => handleHold(record)}
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div
                                style={{ marginTop: "0px", marginLeft: "2px" }}
                              >
                                <Iconmoon
                                  icon={"hold"}
                                  size={14}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "-2px", marginLeft: "9px" }}
                              >
                                Hold Order
                              </div>
                            </div>
                          </Button>{" "}
                        </DisabledButtonStyle>
                      </Menu.Item>
                    ) : (
                      ""
                    )}
                    {record.status == "On Hold" && record.isEditAllowed ? (
                      <Menu.Item key="13" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            onClick={() => handleRelease(record)}
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "0px" }}>
                                <Iconmoon
                                  icon={"production"}
                                  size={17}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "-2px", marginLeft: "6px" }}
                              >
                                Release Order
                              </div>
                            </div>
                          </Button>{" "}
                        </DisabledButtonStyle>
                      </Menu.Item>
                    ) : (
                      ""
                    )}
                  </Menu>
                }
                placement="bottom"
                arrow
              >
                <DisabledButtonStyle>
                  <Button>
                    <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
                  </Button>
                </DisabledButtonStyle>
              </Dropdown>
              //   : (
              //   <div style={{ display: "flex" }}>
              //     <div style={{ width: "38px" }}></div>
              //   </div>
              // )
            }
          </div>
        ) : (
          "-"
        ),
      align: "center",
    },
  ];

  const filteredColumns1 = fullColumnsHead.filter(
    (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
  );
  const filteredColumns2 = fullColumnsNonApproverHead.filter(
    (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
  );
  const filteredColumns3 = fullColumnsNonPriorityHead.filter(
    (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
  );
  const filteredColumns4 = fullColumnsNonStatusHead.filter(
    (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
  );

  const columnsHead = useRef(filteredColumns1);
  const columnsNonApproverHead = useRef(filteredColumns2);
  const columnsNonPriorityHead = useRef(filteredColumns3);
  const columnsNonStatusHead = useRef(filteredColumns4);

  const TooltipSelector = styled.div`
    .edit-tooltip .ant-tooltip-inner {
      padding: 7px !important;
      background: rgba(32, 31, 30, 0.85) !important;
      border-radius: 40px !important;
      font-family: var(--sf-pro-display-m);
      font-style: normal;
      font-size: 12px;
      line-height: 16px;
    }
    .edit-tooltip .ant-tooltip-placement-bottomRight .ant-tooltip-arrow {
      top: 3px;
      right: 13px;
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 5px solid black;
    }
    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #ea655b !important;
      border-color: #dfe1e6 !important;
    }
    .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner,
    .ant-checkbox-input:focus + .ant-checkbox-inner {
      border-color: #ea655b !important;
    }
    .ant-checkbox-checked::after {
      border-color: #ea655b !important;
    }
  `;
  const OrderSummary = styled.div`
    .orderSummaryStyle {
      display: block;
      text-align: right;
      padding-bottom: 16px;
      font-size: 14px;
      font-family: var(--sf-pro-display-m);
      color: var(--theme-color);
      line-height: 16px;
    }
    .orderWeightStyle {
      padding-right: 20px;
    }
  `;

  const handleOrder = (record) => {
    history("../order-details", {
      state: {
        values: {
          poNumber: record.pono,
          date: record.poDate,
          customer: record.customercode,
        },
        route: "po-details",
        backKey: "orderRecords",
      },
    });
  };
// const formatted = now.toLocaleString("en-IN", {
//   hour: "2-digit",
//   minute: "2-digit",
//   hour12: true,
//   day: "2-digit",
//   month: "2-digit",
//   year: "numeric",
// });
  const onChange = (pagination, filters, sorter, extra, orderState) => {
    setOrderRecords();
    setLoading(true);
    setClearSearch(true);

    if (currentState.current === "") {
      columnsHead.current?.map((item) => {
        if (item.dataIndex !== sorter?.field) {
          item["sortOrder"] = null;
        }
        if (item.dataIndex == sorter?.field) {
          item["sortOrder"] = sorter ? sorter.order : "";
        }
      });
    }
    if (currentState.current === "open" || currentState.current === "pending") {
      columnsNonApproverHead.current?.map((item) => {
        if (item.dataIndex !== sorter?.field) {
          item["sortOrder"] = null;
        }
        if (item.dataIndex == sorter?.field) {
          item["sortOrder"] = sorter ? sorter.order : "";
        }
      });
    }
    if (
      currentState.current === "review" ||
      currentState.current === "rejected" ||
      currentState.current === "cancel"
    ) {
      columnsNonPriorityHead.current?.map((item) => {
        if (item.dataIndex !== sorter?.field) {
          item["sortOrder"] = null;
        }
        if (item.dataIndex == sorter?.field) {
          item["sortOrder"] = sorter ? sorter.order : "";
        }
      });
    }
    if (
      currentState.current === "approved" ||
      currentState.current === "hold" ||
      currentState.current === "complete"
    ) {
      columnsNonStatusHead.current?.map((item) => {
        if (item.dataIndex !== sorter?.field) {
          item["sortOrder"] = null;
        }
        if (item.dataIndex == sorter?.field) {
          item["sortOrder"] = sorter ? sorter.order : "";
        }
      });
    }

    const currentSorter = sorter.order
      ? {
          sort_by:
            sorter.field === "pono"
              ? "po"
              : sorter.field === "orderno"
              ? "id"
              : sorter.field === "createddate"
              ? "created_at"
              : sorter.field === "deliverydate"
              ? "delivery_date"
              : sorter.field === "groupno"
              ? "split_group"
              : orderState === "rejected" ||
                orderState === "pending" ||
                orderState === "review" ||
                orderState === "hold" ||
                orderState === "cancel"
              ? "updated_at"
              : "updated_at",

          sort_type: sorter.order === "ascend" ? "ascending" : "descending",
        }
      : orderState === "rejected" ||
        orderState === "pending" ||
        orderState === "review" ||
        orderState === "hold" ||
        orderState === "cancel"
      ? {
          sort_by: "updated_at",
          sort_type: "descending",
        }
      : {
          sort_by: "updated_at",
          sort_type: "descending",
        };
    if (
      sorter.field &&
      (currentSorter.sort_type !== sortParams.sort_type ||
        currentSorter.sort_by !== sortParams.sort_by)
    ) {
      setSortParams(currentSorter);
      setCurrentPage(1);
      setPaginationParams({
        page: 1,
        size: pagination.pageSize,
      });
      paginationRef.current = {
        page: 1,
        size: pagination.pageSize,
      };
    } else {
      setCurrentPage(pagination.current);
      setPaginationParams({
        page: pagination.current,
        size: pagination.pageSize,
      });
      paginationRef.current = {
        page: pagination.current,
        size: pagination.pageSize,
      };
    }
    setRendering(true);
  };

  const applyfilter = (filter) => {
    setOrderRecords();
    if (currentState.current === "") {
      columnsHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (currentState.current === "open" || currentState.current === "pending") {
      columnsNonApproverHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (
      currentState.current === "review" ||
      currentState.current === "rejected" ||
      currentState.current === "cancel"
    ) {
      columnsNonPriorityHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (
      currentState.current === "approved" ||
      currentState.current === "hold" ||
      currentState.current === "complete"
    ) {
      columnsNonStatusHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }

    let temp = appliedFilters;
    let alreadySetFilter = false;
    for (let i = 0; i < temp.length; i++) {
      if (temp[i].type === filter.type) {
        temp[i] = filter;
        alreadySetFilter = true;
      }
    }

    setCurrentPage(1);
    if (filter.type == "ply_type") {
      let nameArr = [];
      let obj = {};
      filter?.plyTypes?.map((ele) => {
        let plyName;
        if (ele == 1) {
          plyName = "Single Ply";
        } else if (ele == 2) {
          plyName = "Double Ply";
        } else if (ele == 3) {
          plyName = "3-Ply";
        } else {
          plyName = "4-Ply";
        }
        nameArr.push(plyName);
      });
      obj["plyNames"] = nameArr;
      obj["type"] = "ply";
      obj["ply"] = filter?.plyTypes;
      filter = obj;
    }
    const tempVar = alreadySetFilter ? [...temp] : temp.concat(filter);
    setAppliedFilters(tempVar);
    setFilterTags(tempVar.map(formatFilters));
    paginationRef.current = {
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    };
    setPaginationParams({
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    });
    setRendering(true);

  };

  const formatFilters = (item) => {
    switch (item.type) {
      case "customer":
        const value =
          item.names.length > 1
            ? `${item.names[0]} or ${item.names.length - 1} others`
            : `${item.names[0]}`;
        // const concatString = item.names.join(" or ");
        // const customerToolTip = `Country equals ${concatString}`;
        return {
          type: item.type,
          formattedType: "Customer",
          operand: "equals",
          value,
          // tooltip: customerToolTip,
        };
      case "consignee":
        const consigneeValue =
          item.names.length > 1
            ? `${item.names[0]} or ${item.names.length - 1} others`
            : `${item.names[0]}`;
        // const concatString = item.names.join(" or ");
        // const customerToolTip = `Country equals ${concatString}`;
        return {
          type: item.type,
          formattedType: "Consignee",
          operand: "equals",
          value: consigneeValue,
          // tooltip: customerToolTip,
        };
      case "order_type":
        const typeValue =
          item.order_type === "reel"
            ? "Reel"
            : item.order_type === "sheet"
            ? "Sheet"
            : "Reel or Sheet";
        return {
          type: item.type,
          formattedType: "Order Type",
          operand: "equals",
          value: typeValue,
          // tooltip: `Order Type equals ${typeValue}`,
        };
      case "created_date":
        let dateOperand = "";
        let dateValue = "";
        if (item.start_date === item.end_date) {
          dateOperand = "-";
          dateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          dateOperand = "between";
          dateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Created date",
          operand: dateOperand,
          value: dateValue,
        };
      case "po_date":
        let poDateOperand = "";
        let poDateValue = "";
        if (item.start_date === item.end_date) {
          poDateOperand = "-";
          poDateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          poDateOperand = "between";
          poDateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "PO date",
          operand: poDateOperand,
          value: poDateValue,
        };
      case "delivery_date":
        let deliveryDateOperand = "";
        let deliveryDateValue = "";
        if (item.start_date === item.end_date) {
          deliveryDateOperand = "-";
          deliveryDateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          deliveryDateOperand = "between";
          deliveryDateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Delivery date",
          operand: deliveryDateOperand,
          value: deliveryDateValue,
        };
      case "gsm":
        const gsmValue =
          item.operator === "in_range"
            ? `${item.min_gsm} and ${item.max_gsm}`
            : `${item.gsm}`;
        const gsmOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equals"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: "GSM",
          operand: gsmOperand,
          value: gsmValue,
          // tooltip: `GSM ${gsmOperand} ${gsmValue}`,
        };
      case "burst_factor":
        const bfValue =
          item.operator === "in_range"
            ? `${item.min_burst_factor} and ${item.max_burst_factor}`
            : `${item.burst_factor}`;
        const bfOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equals"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: "Burst factor",
          operand: bfOperand,
          value: bfValue,
          // tooltip: `Burst factor ${bfOperand} ${bfValue}`,
        };
      case "reel_od":
        const reelOdValue =
          item.operator === "in_range"
            ? `${item.min_reel_od} and ${item.max_reel_od}`
            : `${item.reel_od}`;
        const reelOdOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equals"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: "Reel OD",
          operand: reelOdOperand,
          value: reelOdValue,
          // tooltip: `Reel OD ${reelOdOperand} ${reelOdValue}`,
        };
      case "core_id":
        const coreIdValue =
          item.operator === "in_range"
            ? `${item.min_core_id} and ${item.max_core_id}`
            : `${item.core_id}`;
        const coreIdOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equals"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: "Core ID",
          operand: coreIdOperand,
          value: coreIdValue,
          // tooltip: `Core ID ${coreIdOperand} ${coreIdValue}`,
        };
      case "grade_quality":
        const gradeValue =
          item.grades.length > 1
            ? `${item.grades[0].grade}(${item.grades[0].qualities.join()}) or ${
                item.grades.length - 1
              } others`
            : `${item.grades[0].grade}` +
              (item.grades[0].qualities?.length
                ? `"(${item.grades[0].qualities.join()})"`
                : ``);
        return {
          type: item.type,
          formattedType: "Grade",
          operand: "-",
          value: gradeValue,
          // tooltip: `Core ID ${coreIdOperand} ${coreIdValue}`
        };
      case "size":
        const sizeValue =
          item.operator === "in_range"
            ? `${item.min_size} and ${item.max_size}`
            : `${item.size}`;
        const sizetype =
          item.size_type === "width"
            ? "Width"
            : item.size_type === "length"
            ? "Length"
            : "Width / Length";
        const sizeOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equals"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: sizetype,
          operand: sizeOperand,
          value: sizeValue,
          // tooltip: `${sizetype} ${sizeOperand} ${sizeValue}`,
        };
      case "ply":
        const plyValue =
          item.plyNames.length > 1
            ? `${item.plyNames[0]} or ${item.plyNames.length - 1} others`
            : `${item.plyNames[0]}`;
        return {
          type: item.type,
          formattedType: "Ply Count",
          operand: "equals",
          value: plyValue,
        };
      case "category":
        const catergoryTypeValue =
          item.category === "so"
            ? "SO"
            : item.category === "PO"
            ? "PO"
            : "SO or PO";
        return {
          type: item.type,
          formattedType: "Category",
          operand: "equals",
          value: catergoryTypeValue,
          // tooltip: `Order Type equals ${catergoryTypeValue}`,
        };
    }
  };

  const removeFilter = (filter) => {
    setOrderRecords();
    if (currentState.current === "") {
      columnsHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (currentState.current === "open" || currentState.current === "pending") {
      columnsNonApproverHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (
      currentState.current === "review" ||
      currentState.current === "rejected" ||
      currentState.current === "cancel"
    ) {
      columnsNonPriorityHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (
      currentState.current === "approved" ||
      currentState.current === "hold" ||
      currentState.current === "complete"
    ) {
      columnsNonStatusHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    const filterList = appliedFilters.filter((item) => {
      return item.type !== filter.type;
    });
    const formattedFilterList = filterTags.filter((item) => {
      return item.type !== filter.type;
    });
    setFilterTags(formattedFilterList);
    setAppliedFilters(filterList);
    // setSearchValue("");
    // setClearSearch(true);
    setLoading(true);
    setRendering(true);
    setCurrentPage(1);

    paginationRef.current = {
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    };
    setPaginationParams({
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    });
  };

  const fetchOrdersList = async (params, sort, state) => {
    try {
      let currentSortOrder = sort;
      if (location?.state?.defaultActiveKey) {
        currentSortOrder =
          state === "rejected" ||
          state === "pending" ||
          state === "review" ||
          state === "hold" ||
          state === "cancel"
            ? {
                sort_by: "updated_at",
                sort_type: "descending",
              }
            : {
                sort_by: "updated_at",
                sort_type: "descending",
              };
      }
      const allOrdersData = await getAllOrdersList(
        params,
        currentSortOrder,
        state
      );
      if (allOrdersData?.state === currentState.current) {
        if (!allOrdersData.orders.length) {
          setEmptyStateLabel("noData");
        }
        setTotalRecords(
          allOrdersData.page_size
            ? allOrdersData.page_size
            : allOrdersData.total_orders
        );
        setOrderCount(allOrdersData.total_orders);
        setPOCount(allOrdersData.total_po);
        setSOCount(allOrdersData.total_so);
        setAllOrdersList(allOrdersData.orders);
        setOrderWeightCount((orderState == "approved")?allOrdersData?.total_balance_weight?.toFixed(3):allOrdersData?.total_orders_quantity?.toFixed(3));
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      setEmptyStateLabel("connectionAPIError");
      console.log(error);
    }
  };

  const onMergeOrderHandler = (record, type) => {
    setNewGradeSideDrawer(false);
    setResendApprovalData(false);
    setSplitOrderSideDrawer(false);
    setProductionDetailsSideDrawer(false);
    setMergeSideDrawer(true);
    if (type && type == "menuEle") {
      setSelectedOrder(record);
    }
  };

  const handleMergeDrawerClose = () => {
    setMergeSideDrawer(false);
  };

  const handleCancelQuantityDrawerClose = () => {
    setCancelQuantitySideDrawer(false);
    setSelectedOrder();
  };

  // const onViewPODetailsHandler = (record) => {
  //   history("../po-details", {
  //     state: {
  //       poNumber: record.savedPO,
  //       backKey: "orderRecords",
  //     },
  //   });
  // };
  const onViewPODetailsHandler = (record) => {
    record?.category === "PO"
      ? history("../po-details", {
          state: {
            poNumber: record.savedPO,
            backKey: "orderRecords",
            customer: record.customercode,
          },
        })
      : history("../so-details", {
          state: {
            soNumber: record.sono,
            backKey: "../order-records",
            isView: true,
          },
        });
  };
  const onViewChangeHandler = (record) => {
    history("../history", {
      state: {
        order: {
          orderDetails: record,
          route: "../order-records",
          defaultActiveKey: defaultActiveKey,
          defaultOrderState: orderState,
        },
        logType: "Order",
        name: record.orderno,
        searchText: "Search change in order property",
      },
    });
  };

  const handleDelete = (record) => {
    setIsVisibleDeleteModal(true);
    setSelectedOrder(record);
  };

  const deleteModalClose = () => {
    setIsVisibleDeleteModal(false);
    setNewGradeSideDrawer(false);
  };

  const deleteModalConfirm = (orderNo) => {
    setIsVisibleDeleteModal(false);
    deleteOrder(orderNo)
      .then((response) => {
        setActionToaster({
          error: response.error,
          msg: `Order ${orderNo} was successfully deleted`,
        });
        setRendering(true);
        showToaster();
      })
      .catch((error) => {
        console.log("Error in deleting order:", error);
        setActionToaster({
          error: error.response.error,
          msg: error.response.msg,
        });
        setRendering(true);
        showToaster();
      });
    setNewGradeSideDrawer(false);
  };

  const handleRelease = (record) => {
    setIsVisibleReleaseModal(true);
    setSelectedOrder(record);
  };

  const releaseModalConfirm = async (value) => {
    await approveOrder(value.orderno);
    setIsVisibleReleaseModal(false);
  };

  const approveOrder = async (orderNo) => {
    await bulkChangeOrderState([{ order: orderNo, state: "approved" }])
      .then((response) => {
        setActionToaster({
          error: response.error,
          msg: response.msg,
        });
        setRendering(true);
        showToaster();
      })
      .catch((error) => {
        setActionToaster({
          error: error.response.error,
          msg: error.response.msg,
        });
        setRendering(true);
        showToaster();
      });
    setNewGradeSideDrawer(false);
  };

  const releaseModalClose = () => {
    setIsVisibleReleaseModal(false);
    setNewGradeSideDrawer(false);
  };

  const fetchFilteredOrders = () => {
    getFilteredOrders(
      appliedFilters,
      paginationRef.current,
      sortParams,
      orderState,
      '',
      '',
      searchValue
    )
      .then((response) => {
        setEmptyStateLabel("filter");
        setTotalRecords(
          response.data.page_size
            ? response.data.page_size
            : response.data.total_orders
        );
        setOrderCount(response.data.total_orders);
        setPOCount(response.data.total_po);
        setSOCount(response.data.total_so);

        setAllOrdersList(response.data.orders);
        setOrderWeightCount(response?.data?.total_orders_quantity.toFixed(3));
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        setEmptyStateLabel("connectionAPIError");
      });
  };

  const getAllOrders = () => {
    const orders = allOrdersList?.map((item) => {
      let processQuantity;
      let pendingQuantity;
      let cancelledQuantity;
      let pendingQuantityValue;

      let quantityValue;
      let rewinderReels;
      if (item.type == "reel" && item.quantity_type == "reel_sheet") {
        pendingQuantityValue =
          item.this_item_type == "order"
            ? Math.round(item.total_pending_quantity.quantity)
            : Math.round(item.total_pending_quantity.quantity);
        processQuantity =
          item.this_item_type == "order"
            ? Math.round(item.total_processed_quantity.quantity) + "<br/> Reels"
            : Math.round(item.total_processed_quantity.quantity) +
              "<br/> Reels";
        pendingQuantity =
          item.this_item_type == "order"
            ? Math.round(item.total_pending_quantity.quantity) + " Reels"
            : Math.round(item.total_pending_quantity.quantity) + " Reels";
        cancelledQuantity =
          item.this_item_type == "order"
            ? Math.round(item.cancelled_quantity.quantity) + " Reels"
            : Math.round(item.total_cancelled_quantity.quantity) + " Reels";
        quantityValue =
          item.this_item_type == "order"
            ? Math.round(item.no_of_reel_sheet) + " Reels"
            : Math.round(item.total_quantity) + " Reels";
        rewinderReels =
          item.this_item_type == "order"
            ? Math.round(item.quantity)
            : Math.round(item.total_quantity);
      } else if (item.type == "sheet" && item.quantity_type == "reel_sheet") {
        quantityValue =
          item.this_item_type == "order"
            ? item.weight
              ? item.weight +
                " " +
                capitalize(weightUnit[item.units?.planned_weight].displayName)
              : "-"
            : item.total_weight
            ? item.total_weight +
              " " +
              capitalize(weightUnit[item.units?.total_weight].displayName)
            : "-";
        rewinderReels =
          item.this_item_type == "order"
            ? Math.round(item.quantity)
            : Math.round(item.total_quantity);
        processQuantity =
          item.this_item_type == "order"
            ? item.total_processed_quantity.weight +
              "<br/> " +
              capitalize(
                weightUnit[item.total_processed_quantity.units?.weight]
                  .displayName
              )
            : item.total_processed_quantity.weight +
              "<br/> " +
              capitalize(
                weightUnit[item.total_processed_quantity.units?.weight]
                  .displayName
              );
        pendingQuantity =
          item.this_item_type == "order"
            ? item.total_pending_quantity.weight +
              " " +
              capitalize(
                weightUnit[item.total_pending_quantity.units?.weight]
                  .displayName
              )
            : item.total_pending_quantity.weight +
              " " +
              capitalize(
                weightUnit[item.total_pending_quantity.units?.weight]
                  .displayName
              );
        cancelledQuantity =
          item.this_item_type == "order"
            ? item.cancelled_quantity.weight +
              " " +
              capitalize(weightUnit[item.cancelled_quantity.units].displayName)
            : item.total_cancelled_quantity.weight +
              " " +
              capitalize(
                weightUnit[item.total_cancelled_quantity.units.weight]
                  .displayName
              );
        pendingQuantityValue =
          item.this_item_type == "order"
            ? item.total_pending_quantity.weight
            : item.total_pending_quantity.weight;
      } else if (
        (item.type == "reel" || item.type == "sheet") &&
        item.quantity_type == "weight"
      ) {
        quantityValue =
          item.this_item_type == "order"
            ? item.weight
              ? item.weight +
                " " +
                capitalize(weightUnit[item.units?.planned_weight].displayName)
              : "-"
            : item.total_weight
            ? item.total_weight +
              " " +
              capitalize(weightUnit[item.units?.total_weight].displayName)
            : "-";
        rewinderReels =
          item.this_item_type == "order"
            ? Math.round(item.quantity)
            : Math.round(item.total_quantity);
        processQuantity =
          item.this_item_type == "order"
            ? item.total_processed_quantity.weight +
              "<br/> " +
              capitalize(
                weightUnit[item.total_processed_quantity.units?.weight]
                  .displayName
              )
            : item.total_processed_quantity.weight +
              "<br/> " +
              capitalize(
                weightUnit[item.total_processed_quantity.units?.weight]
                  .displayName
              );
        pendingQuantity =
          item.this_item_type == "order"
            ? item.total_pending_quantity.weight +
              " " +
              capitalize(
                weightUnit[item.total_pending_quantity.units?.weight]
                  .displayName
              )
            : item.total_pending_quantity.weight +
              " " +
              capitalize(
                weightUnit[item.total_pending_quantity.units?.weight]
                  .displayName
              );
        cancelledQuantity =
          item.this_item_type == "order"
            ? item.cancelled_quantity.weight +
              " " +
              capitalize(weightUnit[item.cancelled_quantity.units].displayName)
            : item.total_cancelled_quantity.weight +
              " " +
              capitalize(
                weightUnit[item.total_cancelled_quantity.units.weight]
                  .displayName
              );
        pendingQuantityValue =
          item.this_item_type == "order"
            ? item.total_pending_quantity.weight
            : item.total_pending_quantity.weight;
      }
      let pendingValue;
      if (item.type === "sheet" && !item.core_id && !item.reel_od) {
        pendingValue =
          item.this_item_type == "order"
            ? item.pending_quantity_weight
            : item.total_planned_weight -
              item.total_weight_completed -
              item.total_weight_in_production -
              item.total_weight_in_process;
      } else {
        pendingValue =
          item.this_item_type == "order"
            ? item.quantity -
              item.completed -
              item.in_production -
              item.in_process
            : item.total_quantity -
              item.total_weight_completed -
              item.total_weight_in_production -
              item.total_weight_in_process;
      }
      let planned_weight;
      if (item.this_item_type == "order") {
        planned_weight = item.planned_weight
          ? `${
              item.planned_weight !== 0 ? item.planned_weight?.toFixed(3) : 0
            } ${
              item.units
                ? weightUnit[
                    item.units.planned_weight
                  ]?.displayName?.toUpperCase()
                : ""
            }`
          : "-";
      } else {
        planned_weight = item.total_planned_weight
          ? `${
              item.total_planned_weight !== 0
                ? item.total_planned_weight?.toFixed(3)
                : 0
            } ${
              item.units
                ? weightUnit[
                    item.units?.total_weight
                  ]?.displayName?.toUpperCase()
                : ""
            }`
          : "-";
      }
      let currencySymbol;
      if (item?.units?.net_price) {
        currencySymbol = currency_List.filter(
          (currUnit) => currUnit.code === item.units.net_price
        );
      } else {
        currencySymbol = "";
      }
      let currencySymbolDealer;
      if (item?.units?.dealer_price) {
        currencySymbolDealer = currency_List.filter(
          (currUnit) => currUnit.code === item.units.dealer_price
        );
      } else {
        currencySymbolDealer = "";
      }

      let plannedQuantity;
      let plannedUnit;
      if (item.quantity_type == "reel_sheet") {
        if (item.type == "reel") plannedUnit = "Reels";
        else plannedUnit = "Sheets";

        plannedQuantity = item.planning_quantity;
      } else {
        plannedQuantity = item.planning_weight;
        plannedUnit = capitalize(weightUnit[item.units?.weight]?.displayName);
      }
      let jobID=[]
      if(item?.jobcards?.jobcards){
        item?.jobcards?.jobcards.map((item,index)=>{
          jobID.push(item.jobcard)
        })
      }
      const balance_qty = (item?.balance_weight==0)?"-":item?.balance_weight+" "+capitalize(item?.units?.weight);
      return {
        key: item.uuid,
        isEditAllowed: orderManagementSettings?.edit_after_approval?.value,
        split_type: item.split_type,
        split_group: item.split_group,
        isConflictingstate: item.conflicting_state ==="non_conflicting"?false:true,
        jobcards: jobID, 
        pono:
          item.po && typeof item.po === "string"
            ? item.po.toUpperCase()
            : item.po,
        sono:
          item.so && typeof item.so === "string"
            ? item.so.toUpperCase()
            : item.so,
        savedPO: item.po,
        orderno: item.number ? item.number : "-",
        createddate: moment(item.created_at).format("DD MMM YYYY"),
        poDate: moment(item.po_date).format("DD MMM YYYY"),
        soDate: moment(item.so_date).format("DD MMM YYYY"),
        customercode: item.customer,
        productcode: item.product,
        product_spec: item.product_spec,
        type: item.type ? capitalize(item.type) : "-",
        units: item.units ? item.units : "",
        size: item.width
          ? `${item.width}${item.length ? ` x ${item.length}` : ""} ${
              item.units
                ? lengthUnit[item.units.width]?.displayName?.toUpperCase()
                : ""
            }`
          : "-",
        quantity: quantityValue ? quantityValue : "-",
        rewinder_reels: rewinderReels ? rewinderReels : "-",
        weight:
          item.this_item_type == "order"
            ? `${parseFloat(item.weight).toFixed(3)}`
            : `${parseFloat(item.total_weight).toFixed(3)}`,
        coreid: item.inner_dia ? `${item.inner_dia}` : "-",
        reelod: item.outer_dia ? `${item.outer_dia}` : "-",
        price: item.quoted_price
          ? `${item.units && currencySymbol ? currencySymbol[0].symbol : ""}` +
            " " +
            parseFloat(item.quoted_price).toFixed(3) +
            " " +
            `${
              item?.units?.per_weight_unit
                ? " /" +
                  weightUnit[
                    item.units.per_weight_unit
                  ]?.displayName?.toUpperCase()
                : ""
            }`
          : "-",
        netprice:
          item.net_price &&
          item.quantity_type == "reel_sheet" &&
          item.type == "reel"
            ? ""
            : item.net_price
            ? `${
                item.units && currencySymbol ? currencySymbol[0].symbol : ""
              }` +
              " " +
              parseFloat(item.net_price).toFixed(3)
            : "",
        dealerPrice: item.dealer_price
          ? `${
              item.units && currencySymbolDealer
                ? currencySymbolDealer[0].symbol
                : ""
            }` +
            " " +
            parseFloat(item.dealer_price).toFixed(3) +
            " " +
            `${
              item?.units?.per_weight_unit
                ? " / " +
                  weightUnit[
                    item.units.per_weight_unit
                  ]?.displayName?.toUpperCase()
                : ""
            }`
          : "-",
        deliverydate: item.delivery_date
          ? moment(item.delivery_date).format("DD MMM YYYY")
          : "-",
        approvedby: item.approved_by ? item.approved_by : "-",
        remarks: item.remarks ? item.remarks : "-",
        priority: item.forced,
        // Proper state values for 'changes req' and 'on hold'
        status:
          item.this_item_type == "order"
            ? capitalize(
                item.state === "review"
                  ? "Changes Requested"
                  : item.state === "hold"
                  ? "On Hold"
                  : item.state === "in_production"
                  ? "In Production"
                  : item.state === "cancel"
                  ? "Cancelled"
                  : item.state == "open" 
                  ? "Provisional"
                  : item.state == "pending"
                  ? "Pending Confirmation" 
                  : item.state == "rejected"
                  ? "Confirmation Rejected"
                  : item.state == "approved"
                  ? "Active" 
                  : item.state == "complete"
                  ? "Produced"
                  : item.state
              )
            : "-",
        completed:
          item.this_item_type == "order"
            ? item.completed
            : item.total_completed,
        in_production:
          item.this_item_type == "order"
            ? item.in_production + item.in_process
            : item.total_in_production + item.total_in_process,
        // pending: item.this_item_type == 'order'
        //   ? item.quantity - item.completed - item.in_production - item.in_process
        //   : item.total_quantity - item.total_completed - item.total_in_production - item.total_in_process,

        pending: pendingValue,
        customerName: item.customer_name,
        quantity_type: item.quantity_type ? item.quantity_type : "-",
        // plannedweight: item.planned_weight ? `${item.planned_weight !== 0 ? item.planned_weight?.toFixed(3) : 0
        //   } Tonnes` : '-',
        plannedweight: planned_weight,
        user: item.user ? item.user : "-",
        item_type: item.this_item_type,
        groupno: item.this_item_type == "order" ? "-" : item.id,
        length: item.length,
        width: item.width,
        grain: item.grain,
        order_type: item.type,
        in_process: item.in_process,
        parent: item.parent,
        other_parents: item.other_parents,
        reel_diameter: item.reel_diameter,
        customer_alias: item.customer_alias,
        consignee_alias: item.consignee_alias,
        consignee: item.consignee,
        consignee_name: item.consignee_name,
        previous_state: item.previous_state,
        sheet_completed_weight: item.sheet_completed_weight
          ? item.sheet_completed_weight
          : 0,
        sheet_processed_weight: item.sheet_processed_weight
          ? item.sheet_processed_weight
          : 0,
        sheet_production_weight: item.sheet_production_weight
          ? item.sheet_production_weight
          : 0,
        pending_quantity_weight: item.pending_quantity_weight,
        total_weight_in_process: item.total_weight_in_process
          ? item.total_weight_in_process
          : 0,
        total_weight_in_production: item.total_weight_in_production
          ? item.total_weight_in_production
          : 0,
        total_weight_completed: item.total_weight_completed
          ? item.total_weight_completed
          : 0,
        cancelledQuantity,
        pendingQuantity,
        processQuantity,
        pendingQuantityValue,
        // total_pending_quantity : item.total_pending_quantity,
        // total_rewinder_quantity : item.total_rewinder_quantity,
        // total_sheet_quantity : item.total_sheet_quantity
        progressbar_info: item.progressbar_info,
        plannedQuant: plannedQuantity,
        plannedUnit,
        no_of_sheets: item.no_of_sheets,
        no_of_reel_sheet: item.no_of_reel_sheet,
        cancelled_quantity: item.cancelled_quantity,
        ply: item.ply,
        category: item?.category?.toUpperCase(),
        balance_qty: balance_qty,
      };
    });
    return orders;
  };

  const searchOrders = async (value = "") => {
    setOrderRecords();
    setSearchValue(value);
    if (currentState.current === "") {
      columnsHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (currentState.current === "open" || currentState.current === "pending") {
      columnsNonApproverHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (
      currentState.current === "review" ||
      currentState.current === "rejected" ||
      currentState.current === "cancel"
    ) {
      columnsNonPriorityHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (
      currentState.current === "approved" ||
      currentState.current === "hold" ||
      currentState.current === "complete"
    ) {
      columnsNonStatusHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    setLoading(true);
    setPaginationParams({
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    });
    paginationRef.current = {
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    };
    setCurrentPage(1);
    setRendering(true);

    // if (value === "" || value === null) {
    //   fetchOrdersList(paginationRef.current, sortParams, orderState);
    //   setAppliedFilters([]);
    //   setFilterTags([]);
    // } else {
    //   setClearSearch(false);
    //   searchOrderRecords(value, orderState, undefined, sortParams, source)
    //     .then((response) => {
    //       setLoading(false);
    //       setEmptyStateLabel("search");
    //       setAllOrdersList(response.data);
    //       setTotalRecords(response.data.length);
    //       setOrderCount(response.total_orders);
    //       setPOCount(response.total_po);
    //       setSOCount(response.total_so);

    //       setOrderWeightCount(response?.total_orders_quantity.toFixed(3));
    //     })
    //     .catch(
    //       (error) => console.log("Error in search of order records:", error),
    //       setEmptyStateLabel("connectionAPIError")
    //     );
    // }
  };

  const goToPOPage = (record) => {
    record
      ? record.category === "PO"
        ? history("../po-details", {
            state: {
              poNumber: record.savedPO,
              backKey: "orderRecords",
              customer: record.customercode,
            },
          })
        : history("../so-details", {
            state: {
              soNumber: record.sono,
              backKey: "../order-records",
              isView: true,
            },
          })
      : selectedOrder?.category === "PO"
      ? history("../po-details", {
          state: {
            poNumber: selectedOrder.savedPO,
            backKey: "orderRecords",
            customer: selectedOrder.customercode,
          },
        })
      : history("../so-details", {
          state: {
            soNumber: selectedOrder.sono,
            backKey: "../order-records",
            isView: true,
          },
        });
    setNewGradeSideDrawer(false);
    setResendApprovalData(false);
    setSplitOrderSideDrawer(false);
    setProductionDetailsSideDrawer(false);
    setCancelQuantitySideDrawer(false);
  };

  const goToUploadPo = () => {
    history("../order-records/upload-po");
  };

  const handleViewAction = (record) => {
    setSelectedOrder(record);
    showNewGradeDrawer();
  };

  const handleViewProdDetailsAction = (record) => {
    if (record) {
      setSelectedOrder(record);
    }
    setNewGradeSideDrawer(false);
    showProductionDetailsDrawer();
  };

  const handleViewProcessedQtyDetails = (record) => {
    if (record) {
      setSelectedOrder(record);
    }
    setNewGradeSideDrawer(false);
    showProcessedQtyDrawer();
  };

  const handleViewProcessedQtyAction = (record) => {
    if (record) {
      setSelectedOrder(record);
    }
    setNewGradeSideDrawer(false);
    showProcessedQtyDrawer();
  };

  const handleViewPendingQtyAction = (record) => {
    if (record) {
      setSelectedOrder(record);
    }
    setNewGradeSideDrawer(false);
    showPendingQtyDrawer();
  };

  const handleViewPendingQtyDetails = (record) => {
    if (record) {
      setSelectedOrder(record);
    }
    setNewGradeSideDrawer(false);
    showPendingQtyDrawer();
  };

  const handleCancelledQuantityAction = (record) => {
    setSelectedOrder(record);
    setNewGradeSideDrawer(false);
    setCancelQuantitySideDrawer(true);
  };
  const handleEditAction = (record) => {
    setSelectedOrder(record);
    ShowNewResendApproval();
  };

  const handleSplitAction = (record) => {
    setSelectedOrder(record);
    showNewSplitOrderDrawer();
  };

  const handlePriorityAction = (record) => {
    setIsVisiblePriorityModal(true);
    setSelectedOrder(record);
  };

  const priorityModalConfirm = async (value) => {
    await prioritizeOrder(value);
    setIsVisiblePriorityModal(false);
    setRendering(true);
    showToaster();
  };

  const prioritizeOrder = async (record) => {
    await changeOrderPriority({
      order: record.orderno,
      prioritize: !record.priority,
    })
      .then((response) =>
        setActionToaster({ error: response.error, msg: response.msg })
      )
      .catch((error) => {
        setActionToaster({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
      });
  };

  const priorityModalClose = () => {
    setIsVisiblePriorityModal(false);
  };

  const handlePo = (record) => {
    setSelectedOrder(record);
    goToPOPage(record);
  };

  const ShowNewResendApproval = () => {
    setResendApprovalData(true);
  };

  const showNewGradeDrawer = () => {
    setNewGradeSideDrawer(true);
  };

  const showProductionDetailsDrawer = () => {
    setProductionDetailsSideDrawer(true);
  };

  const showProcessedQtyDrawer = () => {
    setProcessedQtyDetailsSideDrawer(true);
  };

  const showPendingQtyDrawer = () => {
    setPendingQtyDetailsSideDrawer(true);
  };

  const showNewSplitOrderDrawer = () => {
    setSplitOrderSideDrawer(true);
  };

  const onCloseFullNewGrade = () => {
    setNewGradeSideDrawer(false);
    setResendApprovalData(false);
    setSplitOrderSideDrawer(false);
    setProductionDetailsSideDrawer(false);
    setProcessedQtyDetailsSideDrawer(false);
    setPendingQtyDetailsSideDrawer(false);
    setCancelQuantitySideDrawer(false);
    setSelectedOrder();
  };

  const onCloseNewGrade = () => {
    //setSelectedOrder();
    setNewGradeSideDrawer(false);
    setResendApprovalData(false);
    setSplitOrderSideDrawer(false);
    setProductionDetailsSideDrawer(false);
    setCancelQuantitySideDrawer(false);
    setProcessedQtyDetailsSideDrawer(false);
    setPendingQtyDetailsSideDrawer(false);
    setSelectedOrder();
  };

  const onCloseActionDrawer = () => {
    setHoldOrders(false);
    setHoldOrderDrawer(false);
  };

  const history = useNavigate();

  const routeChange = (isSO = false) => {
    if (isSO)
      history("../add-new-so", {
        state: {
          isADD: true,
        },
      });
    else history("../add-new-po");
  };

  const exportHandler = () => {
    let fileName;
    const currentDate = new Date();
    const today =
      currentDate.getDate() +
      "/" +
      currentDate.toLocaleString("default", { month: "long" }) +
      "/" +
      currentDate.getFullYear();
    if (orderState == "") {
      fileName = "all_orders_Kaiznn_" + today;
    } else {
      fileName = orderState + "_orders_Kaiznn_" + today;
    }
    if (appliedFilters.length) {
      let paginationParams = "";
      // let sortParams = "";
      history("../order-records/export-orders", {
        state: {
          body: {
            status: orderState,
            searchValue: searchValue,
            paginationParams: paginationParams,
            sortParams: sortParams,
            appliedFilters: appliedFilters,
            page: "order records",
            type: "Filter",
          },
          rootPage: "../order-records",
          fileName: fileName,
          count: orderCount,
        },
      });
    } else if (!clearSearch && searchValue) {
      history("../order-records/export-orders", {
        state: {
          body: {
            status: orderState,
            searchValue: searchValue,
            page: "order records",
            type: "Search",
          },
          rootPage: "../order-records",
          fileName: fileName,
          count: orderCount,
        },
      });
    } else {
      history("../order-records/export-orders", {
        state: {
          body: {
            status: orderState,
            page: "order records",
            type: "All Data",
            sortParams: sortParams,
          },
          rootPage: "../order-records",
          fileName: fileName,
          count: orderCount,
        },
      });
    }
  };
  // Show Toaster
  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 3000);
  };

  const handleCancel = (record) => {
    if (record) {
      setSelectedOrder(record);
    }
    showHoldOrder();
    setOrderAction("hold");
    setNewGradeSideDrawer(false);
    setResendApprovalData(false);
    setProductionDetailsSideDrawer(false);
    setCancelQuantitySideDrawer(false);
  };

  const handleRestore = (isRestore) => {
    setHoldOrders(false);
    setIsRestore(isRestore);
    setHoldOrderDrawer(false);
    ShowNewResendApproval();
    setNewGradeSideDrawer(false);
    // setResendApprovalData(false);
    setOrderAction();
  };

  const handleHold = (record) => {
    showHoldDrawer(record);
  };

  const showHoldDrawer = (record) => {
    setNewGradeSideDrawer(false);
    setHoldOrderDrawer(true);
    setSelectedOrder(record);
  };

  const showHoldOrder = () => {
    setNewGradeSideDrawer(false);
    setHoldOrders(true);
  };

  const refresh = () => {
    setLoading(true);
    setOrderRecords();
    setSearchValue("");
    setClearSearch(true);
    setRendering(true);
  };
  useEffect(async () => {
    const orderMangSettings = await getWorkflowSettings("order_management");
    setOrderManagementSettings(orderMangSettings.data);
    const deckleMangSettings = await getWorkflowSettings("deckle_management");
    setDeckleManagementSettings(deckleMangSettings?.data);
  }, []);

   useEffect(() => {
      
    if (location.state?.action) {
      setCancelToaster(location.state.action);
      setCancelTosterMsg(location.state.msg);
      history(location.pathname, { replace: true });
    }

  }, [location, history]);
  useEffect(() => {
    let propsData = {};
    if (emptyStateLabel === "noData") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records in this list";
      propsData["subHeading"] =
        "There are no records to show in this list. Add your first record to view details here";
    } else if (emptyStateLabel === "search") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] =
        "There is no record matching your search keyword. Try adjusting your search to find what you are looking for.";
    } else if (emptyStateLabel === "filter") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] =
        "There is no record matching your filter. Try changing your filter to find what you are looking for.";
    } else {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "Something went wrong";
      propsData["subHeading"] =
        "Check your internet connection or try reloading the page.";
    }
    setEmptyStatePropsData(propsData);
  }, [emptyStateLabel]);

  // useEffect(() => {
  //   if (rendering && !appliedFilters.length && searchValue == "") {
  //     if (Object.keys(allInnerRecords).length > 0) {
  //       setRerenderInnerTable(true);
  //       setAllInnerRecords({});
  //     }
  //     fetchOrdersList(paginationRef.current, sortParams, orderState);
  //     setRendering(false);
  //     // setLoading(false);
  //   }
  // }, [rendering, orderState, sortParams, paginationParams]);

  useEffect(async () => {
    const ordersRecord = allOrdersList.length > 0 ? await getAllOrders() : [];
    // const ordersRecord  = [];
    setOrderRecords([...ordersRecord]);
    //   if( location?.state?.selectedOrder && !isStateData && allOrdersList.length)
    // {
    //   setDefaultActiveKey(location.state.defaultActiveKey);
    //   setStateData(true);
    //   setSelectedOrder(location.state.selectedOrder);
    //   setNewGradeSideDrawer(true);
    //   history(location.pathname, {});
    // }
  }, [allOrdersList]);

  useEffect(() => {
    return () => {
      source.cancel("Page is redirected");
    };
  }, []);

  useEffect(() => {
    if(!rendering)return;
    if (appliedFilters.length) {
      setLoading(true);
      fetchFilteredOrders();
    } else if (searchValue !== "" && !appliedFilters.length) {
      searchOrderRecords(searchValue, orderState, undefined, sortParams, source)
        .then((response) => {
          setLoading(false);
          setEmptyStateLabel("search");
          setAllOrdersList(response.data);
          setTotalRecords(response.data.length);
          setOrderCount(response.total_orders);
          setPOCount(response.total_po);
          setSOCount(response.total_so);

          setOrderWeightCount(response?.total_orders_quantity.toFixed(3));
        })
        .catch(
          (error) => console.log("Error in search of order records:", error),
          setEmptyStateLabel("connectionAPIError")
        );
    } else {
      fetchOrdersList(paginationRef.current, sortParams, orderState);
    }
    setRendering(false);
  }, [rendering, orderState]);

  useEffect(() => {
    (async () => {
      try {
        const unitData = await getUnitData();
        if (!unitData.error) {
          setMeasurementData(unitData);
        }
      } catch (err) {
        console.log(err);
      }
    })();
  }, []);

  useEffect(() => {
    if (poBackKey) {
      setActionToaster({
        error: false,
        msg: "The order is successfully added",
      });
      showToaster();
      setPoBackKey("");
    }
  }, [poBackKey]);

  const tabHeads = [
    {
      key: 0,
      title: "All Orders",
      state: "",
      header: columnsHead.current,
    },
    // {
    //   key: 1,
    //   title: "Open",
    //   state: "open",
    //   header: columnsNonApproverHead.current,
    // },
    // {
    //   key: 2,
    //   title: "Pending",
    //   state: "pending",
    //   header: columnsNonApproverHead.current,
    // },
    // {
    //   key: 3,
    //   title: "Changes Requested",
    //   state: "review",
    //   header: columnsNonPriorityHead.current,
    // },
    {
      key: 1,
      // title: "Approved",
      title: "Active",
      state: "approved",
      header: columnsNonStatusHead.current,
    },
    // {
    //   key: 5,
    //   title: "Rejected",
    //   state: "rejected",
    //   header: columnsNonPriorityHead.current,
    // },
    // {
    //   key: 6,
    //   title: "Cancelled",
    //   state: "cancel",
    //   header: columnsNonPriorityHead.current,
    // },
    // {
    //   key: 7,
    //   title: "On Hold",
    //   state: "hold",
    //   header: columnsNonStatusHead.current,
    // },
    {
      key: 2,
      title: "Produced",
      state: "complete",
      header: columnsNonStatusHead.current,
    },
  ];

  const handleTabChange = (key) => {
    currentState.current = tabHeads[key].state;
    if (currentState.current === "") {
      columnsHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (currentState.current === "open" || currentState.current === "pending") {
      columnsNonApproverHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (
      currentState.current === "review" ||
      currentState.current === "rejected" ||
      currentState.current === "cancel"
    ) {
      columnsNonPriorityHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (
      currentState.current === "approved" ||
      currentState.current === "hold" ||
      currentState.current === "complete"
    ) {
      columnsNonStatusHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    setTotalRecords("");
    setOrderCount("");
    setPOCount();
    setSOCount();

    setOrderWeightCount("");
    setDefaultActiveKey(key.toString());
    setLoading(true);
    setOrderRecords();
    setFilterTags([]);
    setAppliedFilters([]);
    setSearchValue("");
    setClearSearch(true);
    setOrderState(tabHeads[key].state);
    // setAppliedFilters([]);
    setPaginationParams({
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    });
    paginationRef.current = {
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    };
    setCurrentPage(1);
    if (
      tabHeads[key].state === "rejected" ||
      tabHeads[key].state === "pending" ||
      tabHeads[key].state === "review" ||
      tabHeads[key].state === "hold" ||
      tabHeads[key].state === "cancel"
    ) {
      setSortParams({
        sort_by: "updated_at",
        sort_type: "descending",
      });
    } else {
      setSortParams({
        sort_by: "updated_at",
        sort_type: "descending",
      });
    }

    setRendering(true);
  };

  const expandedRowRender = (row) => {
    return !allInnerRecords[row.key]?.length ? (
      <TableShimmer
        header={
          orderState == "open" || orderState == "pending"
            ? columnsNonApproverHead.current
            : orderState == "review" ||
              orderState == "rejected" ||
              orderState == "cancel"
            ? columnsNonPriorityHead.current
            : orderState == "approved" ||
              orderState == "hold" ||
              orderState == "complete"
            ? columnsNonStatusHead.current
            : columnsHead.current
        }
        showHeader={true}
        scroll={2000}
        rows={3}
        minHeight={"0px"}
      />
    ) : (
      <Table
        style={{ minHeight: "0px", paddingBottom: "8px", paddingTop: "10px" }}
        columns={
          orderState == "open" || orderState == "pending"
            ? columnsNonApproverHead.current
            : orderState == "review" ||
              orderState == "rejected" ||
              orderState == "cancel"
            ? columnsNonPriorityHead.current
            : orderState == "approved" ||
              orderState == "hold" ||
              orderState == "complete"
            ? columnsNonStatusHead.current
            : columnsHead.current
        }
        dataSource={
          allInnerRecords[row.key].length ? allInnerRecords[row.key] : []
        }
        pagination={false}
        showHeader={true}
        scroll={{ x: 3000 }}
      />
    );
  };

  const rowExpandable = (record) => {
    if (record.item_type === "split_group") {
      return true;
    } else {
      return false;
    }
  };

  const onExpand = async (expanded, record) => {
    if (expanded) {
      setNestedLoading(true);
      const allInnerRecordObj = allInnerRecords;
      let groupedOrders = await getSplitGroupOrders(record.groupno);
      groupedOrders = groupedOrders.filter(({ state }) =>
        orderState ? state === orderState : state !== orderState
      );
      const mappedGroupOrders = await mapInnerRecordsToColumns(groupedOrders);
      allInnerRecordObj[record.key] = mappedGroupOrders;
      setAllInnerRecords(allInnerRecordObj);
      setRerenderInnerTable(false);
      setNestedLoading(false);
    } else {
      setRerenderInnerTable(false);
      setNestedLoading(false);
    }
  };

  const mapInnerRecordsToColumns = async (groupedOrders) => {
    const innerOrders = groupedOrders?.map((item) => {
      let processQuantity;
      let pendingQuantity;
      let cancelledQuantity;
      let pendingQuantityValue;

      let quantityValue;
      let rewinderReels;
      if (item.type == "reel" && item.quantity_type == "reel_sheet") {
        pendingQuantityValue =
          item.this_item_type == "order"
            ? Math.round(item.total_pending_quantity.quantity)
            : Math.round(item.total_pending_quantity.quantity);
        processQuantity =
          item.this_item_type == "order"
            ? Math.round(item.total_processed_quantity.quantity) + "<br/> Reels"
            : Math.round(item.total_processed_quantity.quantity) +
              "<br/> Reels";
        pendingQuantity =
          item.this_item_type == "order"
            ? Math.round(item.total_pending_quantity.quantity) + " Reels"
            : Math.round(item.total_pending_quantity.quantity) + " Reels";
        cancelledQuantity =
          item.this_item_type == "order"
            ? Math.round(item.cancelled_quantity.quantity) + " Reels"
            : Math.round(item.total_cancelled_quantity.quantity) + " Reels";
        quantityValue =
          item.this_item_type == "order"
            ? Math.round(item.no_of_reel_sheet) + " Reels"
            : Math.round(item.total_quantity) + " Reels";
        rewinderReels =
          item.this_item_type == "order"
            ? Math.round(item.quantity)
            : Math.round(item.total_quantity);
      } else if (item.type == "sheet" && item.quantity_type == "reel_sheet") {
        quantityValue =
          item.this_item_type == "order"
            ? item.weight
              ? item.weight +
                " " +
                capitalize(weightUnit[item.units?.quantityValue].displayName)
              : "-"
            : item.total_weight
            ? item.total_weight +
              " " +
              capitalize(weightUnit[item.units?.total_weight].displayName)
            : "-";
        rewinderReels =
          item.this_item_type == "order"
            ? Math.round(item.quantity)
            : Math.round(item.total_quantity);
        processQuantity =
          item.this_item_type == "order"
            ? item.total_processed_quantity.weight +
              "<br/> " +
              capitalize(
                weightUnit[item.total_processed_quantity.units?.weight]
                  .displayName
              )
            : item.total_processed_quantity.weight +
              "<br/> " +
              capitalize(
                weightUnit[item.total_processed_quantity.units?.weight]
                  .displayName
              );
        pendingQuantity =
          item.this_item_type == "order"
            ? item.total_pending_quantity.weight +
              " " +
              capitalize(
                weightUnit[item.total_pending_quantity.units?.weight]
                  .displayName
              )
            : item.total_pending_quantity.weight +
              " " +
              capitalize(
                weightUnit[item.total_pending_quantity.units?.weight]
                  .displayName
              );
        cancelledQuantity =
          item.this_item_type == "order"
            ? item.cancelled_quantity.weight +
              " " +
              capitalize(weightUnit[item.cancelled_quantity.units].displayName)
            : item.total_cancelled_quantity.weight +
              " " +
              capitalize(
                weightUnit[item.total_cancelled_quantity.units.weight]
                  .displayName
              );
        pendingQuantityValue =
          item.this_item_type == "order"
            ? item.total_pending_quantity.weight
            : item.total_pending_quantity.weight;
      } else if (
        (item.type == "reel" || item.type == "sheet") &&
        item.quantity_type == "weight"
      ) {
        quantityValue =
          item.this_item_type == "order"
            ? item.weight
              ? item.weight +
                " " +
                capitalize(weightUnit[item.units?.quantityValue].displayName)
              : "-"
            : item.total_weight
            ? item.total_weight +
              " " +
              capitalize(weightUnit[item.units?.total_weight].displayName)
            : "-";
        rewinderReels =
          item.this_item_type == "order"
            ? Math.round(item.quantity)
            : Math.round(item.total_quantity);
        processQuantity =
          item.this_item_type == "order"
            ? item.total_processed_quantity.weight +
              "<br/> " +
              capitalize(
                weightUnit[item.total_processed_quantity.units?.weight]
                  .displayName
              )
            : item.total_processed_quantity.weight +
              "<br/? " +
              capitalize(
                weightUnit[item.total_processed_quantity.units?.weight]
                  .displayName
              );
        pendingQuantity =
          item.this_item_type == "order"
            ? item.total_pending_quantity.weight +
              " " +
              capitalize(
                weightUnit[item.total_pending_quantity.units?.weight]
                  .displayName
              )
            : item.total_pending_quantity.weight +
              " " +
              capitalize(
                weightUnit[item.total_pending_quantity.units?.weight]
                  .displayName
              );
        cancelledQuantity =
          item.this_item_type == "order"
            ? item.cancelled_quantity.weight +
              " " +
              capitalize(weightUnit[item.cancelled_quantity.units].displayName)
            : item.total_cancelled_quantity.weight +
              " " +
              capitalize(
                weightUnit[item.total_cancelled_quantity.units.weight]
                  .displayName
              );
        pendingQuantityValue =
          item.this_item_type == "order"
            ? item.total_pending_quantity.weight
            : item.total_pending_quantity.weight;
      }

      let pendingValue;
      if (item.core_id && item.reel_od) {
        pendingValue =
          item.this_item_type == "order"
            ? item.quantity -
              item.completed -
              item.in_production -
              item.in_process
            : item.total_quantity -
              item.total_completed -
              item.total_in_production -
              item.total_in_process;
      } else {
        pendingValue = item.pending_quantity_weight;
      }

      let currencySymbol;
      if (item.units.net_price) {
        currencySymbol = currency_List.filter(
          (currUnit) => currUnit.code === item.units.net_price
        );
      } else {
        currencySymbol = "";
      }
      let currencySymbolDealer;
      if (item?.units?.dealer_price) {
        currencySymbolDealer = currency_List.filter(
          (currUnit) => currUnit.code === item.units.dealer_price
        );
      } else {
        currencySymbolDealer = "";
      }
      let jobID=[]
      if(item?.jobcards?.jobcards){
        item?.jobcards?.jobcards.map((item,index)=>{
          jobID.push(item.jobcard)
        })
      }
      return {
        key: item.uuid,
        // pono: item.po,
        isEditAllowed: orderManagementSettings?.edit_after_approval?.value,
        isConflictingstate: item.conflicting_state ==="non_conflicting"?false:true,
        jobcards: jobID, 
        pono:
          item.po && typeof item.po === "string"
            ? item.po.toUpperCase()
            : item.po,
        category: item?.category?.toUpperCase(),
        soDate: moment(item.so_date).format("DD MMM YYYY"),
        sono:
          item.so && typeof item.so === "string"
            ? item.so.toUpperCase()
            : item.so,
        savedPO: item.po,
        orderno: item.number ? item.number : "-",
        createddate: moment(item.created_at).format("DD MMM YYYY"),
        poDate: moment(item.po_date).format("DD MMM YYYY"),
        customercode: item.customer,
        productcode: item.product,
        product_spec: item.product_spec,
        type: item.type ? capitalize(item.type) : "-",
        size: item.width
          ? `${item.width}${item.length ? ` x ${item.length}` : ""} ${
              item.units
                ? lengthUnit[item.units.width].displayName?.toUpperCase()
                : ""
            }`
          : "-",
        // quantity: item.no_of_reel_sheet,
        quantity: quantityValue,
        rewinder_reels: rewinderReels,
        weight: `${parseFloat(item.weight).toFixed(3)}`,
        coreid: item.core_id
          ? `${item.core_id} ${
              item.units
                ? lengthUnit[item.units.core_id].displayName?.toUpperCase()
                : ""
            }`
          : "-",
        reelod: item.reel_od
          ? `${item.reel_od} ${
              item.units
                ? lengthUnit[item.units.reel_od].displayName?.toUpperCase()
                : ""
            }`
          : "-",
        // rewinderreels: `${item.rewinder_reels} ${capitalize(item.type)}s`,
        price: item.quoted_price
          ? `${item.units ? currencySymbol[0].symbol : ""}` +
            " " +
            parseFloat(item.quoted_price).toFixed(3) +
            " " +
            `${
              item?.units?.per_weight_unit
                ? " /" +
                  weightUnit[
                    item.units.per_weight_unit
                  ]?.displayName?.toUpperCase()
                : ""
            }`
          : "-",
        netprice: item.net_price
          ? `${item.units ? currencySymbol[0].symbol : ""}` +
            " " +
            parseFloat(item.net_price).toFixed(3)
          : "-",
        dealerPrice: item.dealer_price
          ? `${
              item.units && currencySymbolDealer
                ? currencySymbolDealer[0].symbol
                : ""
            }` +
            " " +
            parseFloat(item.dealer_price).toFixed(3)
          : "-",
        deliverydate: item.delivery_date
          ? moment(item.delivery_date).format("DD MMM YYYY")
          : "-",
        approvedby: item.approved_by ? item.approved_by : "-",
        remarks: item.remarks ? item.remarks : "-",
        priority: item.forced,
        // Proper state values for 'changes req' and 'on hold'
        status: capitalize(
          item.state === "review"
            ? "changes Req"
            : item.state === "hold"
            ? "On Hold"
            : item.state === "in_production"
            ? "In Production"
            : item.state === "cancel"
            ? "Cancelled"
            : item.state
        ),
        completed: item.completed,
        in_production: item.in_production + item.in_process,
        // pending:
        //   item.quantity - item.completed - item.in_production - item.in_process,
        pending: pendingValue,
        customerName: item.customer_name,
        quantity_type: item.quantity_type ? item.quantity_type : "-",
        // rewinder_reels: `${
        //   item.type === "reel" ? "NA" : `${item.no_of_reel_sheet} Reels`
        // }`,
        // rewinder_reels: item.quantity,
        plannedweight: item.planned_weight
          ? `${
              item.planned_weight !== 0 ? item.planned_weight?.toFixed(3) : 0
            } ${weightUnit[
              item.units.planned_weight
            ]?.displayName?.toUpperCase()}`
          : "-",
        user: item.user ? item.user : "-",
        item_type: item.this_item_type,
        groupno: item.split_group ? item.split_group : "-",
        length: item.length,
        width: item.width,
        grain: item.grain,
        order_type: item.type,
        product_spec: item.product_spec,
        in_process: item.in_process,
        parent: item.parent,
        other_parents: item.other_parents,
        reel_diameter: item.reel_diameter,
        customer_alias: item.customer_alias,
        consignee_alias: item.consignee_alias,
        consignee: item.consignee,
        consignee_name: item.consignee_name,
        previous_state: item.previous_state,
        sheet_completed_weight: item.sheet_completed_weight
          ? item.sheet_completed_weight
          : 0,
        sheet_processed_weight: item.sheet_processed_weight
          ? item.sheet_processed_weight
          : 0,
        sheet_production_weight: item.sheet_production_weight
          ? item.sheet_production_weight
          : 0,
        pending_quantity_weight: item.pending_quantity_weight,
        units: item.units ? item.units : "",
        cancelledQuantity,
        pendingQuantity,
        processQuantity,
        pendingQuantityValue,
        // total_pending_quantity : item.total_pending_quantity,
        // total_rewinder_quantity : item.total_rewinder_quantity,
        // total_sheet_quantity : item.total_sheet_quantity
        progressbar_info: item.progressbar_info,
      };
    });
    return innerOrders;
  };

  const getRow = (record, index) => {
    if (
      index != 0 &&
      orderRecords[index].pono !== orderRecords[index - 1].pono &&
      (orderState === "" ||
        orderState === "open" ||
        orderState === "complete" ||
        orderState === "approved")
    ) {
      return `highlight-bottom-border ${record.priority && "true"}`;
    } else {
      return `${record.priority && "true"}`;
    }
  };
  function formatDateTime(str) {
  // Parse as UTC
  const utcDate = new Date(str.replace(" ", "T") + "Z");

  // Format in IST (Asia/Kolkata)
  const options = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  };

  const dateOptions = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "Asia/Kolkata",
  };

  const timeStr = utcDate.toLocaleTimeString("en-US", options);
  const dateStr = utcDate.toLocaleDateString("en-GB", dateOptions);

  return `${timeStr}, ${dateStr}`;
}

  const getALLERPOrders = async (fetchType) => {
    history('../order-records/fetching-order',{"state":{"type":fetchType}})
  };

  return (
    <RightLayoutContainer
      id="right-layout-container"
      style={
        refetch.current
          ? { minHeight: "100vh", height: "100px", overflow: "scroll" }
          : {}
      }
    >
      <PageTitleComp ref={titleRef} style={{ borderBottom: "0", position: "sticky", top: stickyOffsets.title, zIndex: 100, backgroundColor: "#fff", paddingBottom: "10px" }}>
        <PageHeader
          ghost={false}
          title="Order Records"
          extra={
            (userDetails?.roles.order_records.edit_own ||
              userDetails?.roles?.order_records.edit_all) &&
            orderManagementSettings && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  // gap: 8,
                }}
              >
                {!orderManagementSettings?.fetch_orders_from_erp?.value ? (
                  <Button
                    key="1"
                    className="themeBtn noBg"
                    onClick={goToUploadPo}
                  >
                    <Iconmoon icon="import" size={14} color="#EA655B" />
                    Upload PO/SO
                  </Button>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "end",
                      justifyContent: "center",
                      rowGap: "10px",
                    }}
                  >
                    <div>
                      {/* <Button
                        key="3"
                        className={
                          orderManagementSettings?.fetch_orders_from_erp?.value
                            ? `themeBtn noBg`
                            : `themeBtn`
                        }
                        onClick={() => routeChange(true)}
                      >
                        <Iconmoon
                          icon="addcircle"
                          size={14}
                          color={
                            !orderManagementSettings?.fetch_orders_from_erp
                              ?.value
                              ? "#ffffff"
                              : "#EA655B"
                          }
                        />
                        Add a SO
                      </Button> */}
                      <Button
                        key="5"
                        className="textTypeBtn"
                        onClick={()=>{
                          getALLERPOrders("force_refresh");
                        }}
                      >
                        Force Refresh Orders
                      </Button>
                      <Button
                        key="1"
                        className="themeBtn"
                        onClick={() => {
                          getALLERPOrders("fetch_orders");
                          // setRendering(false);
                        }}
                      >
                        <Iconmoon icon="import" size={14} color="#fff" />
                        Fetch Orders
                      </Button>
                    </div>
                    <span
                      style={{
                        fontStyle: "italic",
                        color: "#605e5c",
                        fontSize: "12px",
                      }}
                    >
                      Last fetched at{" "}
                      {formatDateTime(
                        orderManagementSettings.erp_orders_last_fetched
                      )}
                    </span>
                  </div>
                )}

                {!orderManagementSettings?.fetch_orders_from_erp?.value && (
                  <Button
                    key="4"
                    className="themeBtn"
                    onClick={() => routeChange(false)}
                  >
                    <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                    Add a PO
                  </Button>
                )}
                {!orderManagementSettings?.fetch_orders_from_erp?.value && (
                  <Button
                    key="3"
                    className={
                      orderManagementSettings?.fetch_orders_from_erp?.value
                        ? `themeBtn noBg`
                        : `themeBtn`
                    }
                    onClick={() => routeChange(true)}
                  >
                    <Iconmoon
                      icon="addcircle"
                      size={14}
                      color={
                        !orderManagementSettings?.fetch_orders_from_erp?.value
                          ? "#ffffff"
                          : "#EA655B"
                      }
                    />
                    Add a SO
                  </Button>
                )}
              </div>
            )
          }
        />
      </PageTitleComp>
      {/* <TableLayoutData>
          <div className="tableDataFormat"> */}
      <style dangerouslySetInnerHTML={{
        __html: `
        .ant-tabs, .ant-tabs-content-holder, .ant-tabs-content, .ant-tabs-tabpane {
          overflow: visible !important;
        }
        .ant-table-sticky-holder {
          z-index: 101 !important;
        }
      `}} />
      <StyledTab>
        <Tabs
          defaultActiveKey={defaultActiveKey}
          onChange={handleTabChange}
          destroyInactiveTabPane={true}
          renderTabBar={(props, DefaultTabBar) => (
            <div ref={tabRef} style={{ position: "sticky", top: stickyOffsets.tabs, zIndex: 99, background: "#fff" }}>
              <DefaultTabBar {...props} />
            </div>
          )}
        >
          {tabHeads.map((tab) => (
            <Panes tab={tab.title} key={tab.key}>
              <TableLayoutData>
                <div className="tableDataFormat">
                  <div ref={searchRef} style={{ backgroundColor: "#fff", paddingBottom: "20px", paddingTop: "10px" }}>
                  <Row>
                    <Col style={{ width: "100%" }}>
                      <SearchContainer
                        placeholder={`Search${
                          columnBlacklist.includes("orderno") ? "" : "Order,"
                        } PO or Group Number`}
                        fetchOrder={searchOrders}
                        exportRole={orderRecords?.length ? true : false}
                        exportTrigger={exportHandler}
                        clearSearch={clearSearch}
                        setClearSearch={setClearSearch}
                        paginationParams={paginationParams}
                        searchedValue={searchValue}
                        isDisabled={loading}
                        // filterOptions={[
                        //   {
                        //     key: 0,
                        //     label: "Filter by Created Date",
                        //     value: "created_date",
                        //     type: "date",
                        //   },
                        //   {
                        //     key: 1,
                        //     label: "Filter by PO Date",
                        //     value: "po_date",
                        //     type: "date",
                        //   },
                        //   {
                        //     key: 2,
                        //     label: "Filter by GSM",
                        //     value: "gsm",
                        //     type: "inputSelect",
                        //   },
                        //   {
                        //     key: 3,
                        //     label: "Filter by Grade/Quality",
                        //     value: "grade_quality",
                        //     type: "grade",
                        //   },
                        //   {
                        //     key: 4,
                        //     label: "Filter by Burst Factor",
                        //     value: "burst_factor",
                        //     type: "inputSelect",
                        //   },
                        //   {
                        //     key: 5,
                        //     label: "Filter by Reel OD",
                        //     value: "reel_od",
                        //     type: "inputSelect",
                        //     unitType: "length",
                        //   },
                        //   {
                        //     key: 6,
                        //     label: "Filter by Core ID",
                        //     value: "core_id",
                        //     type: "inputSelect",
                        //     unitType: "length",
                        //   },
                        //   {
                        //     key: 7,
                        //     label: "Filter by Delivery Date",
                        //     value: "delivery_date",
                        //     type: "date",
                        //   },
                        //   {
                        //     key: 8,
                        //     label: "Filter by Customer",
                        //     value: "customer",
                        //     type: "multiSelect",
                        //   },
                        //   {
                        //     key: 9,
                        //     label: "Filter by Order Type",
                        //     value: "order_type",
                        //     type: "multiSelect",
                        //   },
                        //   {
                        //     key: 10,
                        //     label: "Filter by Size",
                        //     value: "size",
                        //     type: "rangeTypeSelect",
                        //     unitType: "length",
                        //   },
                        //   {
                        //     key: 11,
                        //     label: "Filter by Consignee",
                        //     value: "consignee",
                        //     type: "multiSelect",
                        //   },
                        //   {
                        //     key: 12,
                        //     label: "Filter by Ply Count",
                        //     value: "ply_type",
                        //     type: "multiSelect",
                        //   },
                        //   // {
                        //   //   key: 10,
                        //   //   label: "Filter by Status",
                        //   //   value: "orderStatus",
                        //   //   type: "multiSelect",
                        //   // },
                        // ]}
                        // applyFilter={applyfilter}
                      />
                    </Col>
                  </Row>
                  <Row
                    gutter={{ xs: 1, sm: 3, md: 6, lg: 12 }}
                    style={{ marginBottom: "10px", marginTop: "5px" }}
                  >
                    <Col style={{ width: "68%" }}>
                      <Row
                        gutter={{ xs: 1, sm: 3, md: 6, lg: 12 }}
                        style={{
                          marginLeft: "-30px",
                          marginBottom: "-10px",
                        }}
                      >
                        {filtersToBeShown?.map((filterKey) => {
                          const filter = filterOptions.find(
                            (f) => f.value === filterKey
                          );
                          if (!filter) return null;

                          return (
                            <Col
                              key={filter.key}
                              className="gutter-row"
                              style={{
                                width: "auto",
                                marginBottom: "10px",
                                paddingLeft: "0px",
                                paddingRight: "0px",
                              }}
                            >
                              <OrderFilter
                                filterType={{
                                  key: filter.key,
                                  label: filter.label,
                                  value: filter.value,
                                  type: filter.type,
                                  name: filter.label.replace("Filter by ", ""),
                                  ...(filter.value === "size" && {
                                    unitType: filter.unitType,
                                  }),
                                }}
                                applyFilter={applyfilter}
                              />
                            </Col>
                          );
                        })}
                        {finalFilters?.length ? (
                          <Col
                            className="gutter-row"
                            style={{
                              width: "auto",
                              marginBottom: "10px",
                              paddingLeft: "0px",
                              paddingRight: "0px",
                            }}
                          >
                            {" "}
                            <SearchContainer
                              style={{ padding: "0px !important" }}
                              filterOptions={finalFilters}
                              applyFilter={applyfilter}
                              isOtherFilter={true}
                              hideExport={true}
                            />
                          </Col>
                        ) : null}
                      </Row>
                    </Col>
                    <Col style={{ width: "32%" }}>
                      <OrderSummary>
                        <div
                          className="orderSummaryStyle"
                          style={{ marginTop: "10px" }}
                        >
                          <span className="orderWeightStyle">
                            {" "}
                            PO: {poCount}
                          </span>{" "}
                          <span className="orderWeightStyle">
                            {" "}
                            SO: {soCount}
                          </span>{" "}
                          {tab.key !=0 &&<>
                          Quantity: {orderWeightCount}{" "}
                          {measurementData?.data
                            ? capitalize(
                                weightUnit[
                                  measurementData?.data?.units_management
                                    ?.weight?.default
                                ]?.displayName
                              )
                            : "T"}
                          {/* <Styled style={{ display: "inline-flex" }}>
                            <Tooltip
                              placement="bottomRight"
                              title={
                                "It is the total weight of the orders that have quantity in weight and processed weight of the orders that have quantity in number of reels"
                              }
                              className="edit-tooltip"
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                              <span className="infoIcon"></span>
                            </Tooltip>
                          </Styled> */}
                          </>
                          }
                        </div>
                      </OrderSummary>
                    </Col>
                  </Row>
                  {filterTags.map((filter) => (
                    // <Tooltip
                    //   placement="bottomRight"
                    //   title={filter.tooltip || ""}
                    //   className="edit-tooltip"
                    //   getPopupContainer={(triggerNode) => triggerNode}
                    // >
                    <span className="filter-tags">
                      <Iconmoon icon="filter" size={13} color="#a8a8a8" />
                      &nbsp;
                      <span>{filter.formattedType}</span>
                      &nbsp;
                      <span>{filter.operand}</span>
                      &nbsp;
                      <span>{filter.value}</span>
                      <span>
                        {" "}
                        <button
                          onClick={() => {
                            removeFilter(filter);
                          }}
                        >
                          {" "}
                          <Iconmoon
                            icon="wrong"
                            size={15}
                            color="#a8a8a8"
                          />{" "}
                        </button>
                      </span>
                      <Styled></Styled>
                    </span>
                    // </Tooltip>
                  ))}
                  </div>
                  {/* <OrderSummary>
                          <div className="orderSummaryStyle">
                            <span className="orderWeightStyle"> PO: {poCount}</span>{" "}
                            <span className="orderWeightStyle"> SO: {soCount}</span>{" "}

                            Quantity: {orderWeightCount}{" "}
                            {measurementData?.data
                              ? capitalize(
                                  weightUnit[
                                    measurementData?.data?.units_management?.weight
                                      ?.default
                                  ]?.displayName
                                )
                              : "T"}
                            <Styled style={{ display: "inline-flex" }}>
                              <Tooltip
                                placement="bottomRight"
                                title={
                                  "It is the total weight of the orders that have quantity in weight and processed weight of the orders that have quantity in number of reels"
                                }
                                className="edit-tooltip"
                                getPopupContainer={(triggerNode) => triggerNode}
                              >
                                <span className="infoIcon"></span>
                              </Tooltip>
                            </Styled>
                          </div>
                        </OrderSummary> */}

                  {loading ? (
                    <TableShimmer header={tab.header} scroll={2000} />
                  ) : orderRecords?.length && tab.state === orderState ? (
                    <div>
                      <Table
                        columns={tab.header}
                        dataSource={orderRecords}
                        onChange={onChange}
                        expandable={
                          rerenderInnerTable
                            ? {
                                expandedRowRender,
                                defaultExpandedRowKeys: ["0"],
                                rowExpandable,
                                onExpand,
                                expandedRowKeys: rerenderInnerTable ? [] : null,
                              }
                            : null
                        }
                        // pageSize={3}
                        pagination={{
                          current: currentPage,
                          total: totalRecords,
                          showTitle: false,
                          pageSize: paginationRef.current.size,
                          showTotal: (total, range) =>
                            `Showing ${range[0]}-${range[1]} of ${total} results`,
                          pageSizeOptions: [10, 20, 50, 100],
                          showSizeChanger: true,
                          // locale: { items_per_page: "" },
                        }}
                        scroll={{ x: "max-content" }}
                        sticky={{
                          offsetHeader: stickyOffsets.table,
                          getContainer: () => {
                            let node = document.getElementById('right-layout-container');
                            while (node && node !== document.body) {
                              const style = window.getComputedStyle(node);
                              if (style.overflowY === 'auto' || style.overflowY === 'scroll') return node;
                              node = node.parentNode;
                            }
                            return window;
                          }
                        }}
                        // scroll={{x:3000}}
                        //rowClassName={(record,index) => record.priority && "true"}
                        //  { getRow(record,index)}}
                        rowClassName={getRow}
                        // locale={{
                        //   emptyText: loading ? orderRecordss.map(u => <Skeleton.Input height={50} style={{marginTop: '10px', width:'100%'}} active={true} />): <Empty />
                        // }}
                      />
                    </div>
                  ) : (
                    <EmptyState
                      img={
                        emptyStateLabel === "noData" ||
                        emptyStateLabel === "filter"
                          ? emptyState_NoData
                          : emptyStateLabel === "search"
                          ? emptyState_Search
                          : emptyState_ConnectionAPIError
                      }
                      heading={emptyStatePropsData.heading}
                      subHeading={emptyStatePropsData.subHeading}
                      label={emptyStatePropsData.label}
                      refresh={refresh}
                    />
                  )}
                </div>
              </TableLayoutData>
            </Panes>
          ))}
        </Tabs>
      </StyledTab>
      {/* </div>
        </TableLayoutData> */}

      {/* Toasters */}

      {visibleToaster && !actionToaster.error && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg={actionToaster.msg}
        />
      )}
      {visibleToaster && actionToaster.error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={actionToaster.msg}
        />
      )}
      {/* {NewGradeSideDrawer && (
          <EditNewOrderDrawer
            visible={NewGradeSideDrawer}
            onClose={onCloseNewGrade}
            onCloseGrade={onCloseFullNewGrade}
            onShowPo={goToPOPage}
            setDrawer={setNewGradeSideDrawer}
            selectedOrderNo={selectedOrder?.orderno}
            selectedState={selectedOrder?.status}
            selectedOrder={selectedOrder}
            rendering={setRendering}
            toasterAction={setActionToaster}
            showToaster={showToaster}
            roles={userDetails?.roles.order_records}
            handleCancel={handleCancel}
            handleRestore={handleRestore}
            setMergeSideDrawer={onMergeOrderHandler}
            pageType = {"orderRecord"}
            defaultActiveKey={defaultActiveKey}
            defaultOrderState={orderState}
          ></EditNewOrderDrawer>
        )} */}

      {NewGradeSideDrawer && (
        <MultiDiaEditOrderDrawer
          visible={NewGradeSideDrawer}
          onClose={onCloseNewGrade}
          onCloseGrade={onCloseFullNewGrade}
          onShowPo={goToPOPage}
          setDrawer={setNewGradeSideDrawer}
          selectedOrderNo={selectedOrder?.orderno}
          selectedState={selectedOrder?.status}
          selectedOrder={selectedOrder}
          rendering={setRendering}
          toasterAction={setActionToaster}
          showToaster={showToaster}
          roles={userDetails?.roles.order_records}
          handleCancel={handleCancel}
          handleRestore={handleRestore}
          setMergeSideDrawer={onMergeOrderHandler}
          handleViewProdDrawer={handleViewProdDetailsAction}
          handleViewProcessedQtyDrawer={handleViewProcessedQtyDetails}
          handleViewPendingQtyDrawer={handleViewPendingQtyDetails}
          handleSplitDrawer={showNewSplitOrderDrawer}
          handleHold={handleHold}
          handleCancelQuantity={handleCancelledQuantityAction}
          pageType={"orderRecord"}
          defaultActiveKey={defaultActiveKey}
          defaultOrderState={orderState}
          actionType="view"
          type="orderRecord"
          id={userDetails.id}
          category={selectedOrder?.category.toLowerCase()}
        ></MultiDiaEditOrderDrawer>
      )}

      {cancelQuantitySideDrawer && (
        <CancelQuantityDrawer
          visible={cancelQuantitySideDrawer}
          selectedOrderNo={selectedOrder?.orderno}
          onClose={handleCancelQuantityDrawerClose}
          toasterAction={setActionToaster}
          showToaster={showToaster}
          rendering={setRendering}
        ></CancelQuantityDrawer>
      )}

      {productionDetailsSideDrawer && (
        <ProductionDetailsDrawer
          visible={productionDetailsSideDrawer}
          onCloseGrade={onCloseFullNewGrade}
          selectedOrderNo={selectedOrder?.orderno}
          handleCancel={onCloseFullNewGrade}
          category={selectedOrder?.category}
        ></ProductionDetailsDrawer>
      )}

      {processedQtyDetailsSideDrawer && (
        <ViewProcessedQuantityDrawer
          visible={processedQtyDetailsSideDrawer}
          onCloseGrade={onCloseFullNewGrade}
          selectedOrderNo={selectedOrder?.orderno}
          handleCancel={onCloseFullNewGrade}
          category={selectedOrder?.category}
        ></ViewProcessedQuantityDrawer>
      )}

      {pendingQtyDetailsSideDrawer && (
        <ViewPendingQuantityDrawer
          visible={pendingQtyDetailsSideDrawer}
          onCloseGrade={onCloseFullNewGrade}
          selectedOrderNo={selectedOrder?.orderno}
          handleCancel={onCloseFullNewGrade}
          category={selectedOrder?.category}
        ></ViewPendingQuantityDrawer>
      )}

      {mergeSideDrawer && (
        <MergeDrawer
          visible={mergeSideDrawer}
          handleMergeDrawerClose={handleMergeDrawerClose}
          parent={selectedOrder?.parent}
          other_parents={selectedOrder?.other_parents}
          orderDetails={selectedOrder ? selectedOrder : {}}
          toasterAction={setActionToaster}
          showToaster={showToaster}
          rendering={setRendering}
        ></MergeDrawer>
      )}

      {/* {resendApprovalData && (
          <ResendApprovalData
            visible={resendApprovalData}
            onClose={onCloseNewGrade}
            onCloseGrade={onCloseFullNewGrade}
            selectedOrderNo={selectedOrder?.orderno}
            selectedState={selectedOrder?.status}
            rendering={setRendering}
            toasterAction={setActionToaster}
            showToaster={showToaster}
            isEditFromIncompleteOrder={
              selectedOrder?.status == "Approved" ? true : false
            }
            type="orderRecord"
          ></ResendApprovalData>
        )} */}

      {resendApprovalData && (
        <MultiDiaEditOrderDrawer
          visible={resendApprovalData}
          onClose={onCloseNewGrade}
          onCloseGrade={onCloseFullNewGrade}
          selectedOrderNo={selectedOrder?.orderno}
          selectedState={selectedOrder?.status}
          rendering={setRendering}
          toasterAction={setActionToaster}
          showToaster={showToaster}
          isEditFromIncompleteOrder={
            (selectedOrder?.status == "Approved" || selectedOrder?.status == "Active") ? true : false
          }
          type="orderRecord"
          isRestore={isRestore}
          category={selectedOrder?.category.toLowerCase()}
          selectedOrder={selectedOrder}
        ></MultiDiaEditOrderDrawer>
      )}

      {holdOrders && (
        <ActionDrawer
          type={"cancel"}
          visible={holdOrders}
          onClose={onCloseActionDrawer}
          onCloseGrade={onCloseActionDrawer}
          orderNo={selectedOrder?.orderno}
          reFetch={setRendering}
          setActionResponse={setActionToaster}
          showToaster={showToaster}
        >
          <h5>Reason for Cancellation</h5>
          <p>Please specify the reason for cancellation</p>
        </ActionDrawer>
      )}

      {holdOrderDrawer && (
        <ActionDrawer
          type={"hold"}
          visible={holdOrderDrawer}
          onClose={onCloseActionDrawer}
          onCloseGrade={onCloseActionDrawer}
          orderNo={selectedOrder?.orderno}
          reFetch={setRendering}
          setActionResponse={setActionToaster}
          showToaster={showToaster}
        >
          <h5>Reason for holding the order</h5>
          <p>Please specify the reason</p>
        </ActionDrawer>
      )}

      {splitOrderSideDrawer && (
        <SplitOrderDrawer
          visible={splitOrderSideDrawer}
          onClose={onCloseNewGrade}
          onCloseGrade={onCloseFullNewGrade}
          onShowPo={goToPOPage}
          setDrawer={setSplitOrderSideDrawer}
          selectedOrderNo={selectedOrder?.orderno}
          selectedProduct={selectedOrder?.productcode}
          selectedState={selectedOrder?.status}
          selectedCustomerCode={selectedOrder?.customercode}
          rendering={setRendering}
          toasterAction={setActionToaster}
          showToaster={showToaster}
          roles={userDetails?.roles.order_records}
        ></SplitOrderDrawer>
      )}
      <ConfirmationModal
        visible={isVisiblePriorityModal}
        icon={warning}
        param={selectedOrder}
        confirmAction={priorityModalConfirm}
        cancelAction={priorityModalClose}
      >
        <span>
          {selectedOrder?.priority ? "Remove priority?" : "Prioritize Order?"}
        </span>
        <p>
          {selectedOrder?.priority
            ? "The order will be treated as a regular order. Are you sure you want to continue?"
            : "The order will be upgraded to a prioritized order and will be completely matched in deckle. Are you sure you want to proceed?"}
        </p>
      </ConfirmationModal>

      <ConfirmationModal
        visible={isVisibleReleaseModal}
        icon={warning}
        param={selectedOrder}
        confirmAction={releaseModalConfirm}
        cancelAction={releaseModalClose}
      >
        <span> {"Release order for production?"} </span>
        <p>
          {
            "The order will be matched in next deckle. Are you sure you want to proceed?"
          }
        </p>
      </ConfirmationModal>

      {/* Delete confirmation modal */}
      <ModalPopup visible={isVisibleDeleteModal}>
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Delete Order?</span>
          <p>
            You will not be able to recover the order if you delete it. Are you
            sure you want to proceed?
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => deleteModalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={() => deleteModalConfirm(selectedOrder?.orderno)}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>
      {cancelToaster && (
        <AlertContainer
          closeIcon={true}
          setClose={setCancelToaster}
          color={cancelToaster === "erp_err" ? "red toaster" : "green toaster"}
          icon={cancelToaster === "erp_err" ? alertRed : alertGreen}
          msg={cancelTosterMsg}
        >
          {setTimeout(() => setCancelToaster(false), 5000)}
        </AlertContainer>
      )}
    </RightLayoutContainer>
  );
};

export default OrderRecordsData;